import { SandboxView } from "./SandboxView.js";
import * as Card from "../public/icons/card.svg";
import * as Label from "../public/icons/label.svg";
import * as Photo from "../public/icons/photo.svg";
import * as FullScreen from "../public/icons/organigram-fullscreen.svg";
import * as Download from "../public/icons/organigram-download.svg";
import * as Comment from "../public/icons/organigram-comment.svg";
import { socket } from "./feathers-socketio.js";
import Utils from "./utility.js";
import TalentCardPreview from "@/views/org-dashboard/talent-pool/components/TalentCardPreview.vue";
import Vue from 'vue'; 

const AIGenerateIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiM2YjcyODciPjxwYXRoIGQ9Ik00MDAtMTIwdi04MGgtODB2LTgwaDgwdi04MGg4MHY4MGg4MHY4MGgtODB2ODBoLTgwWm0xMjAtMjQwLTgwLTE2MC0xNjAtODAgMTYwLTgwIDgwLTE2MCA4MCAxNjAgMTYwIDgwLTE2MCA4MC04MCAxNjBaTTEyMC02ODBsLTQwLTgwLTgwLTQwIDgwLTQwIDQwLTgwIDQwIDgwIDgwIDQwLTgwIDQwLTQwIDgwWiIvPjwvc3ZnPg==";

const OrangeSpinnerIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZjk4MDAiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cGF0aCBkPSJNMjEgMTJhOSA5IDAgMSAxLTYuMjE5LTguNTYiLz48L3N2Zz4=";

const API_BASE_URL = process.env.VUE_APP_API_URL;
const _totalEvaluation = {
    _total : 0,
    get total(){
        return this._total;
    },
    set total(val){
        this._total = val;
    }
}
const _calculateEvaluation = {
    _total : 0,
    get total(){
        return this._total;
    },
    set total(val){
        this._total = val;
    }
}
const isViewportActive = {
    isActive : true,
    get status(){
        return this.isActive;
    },
    set status(value){
        this.isActive = value;
    }
}

// Helper function to safely get graphData as array
const safeGraphData = (config) => {
    const graphData = config?.data?.graphData;
    return Array.isArray(graphData) ? graphData : [];
};

export class OrganiGram {
    constructor(e, t) {
        this.counter = 0;
        this.activeAiTasks = new Map();

        // --- 1. DEFINE THE FUNCTION FIRST ---
        const injectStyles = (styleId, css) => {
            if (document.getElementById(styleId)) {
                return; 
            }
            const styleSheet = document.createElement("style");
            styleSheet.id = styleId; 
            styleSheet.innerText = css;
            document.head.appendChild(styleSheet);
        };

        // --- 2. DEFINE THE CSS STRINGS ---
        const aiLoaderCSS = `
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            .ai-icon-loading {
                animation: spin 1s linear infinite;
            }
        `;

        const hoverStyles = `
            .node-action-icon {
                opacity: 0;
                visibility: hidden; 
                transition: all 0.2s ease-in-out;
            }
            .node-hover-target:hover .node-action-icon {
                opacity: 1;
                visibility: visible;
            }
        `;
        
        const dndStyles = `
            .is-dragging {
                opacity: 0.4;
                border: 2px dashed #999 !important;
            }
            .drag-over-active {
                background-color: #e6fffa !important;
                box-shadow: 0 0 15px rgba(0, 200, 0, 0.5) !important;
                transform: scale(1.05);
                border: 2px solid #00b894 !important;
                z-index: 100;
                transition: all 0.2s ease;
            }
        `;

        const fullscreenFixStyles = `
            *:fullscreen > .chartCanvasContainer {
                height: 100% !important;
                min-height: 100% !important;
            }
        `;

        const ribbonCSS = `
    @keyframes ribbon-spin { to { transform: rotate(360deg); } }
    .ribbon-spinner { width: 18px; height: 18px; border: 2px solid rgba(0, 0, 0, 0.1); border-radius: 50%; border-top-color: #FFC107; animation: ribbon-spin 1s linear infinite; }
    .resume-external-ribbon { 
        background: #fff; 
        border: 1px solid #E5E7EB; 
        border-radius: 12px; 
        padding: 12px 16px; 
        margin: 15px 20px; 
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        position: relative; 
        z-index: 9999;
        display: none;
    }
        .resume-external-ribbon { 
        background: #fff; 
        border: 1px solid #E5E7EB; 
        border-radius: 12px; 
        padding: 12px 16px; 
        margin: 15px 20px; 
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        position: relative; 
        z-index: 1000;
        display: none;
        transition: opacity 0.3s ease; /* Add this */
    }
    .ribbon-progress-track { width: 100%; height: 6px; background: #F3F4F6; border-radius: 3px; margin-top: 10px; overflow: hidden; }
    .ribbon-progress-fill { height: 100%; transition: width 0.4s ease; }
`;
        const kvdrBtnStyles = `
        .kvdrNodeBtnBox {
            transition: transform 0.2s ease, opacity 0.2s ease;
        }
        .kvdrNodeBtnBox i {
            /* Prevents the tooltip from flickering */
            display: block; 
            padding: 2px;
        }
        .kvdrNodeBtnBox:hover {
            transform: scale(1.15); /* Slight pop effect when hovering the icon */
        }
    `;
    const textareaFixCSS = `
            .invisible-scroll-y::-webkit-scrollbar {
                display: none;
            }
        `;
        injectStyles('organigram-textarea-fix', textareaFixCSS);
        injectStyles('organigram-ai-styles', aiLoaderCSS);
        injectStyles('organigram-kvdr-styles', kvdrBtnStyles); // <--- Add this line
        injectStyles('organigram-dnd-styles', dndStyles);
        injectStyles('organigram-hover-styles', hoverStyles);
        injectStyles('organigram-fullscreen-fix', fullscreenFixStyles);
        injectStyles('organigram-ribbon-styles', ribbonCSS); 

        const a = {
            id: "",
            data: { id: "", name: "", positionName: "", imageUrl: "", parentId: "" },
            candidateList: { id: "", name: "", positionName: "", imageUrl: "", parent: "" },
            root: { id: "", name: "ROOT", image: "" },
            container: "body",
            type: "lable",
            user: {},
            skills: [],
            softSkills: [],
            role: 2,
            collapsed: !0,
            displaySettings: { cardColor: "#F2C244", textColor: "#666" },
            searchContainer: "",
            displayType: ["card", "image", "label"],
            onNodeClick: async (e) => { return e; },
            onNodeDelClick: function ([e]) { return e; },
            onNodeAddProfileClick: function (e) { return e; },
            onNodeRemoveProfileClick: function (e) { return e; },
            onNodeFetch: function (e) { return e; },
            onNodeUpdate: function (e) { return e; },
            onNodeProfileUpdate : async (e) => { return e; },
            onNodeProfileFetch :  async (e) => { return e; },
        };
        this.config = () => a;
        this.key = e;
        this.chart = t;
        this.role = () => a.role;
        this.skills = a.skills;
        this.softSkills = a.softSkills;
        this.user = a.user;
        let permissions = {};
        const setPermissions = () => {
            const map = {
                0: { addRole: false, delRole: false, editTitle: false, addProfile: false, delProfile: false, expandRole: false, addRoleRequest: true },
                1: { addRole: false, delRole: false, editTitle: false, addProfile: true, delProfile: true, expandRole: true, addRoleRequest: true },
                2: { addRole: true, delRole: true, editTitle: true, addProfile: true, delProfile: true, expandRole: true, addRoleRequest: false },
            };
            permissions = map[this.role()] || {};
        };
        Object.keys(a).forEach((e) => {
            this[e] = function (t) {
                if (e === "role" && arguments.length) {
                    a[e] = t;
                    setPermissions(); // auto-update
                    return this;
                }
                return arguments.length ? ((a[e] = t), this) : a[e];
            };
        });
        setPermissions();
        this.can = (perm) => !!permissions[perm];
        this.listenersAdded = false;
        if (!this.listenersAdded) {
            // 1. Add Error Handling
            socket.on('connect_error', (err) => {
                console.warn("Socket connection failed, falling back to manual polling...");
                // If socket fails, trigger a one-time fetch to ensure data is current
                this.startAutoNotificationRefresh();
            });

            const events = [
                'kvdr-role-created',
                'kvdr-role-patched',
                'kvdr-role-removed',
                'kvdr-role-profile-created',
                'kvdr-role-profile-patched',
                'kvdr-role-profile-removed'
            ];

            events.forEach(eventName => {
                // Listen for ANY change event to keep chart in sync
                socket.on(eventName, data => {
                    console.log(`Real-time update received: ${eventName}`);
                    this.startAutoNotificationRefresh();
                });
            });

            this.listenersAdded = true;
        }
        this.activePollers = new Map(); 
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.startSmartPolling(entry.target);
                } else {
                    this.stopSmartPolling(entry.target);
                }
            });
        }, { threshold: 0.1 }); 
        this.setupRealtimeFallback();

        // --- NEW: Initialize Remote Config Caching ---
        this.cachedOrgConfig = null;
        this.isFetchingConfig = false;
        this.fetchOrgConfig(); 
    }

    // --- NEW METHOD: Fetch live settings from the API ---
    async fetchOrgConfig() {
        if (this.isFetchingConfig) return;
        
        const orgId = this.getActualOrgId();
        if (!orgId || orgId === 'undefined') return;

        const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
        if (!token) return;

        this.isFetchingConfig = true;
        try {
            // Safely grab API URL
            let baseUrl = 'https://api.getboarded.tech';
            if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_API_URL && process.env.VUE_APP_API_URL !== 'undefined') {
                baseUrl = process.env.VUE_APP_API_URL.replace(/\/$/, '');
            }
            
            // FeathersJS strictly rejects unknown query params.
            // We use native Feathers sorting to get the latest record and headers for cache bypassing.
            const url = `${baseUrl}/kvdr-org-config?orgId=${orgId}&$sort[createdAt]=-1&$limit=1`;
            
            const response = await fetch(url, {
                headers: { 
                    'Authorization': `Bearer ${token}`, 
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                }
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`API Error ${response.status}: ${errorText}`);
            }
            
            const json = await response.json();
            
            // Map the successful response directly to the active cache
            if (json.data && json.data.length > 0) {
                this.cachedOrgConfig = json.data[0];
            } else if (Array.isArray(json) && json.length > 0) {
                this.cachedOrgConfig = json[0];
            }
        } catch (err) {
            console.error("Error fetching remote KVDR config:", err.message);
        } finally {
            this.isFetchingConfig = false;
        }
    }
        setupRealtimeFallback() {
        // Check for updates every 20 seconds as a fallback for the broken WebSocket
        setInterval(() => {
            // Since your console shows the socket is failing, socket.connected will be false.
            // This will force the app to fetch data manually via standard HTTP.
            if (!socket.connected) {
                console.log("WebSocket inactive: Performing manual background refresh...");
                this.startAutoNotificationRefresh();
                
                // Also refresh any suggestion dots for roles currently visible on screen
                this.activePollers.forEach((timer, element) => {
                    this.startSmartPolling(element);
                });
            }
        }, 20000);
    }
    triggerAiEvaluation = async (orgId, roleId, emails, userList, btn) => {
        try {
            const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
            const response = await fetch(`${API_BASE_URL}/api/talent-pool/re-evaluate-candidates`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ role_id: roleId, user_emails: emails, organization_id: orgId })
            });

            const result = await response.json();
            
            if (result.task_id) {
                // Store task AND the specific emails being processed
                this.activeAiTasks.set(roleId, { taskId: result.task_id, emails: emails });

                // UI Feedback for the current view
                if (btn) {
                    btn.disabled = true;
                    btn.style.opacity = '0.7';
                    btn.innerHTML = `<img src="${OrangeSpinnerIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" class="ai-icon-loading" />`;
                }

                if (userList) {
                    // Only disable checkboxes for the emails actually being evaluated
                    emails.forEach(email => {
                        const row = userList.querySelector(`li[data-email-key="${email.toLowerCase().trim()}"]`);
                        if (row) {
                            row.dataset.evalStatus = 'processing';
                            row.dataset.processing = "true";
                            const cb = row.querySelector('input[type="checkbox"]');
                            if (cb) cb.disabled = true;
                            const rowDiv = row.querySelector('.multi-select-box');
                            if (rowDiv) { rowDiv.style.opacity = "0.6"; rowDiv.style.pointerEvents = "none"; }
                            
                            const statusBox = row.querySelector('.ai-status-box');
                            if (statusBox) {
                                statusBox.innerHTML = `<img src="${OrangeSpinnerIcon}" style="width:20px; height:20px; animation:spin 1s linear infinite;" class="ai-icon-loading" />`;
                            }
                        }
                    });
                }
    
                this._startAiEvaluationPolling(orgId, result.task_id, userList, btn, roleId);
            }
        } catch (err) {
            console.error("AI Evaluation Trigger Error:", err);
            this.activeAiTasks.delete(roleId);
            this.refreshNotifications(); // Trigger UI cleanup
        }
    }

    _startAiEvaluationPolling = (orgId, taskId, userListContainer, aiEvalButton, roleId) => {
        const pollInterval = 3000;
        
        const poller = setInterval(async () => {
            try {
                const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                const response = await fetch(`${API_BASE_URL}/api/talent-pool/re-evaluate-status/${orgId}/${taskId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Poll failed");

                const statusData = await response.json();
                
                // Update specific rows if the list is still in the DOM
                if (userListContainer && userListContainer.isConnected && statusData.users) {
                    Object.entries(statusData.users).forEach(([email, userData]) => {
                        const safeEmail = email.toLowerCase().trim();
                        const userRow = userListContainer.querySelector(`li[data-email-key="${safeEmail}"]`);
                        if (!userRow || userRow.dataset.evalStatus === userData.status) return;

                        if (userData.status === 'completed') {
                            userRow.dataset.evalStatus = 'completed'; 
                            // Rebuild the row with new AI data
                            if (typeof userRow.rebuildRow === 'function') {
                                userRow.rebuildRow({ ...userRow.candidateData, ...userData });
                            }
                        } else if (userData.status === 'failed') {
                            userRow.dataset.evalStatus = 'failed';
                            const sb = userRow.querySelector('.ai-status-box');
                            if (sb) sb.innerHTML = '<span title="Analysis Failed">⚠️</span>';
                        }
                    });
                }

                // Global Task Completion
                if (statusData.status === 'completed' || statusData.status === 'failed') {
                    clearInterval(poller);
                    this.activeAiTasks.delete(roleId);
                    
                    // If the popup is still open, reset the buttons/checkboxes
                    if (userListContainer && userListContainer.isConnected) {
                        if (aiEvalButton) {
                            aiEvalButton.disabled = false;
                            aiEvalButton.style.opacity = '1';
                            aiEvalButton.innerHTML = `<img src="${AIGenerateIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" />`;
                        }
                        userListContainer.querySelectorAll('li[data-processing="true"]').forEach(li => {
                            delete li.dataset.processing;
                            delete li.dataset.evalStatus;
                            const cb = li.querySelector('input[type="checkbox"]');
                            if (cb) cb.disabled = false;
                            const rb = li.querySelector('.multi-select-box');
                            if (rb) { rb.style.opacity = '1'; rb.style.pointerEvents = 'auto'; }
                        });
                    }
                }
            } catch (error) {
                console.error("Polling Error:", error);
                clearInterval(poller);
                this.activeAiTasks.delete(roleId);
            }
        }, pollInterval);
    }

    startSmartPolling(element) {
        if (this.activePollers.has(element)) return;

        const { roleId } = element.dataset;
        const orgId = this.getActualOrgId(); // FIX: Fetch the true Org ID dynamically, not from dataset
        const dot = element.querySelector('.suggestionDot'); 
        
        const poll = () => {
            if (!document.body.contains(element)) {
                this.stopSmartPolling(element);
                return;
            }

            // FIX: Using the correct orgId 
            fetch(`${API_BASE_URL}/api/talent-pool/suggestions/${orgId}/${roleId}?t=${Date.now()}`)
                .then(res => res.json())
                .then(response => {
                    const suggestions = response.data || response || [];
                    // Only show the red dot for actual positive matches, ignore rejected ones
                    const validMatches = Array.isArray(suggestions) ? suggestions.filter(c => c.status !== 'rejected') : [];
                    
                    if (validMatches.length > 0) {
                        if(dot) {
                            dot.style.display = "block";
                            dot.title = `${validMatches.length} new match(es)`;
                        }
                    } else {
                        if(dot) dot.style.display = "none";
                    }
                })
                .catch(() => {}) 
                .finally(() => {
                    if (this.activePollers.has(element)) {
                        const timerId = setTimeout(poll, 15000);
                        this.activePollers.set(element, timerId); 
                    }
                });
        };

        poll();
        this.activePollers.set(element, true);
    }
    stopSmartPolling(element) {
        const timerId = this.activePollers.get(element);
        if (timerId && typeof timerId !== 'boolean') {
            clearTimeout(timerId); 
        }
        this.activePollers.delete(element); 
    }
    createChartGroupBy(e) {
        document.querySelector("#" + e.container).innerHTML = "";
        var t = e.data.length;
        let a,
            r = e.data;
        const s = Utils.createElem("div", ["chartCanvasControlls"], "chart-canvas-controlls");
        s.style.cssText = "display:flex;align-items:center;flex-wrap: wrap;border: 1px solid #e5e5e7;border-left:none;border-right:none;background:#FFF;";
        const o = Utils.createElem("div", ["chartCanvasContainer"], "chart-canvas-container"),
            n = Utils.createElem("div", ["chart-canvas"], "chart-canvas");
        o.append(n), document.querySelector("#" + e.container).appendChild(s), document.querySelector("#" + e.container).appendChild(o);
        const i = Utils.createElem("datalist", "", "allUserList");
        n.append(i);
        for (let s = 0; s < t; s++) {
            const t = Utils.createElem("option", "", "opt_" + r[s].id, r[s].name);
            i.append(t);
            const o = Utils.createElem("div", ["member"], r[s].id, "");
            if (
                (Object.keys(r[s]).forEach((t) => {
                    "parentId" == t ? o.setAttribute("data-parentid", (r[s][t] && null != r[s][t] && "" != r[s][t]) || e.root.id === r[s].id ? r[s][t] : e.root.id) : o.setAttribute("data-" + t, r[s][t]),
                        (o.style.color = e.displaySettings.cardColor);
                }),
                o.setAttribute("data-empid", r[s].id),
                "card" === e.type)
            )
                a =
                    '<label class="emptitle" draggable=true><fieldset style="background-color:' +
                    e.displaySettings.cardColor +
                    ";color:" +
                    e.displaySettings.textColor +
                    ";border-color:" +
                    e.displaySettings.borderColor +
                    '" class="userCard onlyCardType"><div class="userImg onlyImgType"><img src="' +
                    r[s].imageUrl +
                    '"  draggable=false/></div><label class="onlyLblType">' +
                    r[s].name +
                    '<br><span class="text-sm">' +
                    r[s].positionName +
                    "</span></label></fieldset></label>";
            else if ("image" === e.type)
                a =
                    '<label class="emptitle" draggable=true><fieldset style="background-color:' +
                    e.displaySettings.cardColor +
                    ";color:" +
                    e.displaySettings.textColor +
                    ";border-color:" +
                    e.displaySettings.borderColor +
                    '" class="userCard onlyCardType"><div class="userImg onlyImgType"><img src="' +
                    r[s].imageUrl +
                    '" name="' +
                    r[s].name +
                    '" alt="' +
                    r[s].name +
                    '" title="' +
                    r[s].name +
                    r[s].positionName +
                    '"  draggable=false/></div></fieldset></label>';
            else {
                let t = "";
                Object.keys(r[s]).forEach((e) => {
                    t += '<div class="flex flex-row padd-1 space-between border-bottom"><span class="d-block text-left mr-10">' + e + '</span><span class="d-block text-right ml-10">' + r[s][e] + "</span></div>";
                }),
                    (a =
                        '<label class="emptitle" draggable=true><fieldset style="background-color:' +
                        e.displaySettings.cardColor +
                        ";color:" +
                        e.displaySettings.textColor +
                        ";border-color:" +
                        e.displaySettings.borderColor +
                        '" class="userCard onlyCardType"><label class="onlyLblType">' +
                        r[s].name +
                        '<br><span class="text-sm">' +
                        r[s].positionName +
                        '</span></label><div class="member_detail_panel">' +
                        t +
                        "</div></fieldset></label>");
            }
            (o.innerHTML = a), n.appendChild(o);
        }
        const l = Utils.createElem("div", ["member","unorganized"], "", "");
        l.dataset.name = "unorganized";
        const d =
            '<label class="emptitle"><fieldset style="background-color:' +
            e.displaySettings.cardColor +
            ";color:" +
            e.displaySettings.textColor +
            ";border-color:" +
            e.displaySettings.borderColor +
            '" class="userCard onlyCardType"><label class="onlyLblType">Unorganized</label></fieldset></label>';
        (l.innerHTML = d), n.appendChild(l);
        let c = 0;
        document.querySelectorAll("div.member").forEach(function (t, a, r) {
            let s = t.dataset.empid,
                o = document.querySelectorAll("[data-parentid='" + s + "']");
            (t.dataset.relationcount = o.length), 0 !== o.length && null !== o.length && "" !== o.length && o.length > 0 ? (t.dataset.relation = t.dataset.relation) : (t.dataset.relation = "");
            const i = Utils.createElem("a", ["toggleBtn"], "", o.length);
            t.childNodes[0].append(i),
                0 !== o.length ? (t.childNodes[0].lastChild.style.display = "inline-block") : (t.childNodes[0].lastChild.style.display = "none"),
                o.forEach(function (e) {
                    try {
                        t.parentNode !== e
                            ? document.querySelector("[data-empid='" + s + "']").append(e)
                            : (n.innerHTML = "<p>This filter have some bidirectional relation. To create hierarchy view remove those relations or try another filter.</p>");
                    } catch (e) {
                        console.log(`${e}`);
                    }
                });
            let l = document.querySelector("div#chart-canvas > div.unorganized");
            if (((null != t.dataset.parentid && "" != t.dataset.parentid) || 0 != t.querySelectorAll("div.member").length || ((t.style.display = "none"), l.append(t), c++), c > 0 && a == r.length - 1)) {
                const e = Utils.createElem("a", ["toggleBtn"], "", c);
                l.childNodes[0].append(e);
            }
            if (e.collapsed) {
                (t.style.display = "none"), (document.querySelector("div#" + e.container + "> div#chart-canvas > div.member").style.display = "inline-block");
                const a = document.querySelector("div#chart-canvas > div.member").childNodes;
                Array.from(a).forEach((e) => {
                    e.style.display = "inline-block";
                });
            }
        }),
            document.querySelectorAll(".toggleBtn").forEach(function (e) {
                (e.style.marginLeft = -e.offsetWidth / 2 + "px"),
                    e.addEventListener("click", function (e) {
                        e.preventDefault(), e.stopPropagation();
                        let t = e.target.parentElement.parentElement.childNodes;
                        Array.from(t).forEach(function (e) {
                            "inline-block" == e.style.display || "" == e.style.display ? (e.style.display = "none") : (e.style.display = "inline-block");
                        });
                    });
            }),
            Utils.toggleFullScreen(s.id, e.container),
            Utils.toggleZoomScreen(o,n,s),
            Utils.moveViewport(o,n,{isActive:true});
            this.createSwitchDisplayButtons(s.id, e.displayType, e),
            this.downloadOrganiGram(s.id),
            this.createSearchMemberBox(null !== e.searchContainer ? e.searchContainer : s.id, i.id);
    }
    createSwitchDisplayButtons(e, t, a) {
        let r = a.type;
        const s = Utils.createElem("div", ["switchBtnBox"], "", "");
        Array.from(t).forEach((e, t) => {
            const o = Utils.createElem("img", ["switchBtnLblIcon"], "", "");
            o.setAttribute("src", "image" == e ? Photo : "card" == e ? Card : Label),
                o.setAttribute("title", e),
                o.setAttribute("alt", e),
                (o.style.width = "25px"),
                (r === e || ("photo" == r && "image" == e)) && (o.style.background = a.displaySettings.cardColor),
                (o.htmlFor = t + "_" + e);
            const n = Utils.createElem("label", ["switchBtnLbl"], "", "");
            n.htmlFor = t + "_" + e;
            const i = Utils.createElem("input", ["switchBtn"], t + "_" + e, e);
            (i.type = "radio"), i.setAttribute("name", "switchBtnGrp"), i.setAttribute("value", e), (i.style.display = "none"), a.type == e && i.setAttribute("checked", !0), n.append(o, i), s.append(n);
        });
        let o = document.querySelector("#" + e);
        o.append(s);
        let n = o.querySelectorAll(".switchBtn");
        Array.from(n).forEach((e) => {
            e.addEventListener("click", function () {
                (a.type = this.value), r !== a.type && OrganiGram.prototype.createChartGroupBy(a);
            });
        });
    }
    // _createLevelDropdown = (levels, currentValue) => {
    //     // Wrapper for styling
    //     const dropdownWrapper = Utils.createElem('div');
    //     Utils.applyStyles(dropdownWrapper, {
    //         position: 'relative',
    //         display: 'inline-flex',
    //         alignItems: 'center',
    //         marginLeft: '15px',
    //         flexShrink: 0
    //     });

    //     // The actual select element
    //     const select = Utils.createElem('select', ['role-level-dropdown']);
    //     Utils.applyStyles(select, {
    //         fontFamily: 'inherit',
    //         fontSize: '14px',
    //         fontWeight: '600',
    //         color: '#4B5563',
    //         background: '#F3F4F6',
    //         border: '1px solid #E5E7EB',
    //         borderRadius: '8px',
    //         padding: '8px 30px 8px 12px',
    //         cursor: 'pointer',
    //         appearance: 'none', /* Disables default browser arrow */
    //         '-webkit-appearance': 'none',
    //         '-moz-appearance': 'none',
    //         outline: 'none',
    //         transition: 'border-color 0.2s ease',
    //     });
    //     select.onfocus = () => { select.style.borderColor = '#F2C244'; };
    //     select.onblur = () => { select.style.borderColor = '#E5E7EB'; };

    //     // Create and add options
    //     if (Array.isArray(levels) && levels.length > 0) {
    //         // Add a default, non-selectable placeholder
    //         const placeholder = Utils.createElem('option', [], '', 'Select Level');
    //         placeholder.value = "";
    //         if (!currentValue) {
    //             placeholder.selected = true;
    //         }
    //         placeholder.disabled = true;
    //         select.append(placeholder);

    //         levels.forEach(level => {
    //             const option = Utils.createElem('option', [], '', level.label);
    //             option.value = level.label; // Use label as the value to be stored
    //             if (level.label === currentValue) {
    //                 option.selected = true;
    //             }
    //             select.append(option);
    //         });
    //     } else {
    //          const option = Utils.createElem('option', [], '', 'No Levels Configured');
    //          option.value = "";
    //          option.disabled = true;
    //          select.append(option);
    //     }

    //     // Custom dropdown arrow
    //     const arrow = Utils.createElem('div');
    //     arrow.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>`;
    //     Utils.applyStyles(arrow, {
    //         position: 'absolute',
    //         right: '10px',
    //         pointerEvents: 'none',
    //         color: '#9CA3AF'
    //     });
        
    //     dropdownWrapper.append(select, arrow);
    //     return dropdownWrapper;
    // }
    downloadOrganiGram(e) {
        const t = Utils.createElem("img", ["_downloadOrganigramIcon"], "", "");
        t.setAttribute("src", Download), t.setAttribute("width", "100%"), t.setAttribute("height", "100%");
        const a = Utils.createElem("button", ["downloadOrganiGramBtn"], "", "");
        (a.style.cssText = "background:none;"),
            a.append(t),
            document.querySelector("#" + e).childNodes[0].append(a),
            a.addEventListener("click", function (e) {
                e.preventDefault(), e.stopPropagation();
                let t = document.querySelectorAll("div.member"),
                    a = [];
                t.forEach(function (e) {
                    let t = {},
                        r = e.dataset;
                    for (let e in r) t = { ...t, [e]: r[e] };
                    a.push(t);
                }),
                    Utils.JSONToCSV(a, "OrganiGram", !0);
            });
    }
    createSearchMemberBox(e, t) {
        const a = document.getElementById(e);
        let r;
        "input" == a.tagName.toLowerCase() || "select" == a.tagName.toLowerCase()
            ? (r = document.getElementById(e))
            : ((r = Utils.createElem("input", ["searchMemBox"], "search-mem-box", "")),
              r.setAttribute("Placeholder", "Search Here...."),
              (r.style.cssText = "\n                padding: 5px;\n                border: 1px solid #666;\n                border-radius: 3px;\n                font-family: inherit;\n                margin: 20px;"),
              document.querySelector("#" + e).prepend(r)),
            r.setAttribute("list", t),
            r.addEventListener("keyup", function () {
                let e = this.value;
                (e = e.toLowerCase()),
                    (e = e.replace(/\s+/g, "")),
                    "" !== e && null !== e
                        ? document.querySelectorAll("div.member").forEach(function (t) {
                              (t.style.display = "inline-block"), t.classList.add("fadeAway");
                              let a = t.dataset.name,
                                  r = t.dataset.id;
                              (a = a.toLowerCase()),
                                  (a = a.replace(/\s+/g, "")),
                                  e == a ? (t.classList.remove("fadeAway"), document.getElementById(r).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" }, !0)) : t.classList.add("fadeAway");
                          })
                        : document.querySelectorAll("div.member").forEach(function (e) {
                              e.classList.remove("fadeAway");
                          });
            });
    }
    attachTooltip = (element, text) => {
        if(!element) return;
        
        // Remove native title to prevent double tooltips
        element.removeAttribute("title");

        // Inject Styles (Dark, rounded, with arrow)
        if (!document.getElementById('organigram-custom-tooltip-style')) {
            const css = `
                .organigram-custom-tooltip {
                    position: fixed;
                    background: #1f1f1f; /* Dark background matching screenshot */
                    color: #fff;
                    padding: 6px 10px;
                    border-radius: 6px;
                    font-size: 12px;
                    font-family: inherit;
                    white-space: nowrap;
                    z-index: 1000000;
                    pointer-events: none;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                    opacity: 0;
                    animation: tooltipFadeIn 0.2s forwards;
                    transform: translateX(-50%);
                    margin-top: -8px; /* Offset from element */
                }
                .organigram-custom-tooltip::after {
                    content: '';
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    margin-left: -5px;
                    border-width: 5px;
                    border-style: solid;
                    border-color: #1f1f1f transparent transparent transparent;
                }
                @keyframes tooltipFadeIn { 
                    from { opacity: 0; transform: translateX(-50%) translateY(5px); } 
                    to { opacity: 1; transform: translateX(-50%) translateY(0); } 
                }
            `;
            const style = document.createElement('style');
            style.id = 'organigram-custom-tooltip-style';
            style.innerHTML = css;
            document.head.appendChild(style);
        }

        element.addEventListener('mouseenter', (e) => {
            const tip = document.createElement('div');
            tip.className = 'organigram-custom-tooltip';
            tip.innerText = text;
            document.body.appendChild(tip);
            
            const rect = element.getBoundingClientRect();
            const top = rect.top - tip.offsetHeight; 
            const left = rect.left + (rect.width / 2);
            
            tip.style.top = top + 'px';
            tip.style.left = left + 'px';
        });

        element.addEventListener('mouseleave', () => {
            document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());
        });
        
        element.addEventListener('click', () => {
            document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());
        });
    }

createKVDR = (config) => {
    if (!config.data || typeof config.data !== 'object') {
        console.warn("Invalid config.data, resetting to empty state");
        config.data = { graphData: [] };
    }
    if (!Array.isArray(config.data.graphData)) {
        console.warn("graphData not an array, initializing to empty array");
        config.data.graphData = [];
    }
    
    const container = document.querySelector(`#${config.container}`);
    container.innerHTML = ""; 
    this.initResumeProgressRibbon(container);

    if (new URLSearchParams(window.location.search).get('onboarding_active') === 'true') {
        const ribbon = Utils.createElem("div", ["onboarding-ribbon"]);
        Utils.applyStyles(ribbon, {
            width: "100%", backgroundColor: "#e3f2fd", color: "#0277bd", padding: "12px 24px",
            display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "14px",
            borderBottom: "1px solid #b3e5fc", fontFamily: "inherit", boxSizing: "border-box"
        });
        const leftContent = Utils.createElem("div");
        Utils.applyStyles(leftContent, { display: "flex", alignItems: "center", gap: "8px" });
        leftContent.innerHTML = `<span style="font-size:18px">ℹ️</span> <span><strong>Setup In Progress:</strong> You are on Step 1 of 4. Structure your organization below.</span>`;
        const rightAction = Utils.createElem("div");
        const continueLink = Utils.createElem("a", [], "", "Continue Setup →");
        Utils.applyStyles(continueLink, {
            fontWeight: "700", cursor: "pointer", textDecoration: "none", color: "#01579b",
            background: "rgba(255,255,255,0.4)", padding: "6px 16px", borderRadius: "6px",
            transition: "all 0.2s"
        });
        continueLink.addEventListener("mouseenter", () => continueLink.style.background = "rgba(255,255,255,0.8)");
        continueLink.addEventListener("mouseleave", () => continueLink.style.background = "rgba(255,255,255,0.4)");
        continueLink.addEventListener("click", () => {
            const pathParts = window.location.pathname.split('/');
            const slugIndex = pathParts.indexOf('organization') + 1;
            const slug = pathParts[slugIndex];
            if (slug) { localStorage.setItem(`onboardingStep_${slug}`, '2'); }
            const currentPath = window.location.pathname;
            const onboardingPath = currentPath.replace('/evaluate', '/onboarding');
            window.location.href = onboardingPath;
        });
        rightAction.append(continueLink);
        ribbon.append(leftContent, rightAction);
        container.append(ribbon);
    }
    
    const controls = Utils.createElem("div", ["chartCanvasControlls"], "chart-canvas-controlls");
    // const sandboxBtn = Utils.createElem("button", ["sandboxBtn"], "", "");
    // Utils.applyStyles(sandboxBtn, {
    //     width: "32px", height: "32px", margin: "0 8px", padding: "0", background: "transparent",
    //     border: "none", borderRadius: "50%", cursor: "pointer", color: "#FFC107", display: "flex",
    //     alignItems: "center", justifyContent: "center", position: "relative",
    //     transition: "background 0.2s ease, color 0.2s ease"
    // });
    // sandboxBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>`;
    // sandboxBtn.addEventListener("mouseenter", () => { sandboxBtn.style.background = "#FFC107"; sandboxBtn.style.color = "#fff"; });
    // sandboxBtn.addEventListener("mouseleave", () => { sandboxBtn.style.background = "transparent"; sandboxBtn.style.color = "#FFC107"; });
    // sandboxBtn.addEventListener("click", () => {
    //     let totalOrganizationHeadcount = 0;
    //     const getLiteGraphData = () => {
    //         return config.data.graphData.map(node => {
    //             let count = 0;
    //             if (Array.isArray(node.kvdrRoleProfiles)) { count = node.kvdrRoleProfiles.length; }
    //             else if (Array.isArray(node.profiles)) { count = node.profiles.length; }
    //             else if (node.dataset?.selectedUsr || node.selectedUsr) {
    //                 const rawIds = node.dataset?.selectedUsr || node.selectedUsr || "";
    //                 count = rawIds.split(',').filter(Boolean).length;
    //             }
    //             totalOrganizationHeadcount += count;
    //             return {
    //                 ...node, candidateCount: count, profiles: [], candidateList: [],
    //                 displaySettings: node.displaySettings || config.displaySettings || { cc: '#F59E0B', tc: '#fff', bc: '#e5e7eb' }
    //             };
    //         });
    //     };
    //     const liteGraphData = getLiteGraphData();
    //     const rootDataObj = {
    //         selfId: config.root.id, title: config.root.name, parentId: null,
    //         roleSummary: "Head of Organization", candidateCount: totalOrganizationHeadcount, profiles: [], isRoot: true
    //     };
    //     const fullDataSet = [rootDataObj, ...liteGraphData];
    //     const actionBridge = {
    //         onUpdate: async (nodeId, newData) => {
    //             try {
    //                 await config.onNodeUpdate({ query: nodeId, data: newData });
    //                 const graphDataArray = safeGraphData(config);
    //                 const localNode = graphDataArray.find(n => n && n.selfId === nodeId);
    //                 if (localNode) Object.assign(localNode, newData);
    //             } catch (err) { console.error(err); }
    //         },
    //         onDelete: async (nodeId) => {
    //             if (!confirm("Delete this role?")) return;
    //             try {
    //                 await config.onNodeDelClick([nodeId]);
    //                 const idx = safeGraphData(config).findIndex(n => n.selfId === nodeId);
    //                 if (idx > -1) config.data.graphData.splice(idx, 1);
    //                 const newData = [rootDataObj, ...getLiteGraphData()];
    //                 window.dispatchEvent(new CustomEvent('kvdr-sandbox-refresh', { detail: { graphData: newData } }));
    //             } catch (err) { console.error(err); }
    //         },
    //         onAdd: async (parentId) => {
    //             try {
    //                 const newNodeId = Utils.randomString(24);
    //                 const currentUser = (config.user && config.user._id) ? config.user._id : 'admin';
    //                 const validParentId = (parentId && parentId !== "0") ? String(parentId) : String(config.root.id);
    //                 const apiData = {
    //                     title: "New Role", roleSummary: "Description...", status: 'published',
    //                     requestedBy: currentUser, analyzedBy: currentUser, parentId: validParentId,
    //                     selfId: newNodeId, kvdrId: config.id, skills: [], softSkills: [],
    //                     description: [], profiles: [], kvdrRoleProfiles: [], candidateList: [],
    //                     displaySettings: config.displaySettings || { cc: '#F59E0B', tc: '#fff', bc: '#e5e7eb' }
    //                 };
    //                 await config.onNodeClick(apiData);
    //                 config.data.graphData.push(apiData);
    //                 const newData = [rootDataObj, ...getLiteGraphData()];
    //                 window.dispatchEvent(new CustomEvent('kvdr-sandbox-refresh', { detail: { graphData: newData } }));
    //             } catch (err) { console.error(err); }
    //         }
    //     };
    //     new SandboxView({
    //         container: config.container, data: fullDataSet, rootId: config.root.id, actions: actionBridge,
    //         displaySettings: config.displaySettings,
    //         onClose: () => {
    //             if (typeof this.toggleLoadingScreen === 'function') { this.toggleLoadingScreen(true, "Refreshing Workspace..."); }
    //             setTimeout(() => { window.location.reload(); }, 100);
    //         }
    //     });
    // });

    const refreshBtn = Utils.createElem("button", ["refreshBtn"], "", "");
    Utils.applyStyles(refreshBtn, {
        width: "32px", height: "32px", margin: "0 8px", padding: "0", background: "transparent",
        border: "none", borderRadius: "50%", cursor: "pointer", color: "#FFC107", display: "flex",
        alignItems: "center", justifyContent: "center", position: "relative",
        transition: "background 0.2s ease, color 0.2s ease"
    });
    
    // SVG matching the weight and style of your other Feather icons
    refreshBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path></svg>`;
    
    this.attachTooltip(refreshBtn, "Refresh Chart");

    refreshBtn.addEventListener("mouseenter", () => { refreshBtn.style.background = "#FFC107"; refreshBtn.style.color = "#fff"; });
    refreshBtn.addEventListener("mouseleave", () => { refreshBtn.style.background = "transparent"; refreshBtn.style.color = "#FFC107"; });
    
    refreshBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        this.toggleLoadingScreen(true, "Refreshing Chart Data...");
        try {
            // --- NEW: Fetch the latest evaluation metrics from the API first ---
            await this.fetchOrgConfig();

            const query = `kvdrId=${config.id}`;
            let response = await config.onNodeFetch(query);
            let freshData = (response && response.data) ? response.data : response;

            if (Array.isArray(freshData)) {
                // FIX: Map backend 'kvdrRoleProfiles' to 'profiles' so avatars render
                config.data.graphData = freshData.map(node => {
                    if (node.kvdrRoleProfiles && (!node.profiles || node.profiles.length === 0)) {
                        node.profiles = node.kvdrRoleProfiles;
                    }
                    return node;
                });

                // Re-render the chart with standardized data
                this.createKVDR(config);
            }
        } catch (err) {
            console.error("Refresh Error:", err);
        } finally {
            this.toggleLoadingScreen(false);
        }
    });

    controls.append(refreshBtn);
    controls.style.cssText = "display: flex; align-items: center; justify-content: flex-start; flex-wrap: wrap; border: 1px solid #e5e5e7;border-left:none;border-right:none;background:#FFF;";    
    
    // ---> ADD THIS: Hide Refresh & Sandbox for Users <---
    if (this.role() === 0) {
        refreshBtn.style.display = "none";
        // sandboxBtn.style.display = "none";
    }
    const canvasContainer = Utils.createElem("div", ["chartCanvasContainer"], "chart-canvas-container");
    
    Utils.applyStyles(canvasContainer, {
        display: "block", overflow: "hidden", width: "100%", height: "calc(100vh - 160px)",
        minHeight: "500px", background: "#FAFAFA", position: "relative"
    });

    if (!this.fullscreenListenerAdded) {
        const handleFullscreenChange = () => {
            const chartContainerNode = document.querySelector(`#${config.container} .chartCanvasContainer`);
            if (!chartContainerNode) return;

            const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;

            if (isFullscreen) {
                chartContainerNode.style.height = '100%';
                chartContainerNode.style.minHeight = '100%';
            } else {
                chartContainerNode.style.height = 'calc(100vh - 160px)';
                chartContainerNode.style.minHeight = '500px';
            }
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        this.fullscreenListenerAdded = true; 
    }

    const canvas = Utils.createElem("div", ["chart-canvas"], "chart-canvas");
    Utils.applyStyles(canvas, {
        display: "inline-block", textAlign: "center", minWidth: "100%", width: "max-content",
        padding: "50px", boxSizing: "border-box", whiteSpace: "nowrap", transformOrigin: "center top"
    });

    const overlay = Utils.createElem("div", ["backDropOverlay"], "back-drop-overlay");
    overlay.addEventListener("click", () => { overlay.innerHTML = ""; overlay.style.display = "none", isViewportActive.status = true })
    Utils.applyStyles(overlay, {
        background: "rgba(0,0,0,0.4)", position: "fixed", top: 0, left: 0, padding: "10px", overflow: "auto",
        right: 0, width: "100%", height: "100%", zIndex: 9999, display: "none"
    })
    canvasContainer.append(canvas, overlay);
    container.append(controls, canvasContainer);
    
    const rootNodeHtml = `
        <label class="emptitle" style="position:relative; overflow: visible !important;">
            <fieldset class="userCard onlyCardType root-card-drop-target node-hover-target" style="background-color: ${config.displaySettings.cardColor}; color: ${config.displaySettings.textColor}; border-color: ${config.displaySettings.borderColor}; position:relative; overflow: visible !important;">
                <label class="onlyLblType">
                    <div style="display: flex; align-items: center;">
                        <span>${config.root.name}</span>
                        <span class="selectedUsrBox" style="display: flex; margin: 10px 5px; align-items: center;">
                            <img class="selectedUsrImg" src="${config.root.image}" style="width: 32px; height: 32px; object-fit: cover; object-position: center; border: 2px solid; border-radius: 50%;">
                        </span>
                    </div>
                </label>
            </fieldset>
        </label>
    `;
    const rootNode = Utils.createElem("div", ["member", "root"], config.root.id, rootNodeHtml);
    const rootCard = rootNode.querySelector('.root-card-drop-target');
    
    if (this.can("editTitle")) {
        rootCard.addEventListener("dragover", (e) => {
            e.preventDefault();
            const draggedId = window.draggedNodeId;
            if (draggedId) rootCard.classList.add('drag-over-active');
        });
        rootCard.addEventListener("dragleave", () => rootCard.classList.remove('drag-over-active'));
        rootCard.addEventListener("drop", (e) => {
            e.preventDefault();
            rootCard.classList.remove('drag-over-active');
            const draggedId = e.dataTransfer.getData("text/plain");
            const targetId = config.root.id;
            if (draggedId && draggedId !== targetId) {
                const draggedNode = config.data.graphData.find(n => n.selfId === draggedId);
                const draggedName = draggedNode ? draggedNode.title : "this role";
                this.confirmMovePopup(draggedName, config.root.name, async () => {
                    await this.handleNodeMove(draggedId, targetId);
                });
            }
        });
    }
    
    const nodeConfig = {
        body: config.container, candidateList: config.candidateList, data: { kvdrOrgConfigData: config.data.kvdrOrgConfigData },
        displaySettings: { cc: config.displaySettings.cardColor, tc: config.displaySettings.textColor, bc: config.displaySettings.borderColor },
        addUsersToDesig: (popupData) => {
            event.stopPropagation(); overlay.append(popupData); overlay.style.display = "flex";
            popupData.dataset.selectedNode = event.target.closest("div.member").dataset.empid;
        },
        onNodeClick: config.onNodeClick, onNodeDelClick: config.onNodeDelClick, onNodeFetch: config.onNodeFetch,
        onNodeUpdate: config.onNodeUpdate, onNodeAddProfileClick: config.onNodeAddProfileClick,
        onNodeProfileFetch: config.onNodeProfileFetch, onNodeProfileUpdate: config.onNodeProfileUpdate,
        onNodeRemoveProfileClick: config.onNodeRemoveProfileClick,
    };

    if (this.can("addRole")) {
        const addNodeBtn = Utils.createElem("div", ["toggleBtn", "addNodeBtn", "node-action-icon"], "", "");
        this.attachTooltip(addNodeBtn, "Add Roles");
        const plusIconImg = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
        Utils.applyStyles(plusIconImg, { fontSize: "10px", fontWeight: "900", display: "block", color: "#000" });
        addNodeBtn.append(plusIconImg);
        addNodeBtn.addEventListener('click', (a) => this.createNode(nodeConfig, overlay));
        Utils.applyStyles(addNodeBtn, {
            position: "absolute", bottom: "-32px", left: "50%", transform: "translateX(-50%)",
            background: "#FFFFFF", border: "1px solid #000", borderRadius: "3px",
            width: "14px", height: "14px", display: "flex", justifyContent: "center",
            alignItems: "center", cursor: "pointer", zIndex: "999",
            filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))"
        });
        addNodeBtn.dataset.addnode = "true";
        rootNode.querySelector(".userCard").append(addNodeBtn);
    }
    canvas.append(rootNode);
    
    // Utils.toggleFullScreen(controls.id, config.container);
    // const fsBtn = document.getElementById('toggle-full-screen');
    // if (fsBtn) {
    //     fsBtn.innerHTML = '';
    //     const fsIcon = Utils.createElem("i", ["toggleScreenIcon", "vs-icon", "notranslate", "icon-scale", "feather", "icon-maximize"]);
    //     Utils.applyStyles(fsIcon, { fontSize: "20px", color: "#333", pointerEvents: "none", display: "block" });
    //     Utils.applyStyles(fsBtn, { display: "flex", alignItems: "center", justifyContent: "center", width: "40px", height: "40px", padding: "0", margin: "0", marginLeft: "auto" });
    //     fsBtn.append(fsIcon);
    // }

    Utils.toggleFullScreen(controls.id, config.container);
    
    // Call notifications first so Expand can be prepended before it
    this.notificationsPanel(controls);
    if (this.role() === 0 && this.notifyBtn && this.notifyBtn.parentElement) {
        this.notifyBtn.parentElement.style.display = "none";
    }

    const fsBtn = document.getElementById('toggle-full-screen');
    if (fsBtn) {
        fsBtn.innerHTML = '';
        const fsIcon = Utils.createElem("i", ["toggleScreenIcon", "vs-icon", "notranslate", "icon-scale", "feather", "icon-maximize"]);
        Utils.applyStyles(fsIcon, { fontSize: "20px", color: "#333", pointerEvents: "none", display: "block" });
        
        // Removed marginLeft: "auto", added marginRight
        Utils.applyStyles(fsBtn, { display: "flex", alignItems: "center", justifyContent: "center", width: "40px", height: "40px", padding: "0", margin: "0", marginRight: "5px" });
        fsBtn.append(fsIcon);
        
        // Prepend it to the controls container to force it to the extreme left
        controls.prepend(fsBtn);
    }

    // 1. INSIDE createKVDR (Replace your existing if (this.role() !== 0) block with this)
    if (this.role() !== 0) {
        // Restrict UI buttons to only the organization plan tab
        const path = window.location.pathname || "";
        const isOrgPlanView = path.includes('/organization/') && path.includes('/evaluate');
        
        if (isOrgPlanView) {
            // Create a wrapper for the right-side actions to control layout & spacing perfectly
            const rightActionsContainer = Utils.createElem('div');
            Utils.applyStyles(rightActionsContainer, {
                display: 'flex',
                alignItems: 'center',
                marginLeft: 'auto',  // Pushes the container to the far right
                marginRight: '20px', // Prevents clipping out of the screen (shifted slightly left)
                gap: '8px'           // Spacing between the buttons
            });

            // Add the buttons to the wrapper (Users first, then Resumes so it's on the left)
            this.createImportResumesBtn(rightActionsContainer);

            // Append the wrapper to the main controls toolbar
            controls.append(rightActionsContainer);
        }
        
        // Listener attaches once, but is safety-gated internally by the route check
        this.enableGlobalDragDrop(document.body);
    }
    Utils.moveViewport(canvasContainer, canvas, isViewportActive);

    if (config.data.graphData.length) {
        config.data.graphData.forEach((node) => {
            // ---> ADD THIS LINE: Skip drawing the box if it is rejected <---
            if (node.status === 'rejected') return;

            const nodeData = { ...node, ...nodeConfig };
            const importedNode = this.importNodeKVDR(nodeData, overlay);
            rootNode.append(importedNode);
        });
    }
    rootNode.querySelectorAll(".member").forEach((memberNode) => {
        const empId = memberNode.dataset.empid;
        document.querySelectorAll(`[data-parentid='${empId}']`).forEach((childNode) => {
            if (memberNode !== childNode) {
                document.querySelector(`[data-empid='${empId}']`).append(childNode);
            }
        });
    });

    setTimeout(() => {
        if (rootNode && canvasContainer) {
            const rootRect = rootNode.getBoundingClientRect();
            const containerRect = canvasContainer.getBoundingClientRect();
            const currentScrollLeft = canvasContainer.scrollLeft;
            const rootAbsoluteLeft = currentScrollLeft + (rootRect.left - containerRect.left);
            const halfContainer = containerRect.width / 2;
            const halfRoot = rootRect.width / 2;
            const targetScroll = rootAbsoluteLeft - halfContainer + halfRoot;
            canvasContainer.scrollTo({ left: targetScroll, behavior: 'auto' });
        }
    }, 100);
}
getActualOrgId() {
        const config = this.config();
        const cData = config.data || {};
        const orgConfig = cData.kvdrOrgConfigData || {};
        
        let orgId = cData.organizationId || cData.orgId || orgConfig.organizationId || orgConfig.orgId;
        
        // If we don't have a valid 24-character Mongo ID, extract it from Vuex storage
        if (!orgId || !/^[a-fA-F0-9]{24}$/.test(orgId)) {
            try {
                const vuexStr = localStorage.getItem('vuex');
                if (vuexStr) {
                    const vuex = JSON.parse(vuexStr);
                    if (vuex.organization && vuex.organization.orgData && vuex.organization.orgData._id) {
                        return vuex.organization.orgData._id;
                    }
                }
            } catch(e) {}
        }

        return orgId || config.id;
    }

enableGlobalDragDrop(targetElement) {
        // Prevent duplicate listeners from stacking up in SPAs
        if (targetElement.dataset.dndInitialized === 'true') {
            return;
        }
        targetElement.dataset.dndInitialized = 'true';

        // 1. Create the Visual Overlay (Hidden by default)
        if (!document.getElementById('organigram-drop-overlay')) {
            const overlay = Utils.createElem("div", [], "organigram-drop-overlay");
            const content = Utils.createElem("div");
            
            // Icon
            const icon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-upload-cloud"]);
            Utils.applyStyles(icon, { fontSize: "60px", marginBottom: "20px", color: "#fff" });
            
            // Text
            const text = Utils.createElem("h2", [], "", "Drop Resumes to Import");
            Utils.applyStyles(text, { color: "#fff", fontFamily: "inherit", margin: "0" });

            content.append(icon, text);
            Utils.applyStyles(content, { textAlign: "center", pointerEvents: "none" });

            Utils.applyStyles(overlay, {
                position: "fixed", top: "0", left: "0", width: "100%", height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.65)", zIndex: "999999",
                display: "none", alignItems: "center", justifyContent: "center",
                backdropFilter: "blur(4px)", transition: "opacity 0.2s"
            });

            overlay.append(content);
            document.body.append(overlay);
        }

        const overlay = document.getElementById('organigram-drop-overlay');
        let dragCounter = 0;

        // --- NEW ROUTE CHECK ---
        const isOrgPlanView = () => {
            const path = window.location.pathname || "";
            return path.includes('/organization/') && path.includes('/evaluate');
        };

        // --- ADDED CHECK: ONLY TRIGGER FOR FILES ---
        const hasFiles = (e) => {
            return e.dataTransfer && e.dataTransfer.types && (
                e.dataTransfer.types.includes ? e.dataTransfer.types.includes('Files') : e.dataTransfer.types.indexOf('Files') !== -1
            );
        };

        // 2. Event Listeners
        const preventDefaults = (e) => {
            if (!isOrgPlanView()) return; 
            if (!hasFiles(e)) return; // Abort if dragging an internal node
            e.preventDefault();
            e.stopPropagation();
        };

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            targetElement.addEventListener(eventName, preventDefaults, false);
        });

        targetElement.addEventListener('dragenter', (e) => {
            if (!isOrgPlanView()) return;
            if (!hasFiles(e)) return; 
            dragCounter++;
            overlay.style.display = "flex";
        });

        targetElement.addEventListener('dragleave', (e) => {
            if (!isOrgPlanView()) return;
            if (!hasFiles(e)) return; 
            dragCounter--;
            if (dragCounter <= 0) {
                dragCounter = 0;
                overlay.style.display = "none";
            }
        });

        targetElement.addEventListener('drop', (e) => {
            if (!isOrgPlanView()) return;
            if (!hasFiles(e)) return; 
            dragCounter = 0;
            overlay.style.display = "none";
            
            const dt = e.dataTransfer;
            const files = dt.files;

            if(files && files.length > 0) {
                this.handleResumeDropBatch(files);
            }
        });
    }

    async handleResumeDropBatch(files) {
        const validExts = ['.pdf', '.doc', '.docx', '.txt'];
        const validFiles = Array.from(files).filter(f => 
            validExts.some(ext => f.name.toLowerCase().endsWith(ext))
        );

        if (validFiles.length === 0) {
            this.showToast("Invalid file type. Please drop PDF, DOC, or TXT files.", "error");
            return;
        }

        if (validFiles.length > 20) {
            this.showToast("Limit exceeded. Please drop max 20 files at a time.", "error");
            return;
        }

        this.toggleLoadingScreen(true, `Importing ${validFiles.length} Resumes...`);

        // --- BULLETPROOF ID RESOLUTION ---
        const actualOrgId = this.getActualOrgId();
        let kvdrId = "";
        
        // 1. Best Source: Extract directly from active roles on the chart
        const gData = this.config().data?.graphData;
        if (Array.isArray(gData) && gData.length > 0) {
            const firstValid = gData.find(n => n.kvdrId);
            if (firstValid) kvdrId = firstValid.kvdrId;
        }
        
        // 2. Second Source: Try base config ID
        if (!kvdrId || kvdrId === 'undefined') {
            kvdrId = this.config().id;
        }

        // 3. Ultimate Fallback: Ensure it's a valid 24-character Mongo ID, otherwise use Organization ID
        if (!kvdrId || kvdrId === 'undefined' || !/^[a-fA-F0-9]{24}$/.test(kvdrId)) {
            kvdrId = actualOrgId;
        }

        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";

        const formData = new FormData();
        formData.append('api_token', token);
        formData.append('organization_id', actualOrgId);
        formData.append('kvdr_id', kvdrId); // Now strictly a valid 24-char ID
        
        validFiles.forEach(f => formData.append('files', f));

        try {
            const res = await fetch(`${API_BASE_URL}/upload-resumes-batch/`, { 
                method: 'POST', 
                body: formData 
            });
            
            const data = await res.json();
            if (!res.ok) throw new Error(data.detail || "Upload failed");

            const newBatchId = data.batch_id;
            const stateKey = `resume_upload_state_${actualOrgId}`;
            let savedState = { localBatchIds: [], batchesData: {}, uploadQueue: [] };

            try {
                const existing = localStorage.getItem(stateKey);
                if (existing) savedState = JSON.parse(existing);
            } catch(e) {}

            const fileObj = {};
            validFiles.forEach(f => {
                fileObj[f.name] = { status: 'processing', progress: 5 };
            });

            if (!savedState.localBatchIds.includes(newBatchId)) {
                savedState.localBatchIds.push(newBatchId);
            }

            savedState.batchesData[newBatchId] = {
                status: 'processing',
                total_files: validFiles.length,
                processed_count: 0,
                files: fileObj
            };
            
            savedState.timestamp = Date.now();
            savedState.lastActivity = Date.now(); // Timer for the 30-second kill switch
            localStorage.setItem(stateKey, JSON.stringify(savedState));

            const orgSlug = this.config().slug;
            if(orgSlug) {
                localStorage.setItem(`onboardingStep_${orgSlug}`, '2');
            }
            
            this.refreshRibbonUI(); 
            this.showResumeSuccessToast(validFiles.length);

        } catch (e) {
            console.error("Upload Error:", e);
            this.showToast(`Upload Error: ${e.message}`, "error");
        } finally {
            this.toggleLoadingScreen(false);
        }
    }

    initResumeProgressRibbon(container) {
        if (window.__resumeRibbonInterval) clearInterval(window.__resumeRibbonInterval);

        let ribbon = document.getElementById("resume-progress-ribbon-inline");
        if (!ribbon) {
            ribbon = document.createElement("div");
            ribbon.id = "resume-progress-ribbon-inline";
            
            ribbon.style.cssText = `
                background: #fff; border: 1px solid #E5E7EB; border-radius: 8px;
                padding: 16px 20px; margin-bottom: 20px; box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.03);
                display: none; font-family: inherit; width: 100%; box-sizing: border-box;
            `;
            
            // UI setup with Manual Cross Button
            ribbon.innerHTML = `
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <div id="ribbon-icon-zone"></div>
                        <div style="display: flex; flex-direction: column; text-align: left;">
                            <span id="ribbon-title" style="font-size: 14px; font-weight: 600; color: #111827;"></span>
                            <span id="ribbon-sub-title" style="font-size: 12px; color: #6B7280;"></span>
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 15px;">
                        <span id="ribbon-perc-text" style="font-weight: 700; font-size: 16px; color: #FFC107;"></span>
                        <div id="ribbon-action-zone"></div>
                        <button id="ribbon-force-close-btn" style="background:transparent;border:none;cursor:pointer;font-size:24px;line-height:1;color:#9ca3af;padding:0 5px;" title="Dismiss">&times;</button>
                    </div>
                </div>
                <div style="width: 100%; height: 6px; background: #F3F4F6; border-radius: 3px; overflow: hidden;">
                    <div id="ribbon-bar-fill" style="height: 100%; transition: width 0.3s ease; width: 0%;"></div>
                </div>
            `;
            
            container.parentNode.insertBefore(ribbon, container);

            // Bind the manual cross (X) force close logic
            document.getElementById('ribbon-force-close-btn').addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.ribbonStateKey) localStorage.removeItem(this.ribbonStateKey);
                ribbon.style.display = "none";
            });

        } else if (ribbon.parentNode !== container.parentNode) {
            container.parentNode.insertBefore(ribbon, container);
        }

        const findActiveKey = () => {
            return Object.keys(localStorage).find(key => {
                if (!key.startsWith('resume_upload_state_')) return false;
                try {
                    const data = JSON.parse(localStorage.getItem(key));
                    return data && data.localBatchIds && data.localBatchIds.length > 0;
                } catch(e) { return false; }
            });
        };

        this.ribbonStateKey = findActiveKey();
        this.refreshRibbonUI();

        // Start Polling (with 30-sec Auto-Kill feature)
        window.__resumeRibbonInterval = setInterval(async () => {
            if (!this.ribbonStateKey) this.ribbonStateKey = findActiveKey();
            
            if (this.ribbonStateKey) {
                try {
                    const saved = localStorage.getItem(this.ribbonStateKey);
                    if (saved) {
                        const state = JSON.parse(saved);
                        if (state.localBatchIds && state.localBatchIds.length > 0) {
                            
                            // --> 30 SECOND KILL SWITCH <--
                            const lastActivity = state.lastActivity || state.timestamp || Date.now();
                            if (Date.now() - lastActivity > 30000) {
                                console.warn("Ribbon stuck for >30 seconds. Triggering Auto-Kill.");
                                localStorage.removeItem(this.ribbonStateKey);
                                ribbon.style.display = "none";
                                return; 
                            }

                            const ids = state.localBatchIds.join(',');
                            const actualOrgId = this.getActualOrgId();
                            const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";
                            
                            const res = await fetch(`${API_BASE_URL}/status/multi-batch?batch_ids=${ids}&organization_id=${actualOrgId}`, {
                                headers: { 'Authorization': `Bearer ${token}` }
                            });
                            
                            if (res.ok) {
                                const data = await res.json();
                                if (data.batches) {
                                    let isUpdated = false;
                                    Object.keys(data.batches).forEach(bid => {
                                        state.batchesData[bid] = data.batches[bid];
                                        isUpdated = true;
                                    });
                                    if (isUpdated) {
                                        state.lastActivity = Date.now(); // Refresh the kill switch timer
                                        localStorage.setItem(this.ribbonStateKey, JSON.stringify(state));
                                    }
                                }
                            }
                        }
                    }
                } catch(err) {
                    console.error("Ribbon Polling Error", err);
                }
            }

            this.refreshRibbonUI();
        }, 2000);
    }

refreshRibbonUI() {
        const ribbon = document.getElementById("resume-progress-ribbon-inline");
        if (!ribbon) return;

        if (!window.location.pathname.includes('/evaluate')) {
            ribbon.style.display = "none";
            if (window.__resumeRibbonInterval) clearInterval(window.__resumeRibbonInterval);
            return;
        }

        const saved = this.ribbonStateKey ? localStorage.getItem(this.ribbonStateKey) : null;
        
        const hideRibbon = () => {
            if (ribbon.style.display !== "none") ribbon.style.display = "none";
            this.ribbonStateKey = null;
        };

        if (!saved) return hideRibbon();

        let state;
        try { state = JSON.parse(saved); } catch(e) { return; } 

        if (!state.localBatchIds || state.localBatchIds.length === 0) return hideRibbon();

        let totalFiles = 0, processedCount = 0, totalProgress = 0, activeFileName = "", statuses = [];
        Object.values(state.batchesData || {}).forEach(batch => {
            totalFiles += (batch.total_files || 0);
            processedCount += (batch.processed_count || 0);
            statuses.push(batch.status);
            
            if (batch.files) {
                Object.entries(batch.files).forEach(([name, f]) => {
                    const s = f.status;
                    if (!activeFileName && s !== 'completed' && s !== 'failed' && s !== 'processed_and_emailed') {
                        activeFileName = name;
                    }
                    if (s === 'completed' || s === 'processed_and_emailed' || s === 'failed') {
                        totalProgress += 100;
                    } else {
                        totalProgress += (f.progress || 0);
                    }
                });
            }
        });

        const isComplete = (statuses.length > 0 && statuses.every(s => ['completed', 'failed', 'completed_with_errors'].includes(s))) || 
                           (totalFiles > 0 && processedCount >= totalFiles);
                           
        const percentage = isComplete ? 100 : (totalFiles > 0 ? Math.floor(totalProgress / totalFiles) : 0);

        if (ribbon.style.display !== "block") ribbon.style.display = "block";

        const titleEl = document.getElementById("ribbon-title");
        const subEl = document.getElementById("ribbon-sub-title");
        const percEl = document.getElementById("ribbon-perc-text");
        const barEl = document.getElementById("ribbon-bar-fill");
        const iconZone = document.getElementById("ribbon-icon-zone");
        const actionZone = document.getElementById("ribbon-action-zone");

        if (titleEl) titleEl.textContent = isComplete ? 'Processing Complete' : `Parsing ${activeFileName || 'resumes'}...`;
        if (subEl) subEl.textContent = `${processedCount} / ${totalFiles} files processed`;
        
        if (percEl) {
            percEl.textContent = `${percentage}%`;
            percEl.style.color = isComplete ? '#28C76F' : '#FFC107';
        }
        
        if (barEl) {
            barEl.style.width = `${percentage}%`;
            barEl.style.backgroundColor = isComplete ? '#28C76F' : '#FFC107';
        }

        if (iconZone) {
            const iconHtml = isComplete ? '<span style="font-size:16px">✅</span>' : '<div class="ribbon-spinner"></div>';
            if (iconZone.innerHTML !== iconHtml) iconZone.innerHTML = iconHtml;
        }

        if (actionZone) {
            if (isComplete) {
                if (!document.getElementById("ribbon-finish-btn-inline")) {
                    
                    // Disarm the 30-second kill switch so the user has unlimited time to click "Finish"
                    try {
                        let s = JSON.parse(localStorage.getItem(this.ribbonStateKey));
                        s.lastActivity = Date.now() + 86400000; // Push kill threshold 24 hours into future
                        localStorage.setItem(this.ribbonStateKey, JSON.stringify(s));
                    } catch(e){}

                    actionZone.innerHTML = `<button id="ribbon-finish-btn-inline" style="background: #28C76F; color: #fff; border: none; padding: 6px 14px; border-radius: 6px; cursor: pointer; font-weight: 600; font-size: 13px;">Finish</button>`;
                    document.getElementById("ribbon-finish-btn-inline").onclick = (e) => {
                        e.stopPropagation();
                        localStorage.removeItem(this.ribbonStateKey);
                        hideRibbon();
                    };
                }
            } else {
                if (actionZone.innerHTML !== "") actionZone.innerHTML = "";
            }
        }
    }

    openResumeUploadModal() {
        // --- BULLETPROOF ID RESOLUTION FOR MODAL ---
        const actualOrgId = this.getActualOrgId(); 
        let kvdrId = "";
        
        const gData = this.config().data?.graphData;
        if (Array.isArray(gData) && gData.length > 0) {
            const firstValid = gData.find(n => n.kvdrId);
            if (firstValid) kvdrId = firstValid.kvdrId;
        }
        
        if (!kvdrId || kvdrId === 'undefined') {
            kvdrId = this.config().id;
        }

        if (!kvdrId || kvdrId === 'undefined' || !/^[a-fA-F0-9]{24}$/.test(kvdrId)) {
            kvdrId = actualOrgId;
        }

        const stateKey = `resume_upload_state_${actualOrgId}`;
        const API_TOKEN = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";
        
        const state = { localBatchIds: [], batchesData: {}, uploadQueue: [], isUploading: false, pollingInterval: null };

        if (!document.getElementById('resume-modal-styles')) {
            const css = `
                .resume-drop-zone { border: 2px dashed #e2e8f0; border-radius: 12px; background: #f8fafc; display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 250px; cursor: pointer; transition: all 0.3s; }
                .resume-drop-zone:hover, .resume-drop-zone.dragover { background: #f1f5f9; border-color: #94a3b8; }
                .resume-file-list { max-height: 300px; overflow-y: auto; padding-right: 5px; margin-top: 15px; }
                .resume-file-item { padding: 10px 0; border-bottom: 1px solid #f1f1f1; }
                .resume-progress-track { width: 100%; height: 6px; background: #f0f2f5; border-radius: 3px; margin-top: 6px; overflow: hidden; }
                .resume-progress-fill { height: 100%; transition: width 0.3s ease; }
                .bg-success { background-color: #28c76f !important; } .bg-danger { background-color: #ea5455 !important; } .bg-warning { background-color: #ff9f43 !important; }
                .text-success { color: #28c76f; } .text-danger { color: #ea5455; }
            `;
            const style = document.createElement('style');
            style.id = 'resume-modal-styles';
            style.innerHTML = css;
            document.head.appendChild(style);
        }

        const contentWrapper = Utils.createElem('div');
        Utils.applyStyles(contentWrapper, { width: '100%', height: '100%', display: 'flex', flexDirection: 'column' });
        
        const fileInput = Utils.createElem('input');
        fileInput.type = 'file'; fileInput.multiple = true; fileInput.accept = '.pdf,.doc,.docx,.txt'; fileInput.style.display = 'none';

        const persistState = () => {
            if(state.localBatchIds.length === 0 && state.uploadQueue.length === 0) return;
            localStorage.setItem(stateKey, JSON.stringify({ localBatchIds: state.localBatchIds, batchesData: state.batchesData, uploadQueue: state.uploadQueue, timestamp: Date.now() }));
        };

        const loadState = () => {
            try {
                const saved = localStorage.getItem(stateKey);
                if (!saved) return;
                const parsed = JSON.parse(saved);
                if (Date.now() - (parsed.timestamp || 0) > 3600000) { localStorage.removeItem(stateKey); return; }
                const statuses = Object.values(parsed.batchesData || {}).map(b => b.status);
                const allDone = statuses.length > 0 && statuses.every(s => ['completed', 'failed', 'completed_with_errors'].includes(s));
                if (allDone) { localStorage.removeItem(stateKey); return; }
                state.localBatchIds = parsed.localBatchIds || [];
                state.batchesData = parsed.batchesData || {};
                state.uploadQueue = parsed.uploadQueue || [];
            } catch (e) { console.error("State Load Error", e); }
        };

        const getAggregatedStatus = () => {
            let totalFiles = 0, processed = 0, files = {}, batchStatuses = [];
            state.localBatchIds.forEach(bid => {
                const data = state.batchesData[bid];
                if (data) {
                    totalFiles += (data.total_files || 0); processed += (data.processed_count || 0);
                    if (data.files) Object.assign(files, data.files);
                    batchStatuses.push(data.status);
                }
            });
            state.uploadQueue.forEach(q => {
                q.files.forEach(f => { files[`(Queue) ${f.name}`] = { status: 'queued', progress: 0 }; totalFiles++; });
                batchStatuses.push('pending');
            });
            const isComplete = state.localBatchIds.length > 0 && state.uploadQueue.length === 0 && batchStatuses.every(s => ['completed', 'failed', 'completed_with_errors'].includes(s));
            return { totalFiles, processed, files, isComplete };
        };

        const handleFiles = (fileList) => {
            const valid = Array.from(fileList).filter(f => ['.pdf', '.doc', '.docx', '.txt'].some(ext => f.name.toLowerCase().endsWith(ext)));
            if (valid.length === 0 || valid.length > 10) { this.showToast("Invalid files. Check formats and limit (max 10).", "error"); return; }
            state.uploadQueue.push({ files: valid, tempId: Date.now() });
            renderUI(); processQueue();
        };

        const processQueue = async () => {
            if (state.uploadQueue.length === 0 || state.isUploading) return;
            state.isUploading = true;
            const currentBatch = state.uploadQueue[0];
            
            const formData = new FormData();
            formData.append('api_token', API_TOKEN);
            formData.append('organization_id', actualOrgId); 
            formData.append('kvdr_id', kvdrId); // Strictly passed to API
            
            currentBatch.files.forEach(f => formData.append('files', f));

            try {
                renderUI(); 
                const res = await fetch(`${API_BASE_URL}/upload-resumes-batch/`, { method: 'POST', body: formData });
                const data = await res.json();
                if (!res.ok) throw new Error(data.detail);

                const newId = data.batch_id;
                const fileObj = {};
                currentBatch.files.forEach(f => fileObj[f.name] = { status: 'processing', progress: 5 });

                state.batchesData[newId] = { status: 'processing', total_files: currentBatch.files.length, processed_count: 0, files: fileObj };
                if (!state.localBatchIds.includes(newId)) state.localBatchIds.push(newId);
                
                state.uploadQueue.shift();
                persistState();
                startPolling();
            } catch (e) {
                console.error(e);
                this.showToast(`Upload failed: ${e.message || "Unknown error"}`, "error");
                state.uploadQueue.shift(); 
            } finally {
                state.isUploading = false; processQueue(); renderUI();
            }
        };

        const startPolling = () => {
            if (state.pollingInterval) return;
            state.pollingInterval = setInterval(async () => {
                if (state.localBatchIds.length === 0) return;
                try {
                    const ids = state.localBatchIds.join(',');
                    const res = await fetch(`${API_BASE_URL}/status/multi-batch?batch_ids=${ids}&organization_id=${actualOrgId}`);
                    if (res.ok) {
                        const data = await res.json();
                        if (data.batches) {
                            Object.keys(data.batches).forEach(bid => { state.batchesData[bid] = data.batches[bid]; });
                            persistState(); renderUI();
                            const agg = getAggregatedStatus();
                            if (agg.isComplete) stopPolling();
                        }
                    }
                } catch (e) { console.error("Poll Error", e); }
            }, 2000);
        };

        const stopPolling = () => {
            if (state.pollingInterval) { clearInterval(state.pollingInterval); state.pollingInterval = null; }
        };

        const renderUI = () => {
            contentWrapper.innerHTML = "";
            const agg = getAggregatedStatus();
            const hasActiveUploads = state.localBatchIds.length > 0 || state.uploadQueue.length > 0;

            if (!hasActiveUploads) {
                const dropZone = Utils.createElem('div', ['resume-drop-zone']);
                dropZone.innerHTML = `<div style="pointer-events:none; text-align:center;"><p style="font-weight:600; font-size:18px; color:#333;">Drag & Drop Resumes Here</p><p style="font-size:14px; color:#888; margin-top:5px;">or click to select files</p></div>`;
                const meta = Utils.createElem('div', [], '', '<p>Supported: PDF, DOC, DOCX, TXT</p><p>Max 10 files per upload.</p>');
                Utils.applyStyles(meta, { textAlign: 'center', marginTop: '15px', fontSize: '12px', color: '#999' });

                dropZone.addEventListener('click', () => fileInput.click());
                dropZone.addEventListener('dragover', (e) => { e.preventDefault(); dropZone.classList.add('dragover'); });
                dropZone.addEventListener('dragleave', (e) => { e.preventDefault(); dropZone.classList.remove('dragover'); });
                dropZone.addEventListener('drop', (e) => { e.preventDefault(); dropZone.classList.remove('dragover'); if (e.dataTransfer.files) handleFiles(e.dataTransfer.files); });
                contentWrapper.append(dropZone, meta);
            } else {
                const header = Utils.createElem('div');
                Utils.applyStyles(header, { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderBottom: '1px solid #eee', paddingBottom: '10px' });
                
                let totalProgressSum = 0;
                Object.values(agg.files).forEach(f => {
                    if (f.status === 'completed' || f.status === 'processed_and_emailed' || f.status === 'failed') totalProgressSum += 100;
                    else totalProgressSum += (f.progress || 0);
                });
                const percent = agg.totalFiles > 0 ? Math.floor(totalProgressSum / agg.totalFiles) : 0;
                
                header.innerHTML = `<div><h4 style="font-weight:bold; margin:0; color:#333;">${agg.isComplete ? 'Processing Complete' : 'Processing...'}</h4><p style="font-size:13px; color:#666; margin:5px 0 0;">${agg.processed} / ${agg.totalFiles} processed</p>${state.uploadQueue.length > 0 ? `<p style="font-size:11px; color:#ff9f43; margin-top:4px;"><b>${state.uploadQueue.length}</b> batch(es) queued...</p>` : ''}</div><div style="text-align:right;"><span style="font-size:11px; color:#888; display:block;">TOTAL PROGRESS</span><span style="font-size:32px; font-weight:bold; color:#28c76f;">${agg.isComplete ? 100 : percent}%</span></div>`;

                const fileListContainer = Utils.createElem('div', ['resume-file-list']);
                Object.entries(agg.files).forEach(([filename, fileData]) => {
                    const item = Utils.createElem('div', ['resume-file-item']);
                    let statusColor = 'bg-warning', statusText = `${Math.floor(fileData.progress || 0)}%`, barWidth = fileData.progress || 0;
                    if (fileData.status === 'completed' || fileData.status === 'processed_and_emailed') { statusColor = 'bg-success'; statusText = 'DONE'; barWidth = 100; } 
                    else if (fileData.status === 'failed') { statusColor = 'bg-danger'; statusText = 'FAILED'; barWidth = 100; } 
                    else if (fileData.status === 'queued') { statusColor = 'bg-gray-300'; statusText = 'WAITING'; barWidth = 0; }

                    item.innerHTML = `<div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:5px;"><div style="display:flex; align-items:center; overflow:hidden;"><span style="font-size:13px; font-weight:500; color:#444; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:280px;" title="${filename}">${filename}</span></div><span class="${statusColor === 'bg-success' ? 'text-success' : statusColor === 'bg-danger' ? 'text-danger' : 'text-warning'}" style="font-size:11px; font-weight:bold;">${statusText}</span></div><div class="resume-progress-track"><div class="resume-progress-fill ${statusColor}" style="width: ${barWidth}%;"></div></div>`;
                    fileListContainer.append(item);
                });

                const footer = Utils.createElem('div');
                Utils.applyStyles(footer, { marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '10px' });

                if (!agg.isComplete) {
                    const uploadMoreBtn = Utils.createElem('button', [], '', state.isUploading ? 'Uploading Batch...' : 'Upload More Resumes');
                    Utils.applyStyles(uploadMoreBtn, { width: '100%', padding: '10px', borderRadius: '20px', border: '2px solid #FFC107', background: 'transparent', color: '#FFC107', fontWeight: 'bold', cursor: state.isUploading ? 'not-allowed' : 'pointer', opacity: state.isUploading ? '0.6' : '1' });
                    if (!state.isUploading) uploadMoreBtn.onclick = () => fileInput.click();

                    const hideBtn = Utils.createElem('div', [], '', 'Hide & Process in Background');
                    Utils.applyStyles(hideBtn, { textAlign: 'center', fontSize: '12px', color: '#999', cursor: 'pointer', textDecoration: 'underline' });
                    hideBtn.onclick = () => { document.querySelector(".organiGramPopup.resume-upload-view")?.remove(); document.getElementById("back-drop-overlay").style.display = "none"; if (typeof isViewportActive !== 'undefined') isViewportActive.status = true; };
                    footer.append(uploadMoreBtn, hideBtn);
                } else {
                    const finishBtn = Utils.createElem('button', [], '', 'Finish');
                    Utils.applyStyles(finishBtn, { width: '100%', padding: '12px', borderRadius: '6px', background: '#FF9F43', color: '#fff', fontWeight: 'bold', border: 'none', cursor: 'pointer' });
                    finishBtn.onclick = () => { stopPolling(); localStorage.removeItem(stateKey); document.querySelector(".organiGramPopup.resume-upload-view")?.remove(); document.getElementById("back-drop-overlay").style.display = "none"; if (typeof isViewportActive !== 'undefined') isViewportActive.status = true; this.showToast("Import Complete", "success"); };
                    footer.append(finishBtn);
                }
                contentWrapper.append(header, fileListContainer, footer);
            }
        };

        loadState();
        if (state.localBatchIds.length > 0) startPolling();
        renderUI();

        fileInput.onchange = (e) => { if(e.target.files) handleFiles(e.target.files); fileInput.value = ''; };

        const popupConfig = {
            headerText: "Import Resumes",
            onCloseClick: () => { document.querySelector(".organiGramPopup.resume-upload-view")?.remove(); document.getElementById("back-drop-overlay").style.display = "none"; if (typeof isViewportActive !== 'undefined') isViewportActive.status = true; },
            data: contentWrapper, displaySettings: { width: "500px", height: "auto" }, footer: ""
        };

        const popup = this.createPopup(popupConfig);
        popup.classList.add("resume-upload-view");
        const bodyPart = popup.querySelector('.OrganiGramPopupBody');
        if(bodyPart) { bodyPart.style.padding = "20px"; }

        const backdrop = document.getElementById("back-drop-overlay");
        backdrop.innerHTML = ""; backdrop.style.display = "flex"; backdrop.append(popup);
    }

        
    delNodeKVDR(data) {
    const { target, deleteNode, deleteProfile, popupBody, displaySettings } = data;

    const childNodes = target.childNodes;
    const subRoles = Array.from(childNodes).filter((node) => node.matches("div.member"));
    const assignedCount = target.dataset.selectedUsr ? target.dataset.selectedUsr.split(',').filter(Boolean).length : 0;

    const clearPopup = () => {
        popupBody.style.display = "none";
        popupBody.innerHTML = "";
        if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
    };

    const handleDeletion = () => {
        target.remove();
        const nodes = [...subRoles, target];
        const empIds = nodes.map((e) => e.dataset.empid);
        deleteNode(empIds); 
        clearPopup();
    };

    Utils.playBellSound(1000, 990, 'sine');

    const confirmBtn = Utils.createElem("button", ["popup-confirm-btn"], "", "Confirm Delete");
    Utils.applyStyles(confirmBtn, {
        border: "none",
        background: "#dc3545",
        color: "#fff",
        padding: "10px 18px",            
        fontSize: "14px",
        fontWeight: "600",
        cursor: "pointer",
        borderRadius: "8px",             
        boxShadow: "0 4px 12px rgba(220,53,69,0.12)", 
        outline: "none"
    });
    confirmBtn.addEventListener("click", handleDeletion);

    const footerWrapper = Utils.createElem("div");
    Utils.applyStyles(footerWrapper, {
        display: "flex",
        justifyContent: "flex-end",
        padding: "14px 18px",
        borderTop: "1px solid rgba(0,0,0,0.06)",
        boxSizing: "border-box",
        width: "100%",
        background: "transparent"
    });
    footerWrapper.appendChild(confirmBtn);

    const messageContainer = Utils.createElem("div");
    Utils.applyStyles(messageContainer, { 
        padding: "18px 20px", 
        textAlign: "left",         
        alignItems: "flex-start",
        color: "#444", 
        fontSize: "14px", 
        lineHeight: "1.6",
        fontFamily: "inherit",
        display: "block",
        width: "100%",
        boxSizing: "border-box"
    });

    let contentHTML = "";

    if (subRoles.length > 0) {
        contentHTML = `
            <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#fdecea; align-items:flex-start; text-align:left;">
                <span style="font-size:24px; line-height:1; color:#d32f2f; margin-top:2px;">⚠️</span>
                <div style="min-width:0; text-align:left;">
                    <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#b71c1c;">
                        Sub-roles detected
                    </h3>
                    <p style="margin:0; font-size:14px; color:#c62828; line-height:1.4; overflow-wrap:break-word; text-align:left;">
                        This role has <b>${subRoles.length}</b> connected sub-role(s).
                    </p>
                </div>
            </div>

            <p style="margin:14px 0 0; font-size:14px; color:#555; line-height:1.6; text-align:left;">
                Deleting this role will <b>permanently remove</b> all sub-roles and unassign all candidates.
            </p>

            <p style="margin-top:10px; font-size:14px; font-weight:600; color:#333;">
                This action cannot be undone.
            </p>
        `;
    } else if (assignedCount > 0) {
        contentHTML = `
            <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#fff4e5; align-items:flex-start; text-align:left;">
                <span style="font-size:24px; line-height:1; color:#f57c00; margin-top:2px;">⚠️</span>
                <div style="min-width:0; text-align:left;">
                    <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#e65100;">
                        Active assignments
                    </h3>
                    <p style="margin:0; font-size:14px; color:#ef6c00; line-height:1.4; overflow-wrap:break-word; text-align:left;">
                        <b>${assignedCount}</b> candidate(s) are currently assigned.
                    </p>
                </div>
            </div>

            <p style="margin:14px 0 0; font-size:14px; color:#555; line-height:1.6;">
                Deleting this role will remove all assignments from the organization chart.
            </p>

            <p style="margin-top:10px; font-size:14px; font-weight:600; color:#333;">
                This action cannot be undone.
            </p>
        `;
    } else {
        contentHTML = `
            <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#f5f5f5; align-items:flex-start; text-align:left;">
                <span style="font-size:24px; line-height:1; color:#616161; margin-top:2px;">⚠️</span>
                <div style="min-width:0; text-align:left;">
                    <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#424242;">
                        Delete role?
                    </h3>
                    <p style="margin:0; font-size:14px; color:#616161; line-height:1.4; overflow-wrap:break-word; text-align:left;">
                        This role will be removed from the organization chart.
                    </p>
                </div>
            </div>

            <p style="margin-top:14px; font-size:14px; font-weight:600; color:#333;">
                This action cannot be undone.
            </p>
        `;
    }

    messageContainer.innerHTML = contentHTML;

    const confirmPromptData = {
        headerText: "Delete Confirmation",
        onCloseClick: clearPopup,
        data: messageContainer,
        footer: footerWrapper,
        displaySettings: {
            ...displaySettings,
            width: "520px",    
            height: "auto",
            cc: displaySettings.cc,
            tc: displaySettings.tc
        },
    };

    const popupData = this.createPopup(confirmPromptData);
    popupBody.append(popupData);
    popupBody.style.display = "flex";
    popupBody.dataset.selectedNode = target.dataset.empid;
}

    
    importNodeKVDR(nodeData, popupBody) {
        const profiles = nodeData.profiles || [];
        const container = Utils.createElem("div", ["member"], `${nodeData._id}`, "", { "data-empid": nodeData.selfId, "data-parentid": nodeData.parentId });
        container.dataset.selectedUsr = profiles.map((c) => c.userId).join(",") || "";
        container.addEventListener("click", (event) => event.preventDefault());

        const selectedUserBox = Utils.createElem("span", ["selectedUsrBox"]);
        Utils.applyStyles(selectedUserBox, { display: "flex", margin: "10px 5px", alignItems: "center" });

        // Add User Button Logic
        if (this.can('addProfile') && nodeData.status === 'published') {
            const addUserIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
            Utils.applyStyles(addUserIcon, { fontSize: "20px", color: "#000" });
            const addUserButton = Utils.createElem("button", ["openUsrListBtn"]);
            Utils.applyStyles(addUserButton, { 
                border: "1px solid #ddd ", background: "#fff", cursor: "pointer", 
                margin: "0 0 0 8px", borderRadius: "50%", width: "32px", height: "32px", 
                display: "flex", alignItems: "center", justifyContent: "center", position: "relative", padding: "0"
            });
            addUserButton.addEventListener('mouseenter', () => addUserButton.style.borderColor = "#999");
            addUserButton.addEventListener('mouseleave', () => addUserButton.style.borderColor = "#ddd");
            
            this.attachTooltip(addUserButton, "Add Team Member");

            addUserButton.append(addUserIcon);

            const notifyDot = Utils.createElem("span", ["suggestionDot"], "", "");
            Utils.applyStyles(notifyDot, {
                position: "absolute", top: "-2px", right: "-2px", width: "8px", height: "8px",
                backgroundColor: "#ff4444", borderRadius: "50%", border: "1px solid white", display: "none", zIndex: "10"
            });
            addUserButton.append(notifyDot);

            addUserButton.dataset.orgId = this.getActualOrgId();
            addUserButton.dataset.roleId = nodeData.selfId;
            addUserButton.dataset.dot = notifyDot;

            this.observer.observe(addUserButton);
            
            addUserButton.addEventListener("click", (event) => {
                event.preventDefault(); 
                event.stopPropagation();

                const popupConfig = {
                    headerText: "Add Team Member",
                    onCloseClick: () => { document.querySelectorAll('.custom-suggestion-tooltip').forEach(el => el.remove()); event.stopPropagation(); popupBody.style.display = "none"; popupBody.innerHTML = ""; isViewportActive.status = true; },
                    data: this._popupUsrListCollection(event, nodeData, popupBody),
                    displaySettings: nodeData.displaySettings, footer: "",
                };
                const popup = this.createPopup(popupConfig);
                nodeData.addUsersToDesig(popup);
            });
            selectedUserBox.append(addUserButton);
        }

        const exData = {
            kvdrRoleId: nodeData.selfId, candidateList: nodeData.candidateList, kvdrOrgConfigData: nodeData.data.kvdrOrgConfigData,
            removeProfile: (payload) => {
                // 1. Trigger API Call
                nodeData.onNodeRemoveProfileClick(payload);

                // 2. DOM Cleanup: Remove avatar from the Role Card (container) directly
                // 'container' is available in this scope from importNodeKVDR
                const userId = payload.userId;
                
                // Update the dataset list of users
                if (container.dataset.selectedUsr) {
                    let sUsers = container.dataset.selectedUsr.split(",");
                    sUsers = sUsers.filter(id => id !== userId); // Remove ID
                    container.dataset.selectedUsr = sUsers.join(",");
                }

                // Find and remove the specific user image
                // We use the ID we assigned during creation: `img-${userId}`
                const userImg = container.querySelector(`#img-${userId}`);
                if (userImg) userImg.remove();
                
                // 3. Close the Popup Cleanly
                popupBody.innerHTML = "";
                popupBody.style.display = "none";
                
                // 4. Re-enable viewport interactions
                if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;

                // 5. Success Sound/Toast (Optional)
                if (typeof Utils.playBellSound === 'function') Utils.playBellSound(1000, 990, 'sine');
            },
            // ------------------------------------

            profileData: async (t) => { return nodeData.onNodeProfileFetch(t) },
            profileUpdate: async (t) => { return nodeData.onNodeProfileUpdate(t) },
            roleData: async (t) => { return nodeData.onNodeFetch(t) },
            roleUpdate: async (t) => { return nodeData.onNodeUpdate(t) },
            displaySettings: nodeData.displaySettings,
        };

        if (profiles.length) {
            profiles.forEach(candidate => {
                const userId = candidate.userId;
                const profile = nodeData.candidateList.find(c => c.id === userId);
                if (profile) {
                    const userImg = Utils.createElem("img", ["selectedUsrImg"], `img-${userId}`, "", { src: profile.imageUrl });
                    Utils.applyStyles(userImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit: "cover", objectPosition: "center", border: "2px solid", borderRadius: "50%", });
                    
                    userImg.addEventListener("click", (evt) => {
                        evt.preventDefault();
                        evt.stopPropagation();
                        this.expandRole(exData, "Talent", [userId]);
                    });
                    selectedUserBox.prepend(userImg);
                }
            });
        }

        const title = Utils.createElem("i", ["role-card-title"], "", `${nodeData.title}`, { contentEditable: "false" });
        Utils.applyStyles(title, { display: "flex", alignItems: "center", marginRight: "0px", color: nodeData.tc, paddingRight: "20px", cursor: "default" });
        
        const titleWrapper = Utils.createElem("div");
        Utils.applyStyles(titleWrapper, { display: "flex", alignItems: "center" });
        titleWrapper.append(title,selectedUserBox);

        const deleteBtnWrapper = Utils.createElem("div", ["delNodeBtnBox", "node-action-icon"]);
        if(this.can("delRole") && nodeData.status === 'published'){
            const deleteBtn = Utils.createElem("i", ["delNodeBtn", "vs-icon", "notranslate", "icon-scale", "feather", "icon-x"], "", "");
            Utils.applyStyles(deleteBtn, { cursor: "pointer", fontSize: "14px", color: "#555" }); 
            
            this.attachTooltip(deleteBtn, "Delete Role");

            deleteBtn.addEventListener("click", () =>
                this.delNodeKVDR({ target: container, deleteNode: (t) => nodeData.onNodeDelClick(t), deleteProfile: (t) => nodeData.onNodeRemoveProfileClick(t), popupBody: popupBody, displaySettings: nodeData.displaySettings, })
            );
            Utils.applyStyles(deleteBtnWrapper, { position: "absolute", top: "5px", right: "5px", zIndex: "5", lineHeight: "0" });
            deleteBtnWrapper.append(deleteBtn);
        }

        const footerLeft = Utils.createElem("div", ["roleFooterLeft"]);
        if (this.can('editTitle') && nodeData.status === 'published') {
            // CHANGE 1: Removed 'node-action-icon' from the initial creation classes here.
            // We will let updateLockVisuals manage this class dynamically.
            const hiringLockBtn = Utils.createElem("i", ["hiringLockBtn", "vs-icon", "notranslate", "icon-scale", "feather"], "", "");
            
            // CONSTANT FOR STORAGE
            const LOCK_FLAG = "[OPEN_HIRING]";

            // 1. DETERMINE STATE FROM softSkills ARRAY
            let currentSoftSkills = Array.isArray(nodeData.softSkills) ? [...nodeData.softSkills] : [];
            let isHiring = currentSoftSkills.includes(LOCK_FLAG);

            const updateLockVisuals = (isOpen) => {
                hiringLockBtn.classList.remove("icon-lock", "icon-unlock");
                hiringLockBtn.classList.add(isOpen ? "icon-unlock" : "icon-lock");
                hiringLockBtn.style.color = isOpen ? "#28c76f" : "#333"; 
                hiringLockBtn.dataset.tooltipText = isOpen ? "Role is Open" : "Role is Closed";

                // --- FIX START: VISIBILITY LOGIC ---
                if (isOpen) {
                    // If Hiring is Enabled: 
                    // Remove the hover class so it is ALWAYS visible.
                    hiringLockBtn.classList.remove("node-action-icon");
                    hiringLockBtn.style.opacity = "1";
                    hiringLockBtn.style.visibility = "visible";
                } else {
                    // If Hiring is Disabled: 
                    // Add the hover class so it is HIDDEN by default (appears only on hover).
                    hiringLockBtn.classList.add("node-action-icon");
                    // Reset inline styles to let CSS hover effects take over
                    hiringLockBtn.style.opacity = "";
                    hiringLockBtn.style.visibility = "";
                }
                // --- FIX END ---
            };

            // Init Visuals
            updateLockVisuals(isHiring);

            Utils.applyStyles(hiringLockBtn, { 
                fontSize: "13px", 
                position: "absolute", 
                left: "0px", 
                bottom: "0px", 
                cursor: "pointer",
                padding: "2px"
            });

            // Dynamic Tooltip
            hiringLockBtn.addEventListener('mouseenter', () => {
                const text = hiringLockBtn.dataset.tooltipText;
                const tip = document.createElement('div');
                tip.className = 'organigram-custom-tooltip';
                tip.innerText = text;
                document.body.appendChild(tip);
                
                const rect = hiringLockBtn.getBoundingClientRect();
                const top = rect.top - tip.offsetHeight - 5; 
                const left = rect.left + (rect.width / 2);
                tip.style.top = top + 'px';
                tip.style.left = left + 'px';
            });
            hiringLockBtn.addEventListener('mouseleave', () => {
                document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());
            });

            // Toggle Handler
            hiringLockBtn.addEventListener("click", async (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Toggle logic
                isHiring = !isHiring;
                updateLockVisuals(isHiring);
                
                // Remove tooltip immediately on click to prevent obstruction
                document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());

                // UPDATE DATA ARRAY
                if (isHiring) {
                    if (!currentSoftSkills.includes(LOCK_FLAG)) currentSoftSkills.push(LOCK_FLAG);
                } else {
                    currentSoftSkills = currentSoftSkills.filter(skill => skill !== LOCK_FLAG);
                }

                // Update Local Node Data reference immediately
                nodeData.softSkills = currentSoftSkills;
                const localNode = safeGraphData(this.config()).find(n => n.selfId === nodeData.selfId);
                if(localNode) localNode.softSkills = currentSoftSkills;

                try {
                    // SAVE TO BACKEND via existing update function
                    await nodeData.onNodeUpdate({ 
                        query: nodeData.selfId, 
                        data: { softSkills: currentSoftSkills } 
                    });
                    
                    if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'sine');
                } catch (err) {
                    console.error("Failed to update hiring status", err);
                    // Revert on failure
                    isHiring = !isHiring;
                    updateLockVisuals(isHiring);
                }
            });

            footerLeft.append(hiringLockBtn);
        }
        const footerRight = Utils.createElem("div", ["roleFooterRight"]);
        if(this.can('expandRole') && nodeData.status === 'published'){
            const expandBtn = Utils.createElem("i", ["roleExpandBtn", "vs-icon", "notranslate", "icon-scale", "feather", "icon-edit-2", "node-action-icon"], "", "");
            Utils.applyStyles(expandBtn, { fontSize: "13px", color: "#000", position: "absolute", right: "0px", bottom: "0px", cursor: "pointer" });
            
            this.attachTooltip(expandBtn, "Edit Role");

            expandBtn.addEventListener("click", () => this.expandRole(exData, "ROLE"));
            footerRight.append(expandBtn);
        }
        const footer = Utils.createElem("div", ["roleFooter"]);
        Utils.applyStyles(footer, { border: "none", padding: "5px 0", display: "flex", alignItems: "center", justifyContent: "space-between", flex: "1 1 100%", position: "relative" });
        footer.append(footerLeft, footerRight);

        // --- DRAG AND DROP LOGIC STARTS HERE ---
        // --- UPDATED: ADD 'node-hover-target' to this CARD ---
        const card = Utils.createElem("fieldset", ["userCard", "onlyCardType"]);
        
        // Only apply hover effects if it is published
        if (nodeData.status === 'published') {
            card.classList.add("node-hover-target");
        } else {
            card.style.cursor = "not-allowed"; // Show a blocked cursor for pending/rejected
        }
        
        // Only allow Drag & Drop if published
        if(this.can("editTitle") && nodeData.status === 'published') { 
            card.draggable = true;
            card.addEventListener("dragstart", (e) => {
                e.stopPropagation();
                e.dataTransfer.setData("text/plain", nodeData.selfId);
                e.dataTransfer.effectAllowed = "move";
                card.style.opacity = "0.6";
                card.classList.add('is-dragging'); 
                window.draggedNodeId = nodeData.selfId; 
            });
            card.addEventListener("dragend", (e) => {
                e.stopPropagation();
                card.style.opacity = "1";
                card.classList.remove('is-dragging'); 
                delete window.draggedNodeId;
                document.querySelectorAll('.drag-over-active').forEach(el => el.classList.remove('drag-over-active'));
            });
            card.addEventListener("dragover", (e) => {
                e.preventDefault(); e.stopPropagation();
                const draggedId = window.draggedNodeId;
                if(draggedId && draggedId !== nodeData.selfId) { card.classList.add('drag-over-active'); }
            });
            card.addEventListener("dragleave", (e) => {
                e.preventDefault(); e.stopPropagation();
                card.classList.remove('drag-over-active');
            });
            card.addEventListener("drop", (e) => {
                e.preventDefault(); e.stopPropagation();
                card.classList.remove('drag-over-active');
                const draggedId = e.dataTransfer.getData("text/plain");
                const targetId = nodeData.selfId;
                if(draggedId === targetId) return;
                const draggedNode = safeGraphData(this.config()).find(n => n.selfId === draggedId);
                const draggedName = draggedNode ? draggedNode.title : "this role";
                this.confirmMovePopup(draggedName, nodeData.title, async () => { await this.handleNodeMove(draggedId, targetId); });
            });
        }
        // --- DRAG AND DROP LOGIC ENDS HERE ---

        Utils.applyStyles(card, { 
            backgroundColor: nodeData.displaySettings.cc, color: nodeData.displaySettings.tc, 
            borderColor: nodeData.displaySettings.bc, flexWrap: "wrap", 
            position: "relative", overflow: "visible !important", transition: "all 0.2s ease"
        });
        
        if(this.can("delRole") && nodeData.status === 'published') { card.append(deleteBtnWrapper); }
        card.append(titleWrapper, footer);
        
        const label = Utils.createElem("label", ["emptitle"]);
        Utils.applyStyles(label,{ opacity:nodeData.status=='pending'?'0.5':nodeData.status=='rejected'?'0.2':'1', position: "relative", overflow: "visible !important" })
        label.append(card);

        // ONLY allow adding roles (+) if the current node is published
        let allowAddBtn = false;
        if (nodeData.status === 'published') {
            if (this.can("addRole")) {
                allowAddBtn = true;
            } else if (this.can("addRoleRequest") && nodeData.isCurrentUserNode === true) {
                allowAddBtn = true;
            }
        }

        if(allowAddBtn){
            const addNodeBtn = Utils.createElem("div", ["toggleBtn", "addNodeBtn", "node-action-icon"], "", "", {"data-addnode": "true"});
            this.attachTooltip(addNodeBtn, "Add Roles");

            const plusIconImg = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
            Utils.applyStyles(plusIconImg, { fontSize: "10px", fontWeight: "900", display: "block", color: "#000" })
            addNodeBtn.append(plusIconImg);
            
            addNodeBtn.addEventListener('click',() => this.createNode(nodeData, popupBody));
            
            Utils.applyStyles(addNodeBtn, {
                position: "absolute", bottom: "-32px", left: "50%", transform: "translateX(-50%)",
                background: "#FFFFFF", border: "1px solid #000", borderRadius: "3px",
                width: "14px", height: "14px", display: "flex", justifyContent: "center", 
                alignItems: "center", cursor: "pointer", zIndex: "999",
                filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))", marginLeft: "0" 
            });
            
            card.append(addNodeBtn);
        }
        container.append(label);
        this.counter++;

        return container;
    }

    async _roleProfileData(e){
        const t = Utils.createElem("ul");
        t.style.cssText = "display:flex; flex-direction:column; height:100%; row-gap:15px;"; 
        
        const roleDataFull = (e.type === 'ROLE') ? await e.roleData(`selfId=${e.kvdrRoleId}`) : await e.profileData(`userId=${e.profile[0].id}&kvdrRoleId=${e.kvdrRoleId}`);
        let _currentRoleData = roleDataFull[0];

        // --- CONSTANTS ---
        const DESC_UPDATE_PREFIX = "Updated Role Description: ";
        
        // Get Logs
        let allLogs = (_currentRoleData.description && Array.isArray(_currentRoleData.description)) ? _currentRoleData.description : [];
        
        // --- 1. DETERMINE CURRENT DESCRIPTION TO SHOW ---
        let staticDescription = "";
        
        // Look for the LATEST log that is a Description Update
        const latestDescLog = allLogs.slice().reverse().find(log => log.msg && log.msg.startsWith(DESC_UPDATE_PREFIX));

        // Priority 1: Latest Log in History
        if (latestDescLog) {
            // Remove the prefix to show just the text in the textarea
            staticDescription = latestDescLog.msg.substring(DESC_UPDATE_PREFIX.length);
            console.log("📜 [DESC LOG] Loaded description from latest history log.");
        } 
        // Priority 2: Standard DB Field
        else if (_currentRoleData.roleSummary && _currentRoleData.roleSummary !== "undefined") {
            staticDescription = _currentRoleData.roleSummary;
            console.log("📜 [DESC LOG] Loaded description from roleSummary field.");
        }

        // --- 2. NOTES VISIBILITY ---
        // We want these updates to be visible in notes now, so we pass allLogs.
        // You can filter out other system messages here if needed, but we keep Description updates.
        let visibleNotes = allLogs;

        // --- HEADER ---
        let currentTitleValue = _currentRoleData.title || "";
        let customHeader = null;
        if (e.type === 'ROLE') {
            customHeader = Utils.createElem("div");
            Utils.applyStyles(customHeader, { display: "flex", alignItems: "center", gap: "10px", width: "100%", paddingRight: "10px" });
            const titleInput = Utils.createElem("input", ["roleTitleInputHeader"], "", "");
            titleInput.value = currentTitleValue;
            titleInput.placeholder = "Role Name";
            Utils.applyStyles(titleInput, { fontSize: "1.2rem", fontWeight: "700", color: "#111827", border: "1px solid transparent", background: "transparent", width: "auto", minWidth: "250px", padding: "4px 8px", borderRadius: "4px", fontFamily: "inherit" });
            titleInput.addEventListener('input', (evt) => { currentTitleValue = evt.target.value; });
            customHeader.append(titleInput);
        }

        // --- UTILS ---
        const accessMap = { 'Appraisal (Self)': 'appraisalData', 'Fitment (Fit)': 'fitmentData', 'Performance (Drive)': 'performanceData', 'Succession (Secure)': 'successionData' };
        const roleAccess = { 0: ['Appraisal (Self)'], 1: ['Appraisal (Self)', 'Fitment \n(Fit)', 'Performance (Drive)'], 2: ['Appraisal (Self)', 'Fitment (Fit)', 'Performance (Drive)', 'Succession (Secure)'] };
        const allowedFields = roleAccess[this.role()] || [];

        const l = Utils.createElem("li");
        l.style.cssText = "border:2px solid #d0d5dd;border-radius:5px;display:flex;align-items:center;justify-content:space-between;";
        
        // ... [SKIPPED: Profile/Talent/Skills Rendering logic remains identical to previous version] ...
        if(e.profile.length && e.profile.length > 0){
             let ids = ''; for(let i=0;i<e.profile.length;i++){ ids = ids+'&userId='+e.profile[i].id; }
             const profileData = await e.profileData(`${ids}&kvdrRoleId=${e.kvdrRoleId}`);
             if(profileData.length){ this.assessmentData = []; for(let i=0;i<profileData.length;i++){ let entry = {}; allowedFields.forEach(field => { entry[field] = profileData[i][accessMap[field]] || ''; }); this.assessmentData.push(entry); } }
        }
        if(e.type === 'Talent'){
             const profileData = await e.profileData(`userId=${e.profile[0].id}&kvdrRoleId=${e.kvdrRoleId}`);
             if(profileData.length){ let entry = {}; allowedFields.forEach(field => { entry[field] = profileData[0][accessMap[field]] || ''; }); this.assessmentData = [entry]; }
             const a = Utils.createElem("label", "", "", ""); a.style.cssText = "display:flex;align-items:center;padding:5px;";
             const r = Utils.createElem("img", ["roleProfileImg"], "", ""); r.setAttribute("src", e.profile[0].imageUrl); r.style.cssText = "width:45px;height:45px;oveflow:hidden;object-fit:cover;object-position:center;border-radius:50%;margin-right:10px";
             const s = Utils.createElem("span", "", "", ""); s.style.cssText = "text-align:left;";
             const o = Utils.createElem("h5", "", "", e.profile[0].name); const n = Utils.createElem("span", "", "", e.profile[0].emailId); n.style.cssText = "font-size:1rem;font-weight:normal"; s.append(o, n);
             
             const i = Utils.createElem("span", ["removeRoleProfile"], "remove-role-profile-" + e.profile[0].id + "-btn", "-");
            i.style.cssText = "background:#FF0000;border-radius:50%;width:30px;height:30px;line-height:30px;font-size:30px;cursor:pointer;color:#FFF;margin-right:10px;margin-left:auto;display:flex;justify-content:center;align-items:center;padding-bottom:4px;";
     //  i.addEventListener("click", function () {
            //     let t = event.target.closest("div#candidate-list-popup").dataset.selectedNode;
            //     e.removeProfile({ userId: e.profile[0].id, kvdrRoleId: t });
            //     let rNode = document.querySelector('[data-empid="' + t + '"]');
            //     let sUsers = rNode.dataset.selectedUsr.split(",");
            //     let oIndex = sUsers.indexOf(e.profile[0].id);
            //     sUsers.splice(oIndex, 1);
            //     rNode.dataset.selectedUsr = sUsers;
            //     rNode.querySelector('img[id="img-' + e.profile[0].id + '"]').remove();
            //  });
            i.addEventListener("click", function (event) {
                event.preventDefault(); 
                event.stopPropagation();
                
                // JUST call this. 
                // Do NOT add any document.querySelector lines after this.
                // The removeProfile function defined in importNodeKVDR handles the DOM removal now.
                e.removeProfile({ 
                    userId: e.profile[0].id, 
                    kvdrRoleId: e.kvdrRoleId 
                });
            });
             a.append(r, s); l.append(a, i);
        } else {
             const skills = _currentRoleData['skills']||[]; const softSkills = _currentRoleData['softSkills']||[];
             const skillsContainer = Utils.createElem('div',["textCumItemBox"]); Utils.applyStyles(skillsContainer,{'display':'block',padding:'15px 10px',width:'100%',textAlign:'left',placeSelf:'flex-start'});
             const softSkillsContainer = Utils.createElem('div',["textCumItemBox"]); Utils.applyStyles(softSkillsContainer,{'display':'block',padding:'15px 10px',width:'100%',textAlign:'left',placeSelf:'flex-start'});
             const functionalSkillLabel = Utils.createElem('label', [], '', 'Functional Skills'); Utils.applyStyles(functionalSkillLabel, { fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '16px', color: '#000' }); 
             const softSkillLabel = Utils.createElem('label', [], '', 'Soft Skills'); Utils.applyStyles(softSkillLabel, { fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '16px', color: '#000' }); 
             const functionalSkillBox = this.createSkillSpan(skills,e.kvdrRoleId,e.roleUpdate,'skills');
             const softSkillBox = this.createSkillSpan(softSkills,e.kvdrRoleId,e.roleUpdate,'softSkills');
             const skillEntrBox = Utils.createSuggestiveDropDown(this.skills(),'functionalSkills','Add functional skill...'); 
             skillEntrBox.classList.add('edit-func-skill-input'); // <-- Add this class
             skillEntrBox.addEventListener('keydown',()=>this.updateRoleSkills(e.kvdrRoleId,functionalSkillBox,skills,e.roleUpdate,'skills'));
             
             const softSkillEntrBox = Utils.createSuggestiveDropDown(this.softSkills(),'softSkills','Add soft skill...'); 
             softSkillEntrBox.classList.add('edit-soft-skill-input'); // <-- Add this class
             softSkillEntrBox.addEventListener('keydown',()=>this.updateRoleSkills(e.kvdrRoleId,softSkillBox,softSkills,e.roleUpdate,'softSkills'));
             skillsContainer.append(functionalSkillLabel, skillEntrBox, functionalSkillBox); softSkillsContainer.append(softSkillLabel, softSkillEntrBox, softSkillBox);
             l.append(skillsContainer,softSkillsContainer);
        }

        // --- TABS UI ---
        const d = Utils.createElem("div");
        d.style.cssText = "display:flex; flex-direction:column; flex:1; row-gap:10px; min-height:0;"; // min-height is for flex bug fix

        const tabBtnsContainer = Utils.createElem("div");
        tabBtnsContainer.style.cssText = "gap:10px;display:flex;align-items:center;flex-wrap:wrap;";
        
        const contentContainer = Utils.createElem("div");
        Utils.applyStyles(contentContainer, { flex: '1', display: 'flex', flexDirection: 'column' });

        const btnStyle = `min-width:100px;height:40px;color:#646464;font-size:13px;text-align:center;border:none;border-radius:8px;cursor:pointer;font-weight:bold;padding:4px 10px;line-height:15px;transition:all 0.2s;background-color:#f0f0f0;`;
        const notesBtn = Utils.createElem("button", ["descBtn"]);
        notesBtn.style.cssText = `width: 40px; height: 40px; border: none; border-radius: 8px; cursor: pointer; padding: 4px 10px; background-color: #f0f0f0; background-image: url(${Comment}); background-position: center center; background-size: auto; background-repeat: no-repeat; margin-left: auto;`;
        notesBtn.title = "Notes & Logs";
        const roleDescWrapper = Utils.createElem('div'); 
        const notesWrapper = Utils.createElem("div");    
        const togglePopupFooter = (event, show) => {
        const popup = event.target.closest('.organiGramPopup');
        if (!popup) return;
        const footer = popup.querySelector('.OrganiGramPopupFooter');
        if (footer) {
            footer.style.display = show ? 'flex' : 'none';
        }
    };
        const switchTab = (viewName, targetBtn) => {
            contentContainer.innerHTML = "";
            Array.from(tabBtnsContainer.children).forEach(btn => {
                btn.style.backgroundColor = "#f0f0f0";
                btn.style.color = "#646464";
            });
            if(targetBtn){
                targetBtn.style.backgroundColor = e.displaySettings.cc;
                if(targetBtn !== notesBtn) targetBtn.style.color = e.displaySettings.tc;
            }
            if(viewName === 'DESC'){
                contentContainer.append(roleDescWrapper);
            } else if (viewName === 'NOTES') {
                contentContainer.append(notesWrapper);
            }
        };

        // --- TAB 1: ROLE DESCRIPTION ---
        if (e.type === 'ROLE') {
            const roleDescBtn = Utils.createElem("button", ["roleDescBtn"], "", "Role Description");
            roleDescBtn.style.cssText = btnStyle;
            roleDescBtn.addEventListener("click", (evt) => { evt.preventDefault(); switchTab('DESC', evt.currentTarget); 
                togglePopupFooter(evt, false);
                const popup = evt.target.closest('.organiGramPopup');
                if (popup) {
                    const footer = popup.querySelector('.OrganiGramPopupFooter');
                    if (footer) footer.style.display = 'none';
                }
            });
            tabBtnsContainer.append(roleDescBtn);

            if (!document.getElementById('textarea-scroll-styles')) {
                const style = document.createElement('style');
                style.id = 'textarea-scroll-styles';
                style.innerHTML = `.invisible-scroll-y { overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none; } .invisible-scroll-y::-webkit-scrollbar { display: none; }`;
                document.head.appendChild(style);
            }
            
            const roleDescTextarea = Utils.createElem("textarea", ["roleDescBox", "invisible-scroll-y"], "", "", {'placeholder':"Enter Role Description...", 'rows':5, 'maxlength':2000});
            // Increased padding-right to 75px to prevent text from overlapping with both buttons
            roleDescTextarea.style.cssText = `width:100%; height:240px; font-family:inherit; color:${e.displaySettings.tc}; resize:none; padding:15px; padding-right:75px; border-radius:10px; border:1px solid #ddd; box-sizing:border-box;`;

            let originalTitle = currentTitleValue;
            let originalDesc = staticDescription;
            roleDescTextarea.value = staticDescription;
            let roleDescTextareaRef = roleDescTextarea;

            Utils.applyStyles(roleDescWrapper, { position: 'relative', width: '100%', flex: 1, display: 'flex' });
            
            // AI Generate
            const aiGenerateBtn = Utils.createElem('button');
            aiGenerateBtn.title = "Use AI to enhance description";
            Utils.applyStyles(aiGenerateBtn, { position: 'absolute', top: '12px', right: '12px', background: '#f0f0f0', border: 'none', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: '2' });
            const aiIcon = Utils.createElem('img'); aiIcon.src = AIGenerateIcon; Utils.applyStyles(aiIcon, { width: '22px', height: '22px' }); aiGenerateBtn.append(aiIcon);
            aiGenerateBtn.addEventListener('click', async (event) => {
                event.preventDefault(); 
                aiIcon.classList.add('ai-icon-loading');
                try {
                     const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                     const response = await fetch(`${API_BASE_URL}/api/generate-role-description`, { 
                         method: 'POST', 
                         headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, 
                         body: JSON.stringify({ role_id: e.kvdrRoleId }) 
                     });
                     const data = await response.json();
                     
                     roleDescTextarea.value = data.description;
                     roleDescTextarea.dispatchEvent(new Event('input')); 
                     
                     // Helper to create visual pills and save to backend
                     const appendPillsEdit = (recommended, currentArray, container, apiFn, keyName, roleId) => {
                         if (!recommended || recommended.length === 0) return;
                         let addedNew = false;
                         
                         recommended.forEach(item => {
                             const cleanItem = item.trim();
                             if (!cleanItem || currentArray.some(s => s.toLowerCase() === cleanItem.toLowerCase())) return;
                             
                             currentArray.push(cleanItem);
                             addedNew = true;

                             const skillPill = Utils.createElem('span', [], '', '', { 'data-value': cleanItem });
                             Utils.applyStyles(skillPill, {
                                 background: '#fff', color: '#334155', borderRadius: '16px', 
                                 padding: '4px 8px 4px 12px', display: 'inline-flex', alignItems: 'center',
                                 gap: '6px', fontSize: '12px', border: '1px solid #e2e8f0',
                                 maxWidth: '100%', height: '24px', boxSizing: 'border-box', flexShrink: 0, marginTop: '0'
                             });

                             const skillText = Utils.createElem('span', [], '', cleanItem);
                             skillText.setAttribute('title', cleanItem);
                             Utils.applyStyles(skillText, { maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' });

                             const delSkillBtn = Utils.createElem('button', [], '', '×', { 'data-value': cleanItem });
                             Utils.applyStyles(delSkillBtn, {
                                 background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer',
                                 width: '16px', height: '16px', display: 'flex', alignItems: 'center',
                                 justifyContent: 'center', fontSize: '14px', fontWeight: 'bold', padding: '0', flexShrink: 0
                             });

                             delSkillBtn.addEventListener('click', () => this.delRoleSkill(skillPill, roleId, apiFn, currentArray, keyName));

                             skillPill.append(skillText, delSkillBtn);
                             container.append(skillPill);
                         });
                         
                         if (addedNew && apiFn) {
                             apiFn({ query: roleId, data: { [keyName]: currentArray } });
                         }
                         container.scrollTop = container.scrollHeight;
                     };

                     // --- FIX STARTS HERE ---
                     // Re-fetch the current skill arrays from the parent scope to resolve the ReferenceError.
                     const skills = _currentRoleData['skills'] || [];
                     const softSkills = _currentRoleData['softSkills'] || [];
                     // --- FIX ENDS HERE ---

                     // Target containers and add recommendations
                     appendPillsEdit(data.recommended_technical_skills, skills, functionalSkillBox, e.roleUpdate, 'skills', e.kvdrRoleId);
                     appendPillsEdit(data.recommended_soft_skills, softSkills, softSkillBox, e.roleUpdate, 'softSkills', e.kvdrRoleId);
                     
                } catch(err){ 
                    console.error("AI Generation Error:", err); 
                } finally { 
                    aiIcon.classList.remove('ai-icon-loading'); 
                }
            });

            // Save Button (Tick Icon)
            const saveBtn = Utils.createElem("button", ["saveRoleTickBtn"], "", "");
            const tickIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-check"]);
            Utils.applyStyles(tickIcon, { fontSize: "18px", color: "#fff", fontWeight: "bold" });
            saveBtn.append(tickIcon);
            Utils.applyStyles(saveBtn, { position: 'absolute', bottom: '12px', right: '12px', backgroundColor: "#28c76f", border: "none", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 5px rgba(0,0,0,0.2)", zIndex: "3", transition: "all 0.2s", opacity: "0", transform: "scale(0.8)", pointerEvents: "none" });

            const checkDirty = () => {
                if (currentTitleValue !== originalTitle || roleDescTextarea.value !== originalDesc) {
                    saveBtn.style.opacity = "1"; saveBtn.style.transform = "scale(1)"; saveBtn.style.pointerEvents = "all";
                } else {
                    saveBtn.style.opacity = "0"; saveBtn.style.transform = "scale(0.8)"; saveBtn.style.pointerEvents = "none";
                }
            };
            roleDescTextarea.addEventListener('input', checkDirty);
            const headerInput = customHeader ? customHeader.querySelector('input') : null;
            if(headerInput) headerInput.addEventListener('input', checkDirty);

            // ----------------------------------------------------------------------
            // DESCRIPTION SAVE HANDLER: LOGIC CHANGED HERE
            // ----------------------------------------------------------------------
            saveBtn.addEventListener('click', async (evt) => {
                evt.preventDefault(); evt.stopPropagation();
                let currentDescValue = "";
                if(roleDescTextareaRef) currentDescValue = roleDescTextareaRef.value;
                
                console.log("💾 [DESC LOG] Save clicked. New text length:", currentDescValue.length);

                // --- 1. CREATE NEW LOG ENTRY ---
                // We do NOT remove old entries. We ADD a new one so history is preserved in Notes.
                const newLog = { 
                    msg: DESC_UPDATE_PREFIX + currentDescValue, // Add Prefix so we can find it later
                    userId: this.user()._id, 
                    createdAt: new Date() 
                };
                
                // Append new log to the end of array
                const newLogs = [...allLogs, newLog];

                console.log("💾 [DESC LOG] Logs updated. Count:", newLogs.length);

                tickIcon.className = "vs-icon notranslate icon-scale feather icon-loader ai-icon-loading"; 
                try {
                    const param = { 
                        query: e.kvdrRoleId, 
                        data: { 
                            title: currentTitleValue, 
                            roleSummary: currentDescValue, // Also update summary for quick access
                            description: newLogs           // Save the full history
                        } 
                    };
                    await e.roleUpdate(param);
                    
                    if (this.config().data && this.config().data.graphData) {
                        const localNode = safeGraphData(this.config()).find(n => n.selfId === e.kvdrRoleId);
                        if (localNode) {
                            localNode.title = currentTitleValue;
                            localNode.roleSummary = currentDescValue;
                            localNode.description = newLogs;
                        }
                    }
                    originalTitle = currentTitleValue;
                    originalDesc = currentDescValue;
                    allLogs = newLogs; // Update local reference
                    
                    // Update header title visually
                    const cardTitle = document.querySelector(`[data-empid='${e.kvdrRoleId}'] .role-card-title`);
                    if(cardTitle) cardTitle.innerText = currentTitleValue;

                    // Update Notes Tab View if it exists
                    // We don't filter out description logs anymore
                    const oldHistory = notesWrapper.querySelector('.descLogsBox');
                    if(oldHistory) oldHistory.remove();
                    const newHistory = this.descriptionLogs(allLogs, notesLogTextarea);
                    notesWrapper.append(newHistory);

                    if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
                    setTimeout(() => { tickIcon.className = "vs-icon notranslate icon-scale feather icon-check"; checkDirty(); }, 500);
                } catch(err) { console.error(err); alert("Failed."); tickIcon.className = "vs-icon notranslate icon-scale feather icon-x"; }
            });

            roleDescWrapper.append(roleDescTextarea, aiGenerateBtn, saveBtn);
        }

        // --- TAB 2: Assessments ---
        if (this.assessmentData) {
            allowedFields.forEach((item) => {
                if (!item) return;
                const btn = Utils.createElem("button", ["tabBtn"], "", item);
                btn.style.cssText = `min-width:100px;height:40px;color:#646464;font-size:13px;text-align:center;border:none;border-radius:8px;cursor:pointer;font-weight:bold;padding:4px 10px;line-height:15px;transition:all 0.2s;background-color:#f0f0f0;`;
                btn.value = accessMap[item.trim()];
                
                btn.addEventListener("click", (evt) => {
                    togglePopupFooter(evt, true);
                    evt.preventDefault();
                    const popup = evt.target.closest('.organiGramPopup');
                    if (popup) {
                        const footer = popup.querySelector('.OrganiGramPopupFooter');
                        if (footer) footer.style.display = 'flex'; // Use 'flex' to show it
                    }
                    
                    // !!! IMPORTANT CHANGE HERE !!! 
                    // We are passing 'e.type' as the 8th argument. 
                    // This tells the next function if we are in 'ROLE' mode or 'Talent' mode.
                    this.createRelativeUsrData(
                        this.assessmentData, 
                        e.kvdrOrgConfigData, 
                        evt.target, 
                        e.profile, 
                        contentContainer, 
                        e.profileUpdate, 
                        e.displaySettings, 
                        e.type // <--- THIS MUST BE HERE
                    );
                });
                tabBtnsContainer.append(btn);
            });
        }

        
        // --- TAB 3: NOTES ---
        notesBtn.addEventListener("click", (evt) => { evt.preventDefault(); switchTab('NOTES', evt.currentTarget); 
            togglePopupFooter(evt, false);
            const popup = evt.target.closest('.organiGramPopup');
            if (popup) {
                const footer = popup.querySelector('.OrganiGramPopupFooter');
                if (footer) footer.style.display = 'none';
            }
        });
        tabBtnsContainer.append(notesBtn);
        Utils.applyStyles(notesWrapper, { position: "relative", width: "100%" });

        const notesLogTextarea = Utils.createElem("textarea",["descBox"], "", "", {'placeholder':"Add a new note...",'rows':5,'maxlength':2500});
        notesLogTextarea.style.cssText = `width:100%;height:240px;font-family:inherit;color:${e.displaySettings.tc};resize:none;padding:10px;padding-right:60px;border-radius:10px;border:1px solid #ddd;`;
        
        const notesSaveBtn = Utils.createElem("button", ["saveNoteBtn"], "", "");
        const noteTickIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-check"]);
        Utils.applyStyles(noteTickIcon, { fontSize: "18px", color: "#fff", fontWeight: "bold" });
        notesSaveBtn.append(noteTickIcon);
        Utils.applyStyles(notesSaveBtn, { position: 'absolute', top: '190px', right: '12px', backgroundColor: "#28c76f", border: "none", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 5px rgba(0,0,0,0.2)", zIndex: "3", transition: "all 0.2s", opacity: "0", transform: "scale(0.8)", pointerEvents: "none" });

        notesLogTextarea.addEventListener('input', () => {
            if(notesLogTextarea.value.trim().length > 0) {
                notesSaveBtn.style.opacity = "1"; notesSaveBtn.style.transform = "scale(1)"; notesSaveBtn.style.pointerEvents = "all";
            } else {
                notesSaveBtn.style.opacity = "0"; notesSaveBtn.style.transform = "scale(0.8)"; notesSaveBtn.style.pointerEvents = "none";
            }
        });

        notesSaveBtn.addEventListener('click', async (evt) => {
            evt.preventDefault(); evt.stopPropagation();
            const noteText = notesLogTextarea.value.trim();
            if(!noteText) return;
            noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-loader ai-icon-loading";

            const newLog = { msg: noteText, userId: this.user()._id, createdAt: new Date() };
            // Add note to ALL logs
            const updatedLogs = [...allLogs, newLog];
            
            const param = {
                query : e.type === 'ROLE' ? e.kvdrRoleId : `userId=${e.profile[0].id}&kvdrRoleId=${e.kvdrRoleId}`,
                data : { description: updatedLogs }
            };

            try {
                e.type === 'ROLE' ? await e.roleUpdate(param) : await e.profileUpdate(param);
                if (this.config().data && this.config().data.graphData) {
                    const localNode = safeGraphData(this.config()).find(n => n.selfId === e.kvdrRoleId);
                    if (localNode) localNode.description = updatedLogs;
                }
                allLogs = updatedLogs;
                
                // Refresh Logs View
                const oldHistory = notesWrapper.querySelector('.descLogsBox');
                if(oldHistory) oldHistory.remove();
                // Pass ALL LOGS so Description Updates are visible here too
                const newHistory = this.descriptionLogs(allLogs, notesLogTextarea);
                notesWrapper.append(newHistory);
                
                notesLogTextarea.value = "";
                notesSaveBtn.style.opacity = "0"; notesSaveBtn.style.transform = "scale(0.8)"; notesSaveBtn.style.pointerEvents = "none";
                if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
                setTimeout(() => { noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-check"; }, 500);
            } catch(err) { console.error(err); noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-x"; }
        });

        // Initial Logs Render: Pass ALL LOGS so users see description updates mixed with notes
        let notesLogHistory = this.descriptionLogs(allLogs, notesLogTextarea);
        notesWrapper.append(notesLogTextarea, notesSaveBtn, notesLogHistory);
        
        if (e.type === 'ROLE') {
            const roleBtn = tabBtnsContainer.querySelector('.roleDescBtn');
            if(roleBtn) {
                roleBtn.click();
                togglePopupFooter({ target: roleBtn }, false);
            }
        } else {
            // This is the 'Talent Evaluation' view
            const firstButton = tabBtnsContainer.querySelector('button');
            if (firstButton) { 
                firstButton.click(); 
                // Since the default tab is an evaluation tab, show the footer immediately.
                //togglePopupFooter({ target: firstButton }, true); // <--- THIS IS THE FIX
            } 
            else { contentContainer.innerHTML = "<p>No evaluation data available.</p>"; }
        }

        d.append(tabBtnsContainer, contentContainer);
        t.append(l, d);
        return { content: t, customHeader: customHeader };
    }
    toggleLoadingScreen(show, message = "Updating Organization...") {
        let loader = document.getElementById('organigram-global-loader');
        
        // --- FIX 1: FORCE COLOR UPDATE ---
        // If the loader already exists, find the spinner and force it to be Yellow
        if (loader) {
            const existingSpinner = loader.querySelector('div');
            if(existingSpinner) {
                existingSpinner.style.borderTop = "5px solid #F2C244"; // Force Yellow
            }
        }

        // Create loader if it doesn't exist
        if (!loader) {
            loader = document.createElement("div");
            loader.id = 'organigram-global-loader';
            
            // Container Styles
            Object.assign(loader.style, {
                position: "fixed", top: "0", left: "0", width: "100%", height: "100%",
                backgroundColor: "rgba(255, 255, 255, 0.85)", zIndex: "99999",
                display: "none", flexDirection: "column", alignItems: "center", justifyContent: "center",
                backdropFilter: "blur(4px)"
            });

            // CSS Spinner
            const spinner = document.createElement("div");
            Object.assign(spinner.style, {
                width: "50px", 
                height: "50px", 
                border: "5px solid #f3f3f3", 
                borderTop: "5px solid #FFC107", // <--- YELLOW COLOR
                borderRadius: "50%",
                animation: "spin 1s linear infinite", 
                marginBottom: "20px"
            });
            
            // Add Animation Keyframes
            if (!document.getElementById('organigram-spinner-style')) {
                const styleSheet = document.createElement("style");
                styleSheet.id = 'organigram-spinner-style';
                styleSheet.innerText = `@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;
                document.head.appendChild(styleSheet);
            }

            // Text
            const text = document.createElement("h3");
            text.id = 'organigram-loader-text';
            Object.assign(text.style, { color: "#333", fontFamily: "inherit" });

            loader.append(spinner, text);
            document.body.append(loader);
        }

        // Update Text & Visibility
        if (show) {
            document.getElementById('organigram-loader-text').innerText = message;
            loader.style.display = "flex";
        } else {
            loader.style.display = "none";
        }
    }
    async handleNodeMove(draggedId, newParentId) {
        // 1. Circular Check
        const currentData = this.config().data.graphData;
        if (this.isDescendant(draggedId, newParentId, currentData)) {
            this.showToast("Cannot move a role under its own subordinate!", "error");
            return;
        }

        // 2. SHOW LOADING SCREEN
        this.toggleLoadingScreen(true, "Reorganizing Structure...");

        // Backup for rollback
        const originalData = JSON.parse(JSON.stringify(currentData));

        try {
            // 3. API UPDATE (Save to DB)
            const param = { query: draggedId, data: { parentId: newParentId } };
            await this.config().onNodeUpdate(param);

            // 4. DELAY (Wait for DB to settle)
            await new Promise(resolve => setTimeout(resolve, 1500));

            // 5. ATTEMPT FETCH
            let freshData = null;
            try {
                const query = `kvdrId=${this.config().id}`;
                let response = await this.config().onNodeFetch(query);
                if (response && response.data) response = response.data;
                freshData = response;
            } catch (err) {
                console.warn("Fetch failed, switching to local update mode.");
            }

            // 6. INTELLIGENT UPDATE
            if (Array.isArray(freshData) && freshData.length > 0) {
                this.config().data.graphData = freshData;
            } else {
                // Fail-safe: Update locally if server list is empty
                const node = safeGraphData(this.config()).find(n => n.selfId === draggedId);
                if (node) node.parentId = newParentId;
            }

            // 7. RENDER CHART
            this.createKVDR(this.config());
            
            // --- REMOVED THE DUPLICATE SUCCESS TOAST HERE ---
            // The global system notification ("Role Update") will handle it now.

            if (typeof Utils.playBellSound === 'function') {
                Utils.playBellSound(800, 840, 'square');
            }

        } catch (error) {
            console.error("Critical Failure:", error);
            
            // ROLLBACK
            this.config().data.graphData = originalData;
            this.createKVDR(this.config());

            this.showToast("Move failed. Restoring previous state.", "error");
        } finally {
            // 8. HIDE LOADER
            this.toggleLoadingScreen(false);
        }
    }

    // Helper to prevent infinite loops
    isDescendant(draggedId, targetId, graphData) {
        if (draggedId === targetId) return true;
        let current = graphData.find(n => n.selfId === targetId);
        while (current) {
            if (current.parentId === draggedId) return true;
            current = graphData.find(n => n.selfId === current.parentId);
        }
        return false;
    }

    // Helper for nice notifications
    showToast(message, type = "info") {
        // Remove existing toasts first to prevent stacking
        const existing = document.querySelector('.organigram-toast');
        if(existing) existing.remove();

        const toast = document.createElement("div");
        toast.className = 'organigram-toast';
        toast.innerText = message;
        
        let bg = "#333"; // info
        if(type === 'success') bg = "#00b894";
        if(type === 'error') bg = "#d63031";

        Object.assign(toast.style, {
            position: "fixed", bottom: "30px", right: "30px",
            background: bg, color: "#fff", padding: "12px 24px", 
            borderRadius: "8px", boxShadow: "0 5px 15px rgba(0,0,0,0.2)", 
            zIndex: "10000", fontWeight: "600", fontSize: "14px", 
            transition: "all 0.3s ease", opacity: "0", transform: "translateY(10px)"
        });

        document.body.appendChild(toast);
        
        // Animation
        requestAnimationFrame(() => {
            toast.style.opacity = "1";
            toast.style.transform = "translateY(0)";
        });

        setTimeout(() => {
            toast.style.opacity = "0";
            toast.style.transform = "translateY(10px)";
            setTimeout(() => toast.remove(), 300);
        }, 3000);
    }

    confirmMovePopup(draggedName, targetName, onConfirm) {
    const wrapper = Utils.createElem("div");
    Utils.applyStyles(wrapper, {
        padding: "16px 20px",
        textAlign: "left" // 🔥 LEFT ALIGN EVERYTHING
    });

    // Warning Icon (left aligned, inline with text style)
    const icon = Utils.createElem("div", [], "", "⚠️");
    Utils.applyStyles(icon, {
        fontSize: "28px",
        marginBottom: "10px",
        marginTop: "-8px" // 🔥 pulls icon upward
    });

    // Title
    const msg = Utils.createElem("h3", [], "", "Change Reporting Line?");
    Utils.applyStyles(msg, {
        margin: "0 0 8px 0",
        color: "#111",
        fontSize: "18px",
        fontWeight: "600",
        textAlign: "left"
    });

    // Description
    const desc = Utils.createElem(
        "p",
        [],
        "",
        `Are you sure you want to move <b>${draggedName}</b> to report under <b>${targetName}</b>?`
    );
    Utils.applyStyles(desc, {
        margin: "0",
        color: "#555",
        fontSize: "14px",
        lineHeight: "1.6",
        textAlign: "left"
    });

    wrapper.append(icon, msg, desc);

    // Confirm Button (Yellow like Pic 2)
    const confirmBtn = Utils.createElem("button", [], "", "Yes, Move it");
    Utils.applyStyles(confirmBtn, {
        background: "#ffc107",        // 🔥 YELLOW BUTTON
        color: "#000",
        border: "none",
        padding: "10px 24px",         // 🔥 BETTER BUTTON PADDING
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "600",
        fontSize: "14px"
    });

    // Popup
    const backdrop = document.getElementById("back-drop-overlay");

    const popupConfig = {
        headerText: "Confirm Reorganization",
        onCloseClick: () => {
            backdrop.style.display = "none";
            backdrop.innerHTML = "";
            isViewportActive.status = true;
        },
        data: wrapper,
        displaySettings: { width: "420px" }, // Slightly wider like Pic 2
        footer: confirmBtn
    };

    const popup = this.createPopup(popupConfig);

    // Confirm Action
    confirmBtn.addEventListener("click", () => {
        backdrop.style.display = "none";
        backdrop.innerHTML = "";
        isViewportActive.status = true;
        onConfirm();
    });

    backdrop.innerHTML = "";
    backdrop.append(popup);
    backdrop.style.display = "flex";
}

    async createNode(e,p){
        event.preventDefault();
        event.stopPropagation();
        const nodeId = Utils.randomString(24);
        const parent = event.target.closest(".member");
        let parentId = parent.dataset.empid || 0;
        
        this.addRolePopup(e,p,parentId,nodeId)
        .then(res => {
            if (res && (res._id || res.selfId)) {
                res['profiles'] = [];
                
                // --- CRITICAL FIX: Safe Array Push ---
                // Guarantee that data and graphData exist as an Array before pushing to prevent the TypeError
                if (!this.config().data) {
                    this.config().data = { graphData: [] };
                } else if (!Array.isArray(this.config().data.graphData)) {
                    this.config().data.graphData = [];
                }
                this.config().data.graphData.push(res);
                // -------------------------------------
                
                // Construct a clean config for the new node so we don't overwrite the parent's data
                const newNodeData = {
                    ...e,                  // Inherit base configurations (methods, display settings)
                    ...res,                // Apply the newly created role's data
                    selfId: res.selfId || res._id || nodeId,
                    parentId: parentId,
                    isCurrentUserNode: false // User is not assigned to this new pending role
                };

                // Draw it immediately (it will automatically be dimmed because status is 'pending')
                const node = this.importNodeKVDR(newNodeData, p);
                
                // Attach it to the screen instantly
                parent.append(node);
                
                // Play a tiny confirmation sound to let the user know it appeared
                if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'sine');
            } 
        }).catch(err => console.error("Error creating node:", err));
    }
    async addNodeKVDR(e,p,parentId,nodeId,title,parent) {
        const newNode = Utils.createElem("div", ["member"],"","",{"data-selected-usr":"","data-empid" : nodeId,"data-parentid":parentId});
        newNode.addEventListener("click", (event) => event.preventDefault());
        
        const addUserIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
        Utils.applyStyles(addUserIcon, { fontSize: "14px", color: "#28c76f" });

        const addUserButton = Utils.createElem("button", ["openUsrListBtn"]);
        Utils.applyStyles(addUserButton, {
            border: "1px solid #ddd",
            background: "#fff", 
            cursor: "pointer",
            borderRadius: "50%",
            width: "24px", 
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0",
            marginLeft: "8px"
        });
        
        addUserButton.setAttribute("title", "Add Team Member");
        addUserButton.append(addUserIcon);
        
        addUserButton.addEventListener("click",()=>{
            const popupConfig = {
                headerText: "Select User(s)",
                onCloseClick: () => { event.stopPropagation(); p.style.display = "none"; p.innerHTML = ""; isViewportActive.status = true; },
                data: this._popupUsrListCollection(event, e, p),
                displaySettings: e.displaySettings, footer: "",
            };
            const popup = this.createPopup(popupConfig);
            e.addUsersToDesig(popup);
        });

        const selectedUserImg = Utils.createElem("img", ["selectedUsrImg"]);
        Utils.applyStyles(selectedUserImg, {
            position: "relative", marginLeft: "-5px", width: "32px", height: "32px",
            objectFit: "cover", objectPosition: "center", border: "2px solid", borderRadius: "50%", display: "none",
        });

        const selectedUserBox = Utils.createElem("span", ["selectedUsrBox"]);
        Utils.applyStyles(selectedUserBox, { display: "flex", margin: "10px 5px", alignItems: "center" });
        selectedUserBox.append(selectedUserImg, addUserButton);

        const titleBox = Utils.createElem("i", [], "", title, { contentEditable: "true" });
        Utils.applyStyles(titleBox, { display: "flex", alignItems: "center", marginRight: "20px" });
        titleBox.addEventListener("focusout", () => e.onNodeUpdate({ data: { title: event.target.innerText }, query: nodeId }));
        
        const titleWrapper = Utils.createElem("div");
        Utils.applyStyles(titleWrapper, { display: "flex", alignItems: "center" });
        titleWrapper.append(titleBox,selectedUserBox);

        const deleteBtn = Utils.createElem("i", ["deleteNodeBtn", "vs-icon", "notranslate", "icon-scale", "feather", "icon-x"], "", "");
        Utils.applyStyles(deleteBtn, { cursor: "pointer", fontSize: "16px", color: "#000" });
        deleteBtn.setAttribute("title", "Delete Role"); 
        deleteBtn.dataset.removenode = true;
        
        const deleteNodeData = {
            target: newNode, deleteNode: (target) => e.onNodeDelClick(target), deleteProfile: (target) => e.onNodeRemoveProfileClick(target),
            popupBody: p, displaySettings: e.displaySettings,
        };
        deleteBtn.addEventListener("click", () => this.delNodeKVDR(deleteNodeData));

        const deleteBtnWrapper = Utils.createElem("div", ["delNodeBtnBox", "node-action-icon"]); 
        Utils.applyStyles(deleteBtnWrapper, { position: "absolute", top: "10px", right: "10px", zIndex: "5" });
        deleteBtnWrapper.append(deleteBtn);

        const expandBtn = Utils.createElem("img", ["roleExpandBtn", "node-action-icon"], "", "", { src: FullScreen }); 
        Utils.applyStyles(expandBtn, { width: "13px", height: "13px", filter: "invert(0)", position: "absolute", right: "0px", bottom: "0px" });
        const expandConfig = {
            kvdrRoleId: nodeId, candidateList: e.candidateList, kvdrOrgConfigData: e.data.kvdrOrgConfigData,
            removeProfile: (target) => { e.onNodeRemoveProfileClick(target); selectedUserImg.innerHTML = ""; selectedUserImg.style.display = "none"; },
            profileData: async (data) => e.onNodeProfileFetch(data), profileUpdate: async (data) => e.onNodeProfileUpdate(data),
            roleData: async (data) => e.onNodeFetch(data), roleUpdate: async (data) => e.onNodeUpdate(data),
            displaySettings: e.displaySettings,
        };
        expandBtn.addEventListener("click", async () => this.expandRole(expandConfig,'ROLE'));

        const footerLeft = Utils.createElem("div", ["roleFooterLeft"]);
        const footerRight = Utils.createElem("div", ["roleFooterRight"]);
        footerRight.append(expandBtn);

        const footer = Utils.createElem("div", ["roleFooter"]);
        Utils.applyStyles(footer, { border: "none", padding: "5px 0px", display: "flex", alignItems: "center", justifyContent: "space-between", flex: "1 1 100%", position: "relative" });
        footer.append(footerLeft, footerRight);

        // --- UPDATED: Add 'node-hover-target' to CARD ---
        const userCard = Utils.createElem("fieldset", ["userCard", "onlyCardType", "node-hover-target"]);
        Utils.applyStyles(userCard, { backgroundColor: e.displaySettings.cc, color: e.displaySettings.tc, borderColor: e.displaySettings.bc, flexWrap: "wrap", position: "relative" });
        
        const addNodeBtn = Utils.createElem("div", ["toggleBtn", "addNodeBtn", "node-action-icon"], "", "", {"data-addnode": "true"}); 
        
        const plusIconImg = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
        Utils.applyStyles(plusIconImg, { fontSize: "10px", fontWeight: "900", display: "block", color: "#000" });

        addNodeBtn.append(plusIconImg);
        
        addNodeBtn.addEventListener('click',()=>this.createNode(e,p));
        
        Utils.applyStyles(addNodeBtn, {
             position: "absolute", 
             bottom: "-32px", 
             left: "50%", 
             transform: "translateX(-50%)",
             background: "#FFFFFF", 
             border: "1px solid #000", 
             borderRadius: "3px",
             width: "14px",
             height: "14px",
             display: "flex", 
             justifyContent: "center", 
             alignItems: "center",
             cursor: "pointer", 
             zIndex: "999",
             filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))",
             marginLeft: "0" 
        });

        userCard.append(deleteBtnWrapper, titleWrapper, footer);
        
        // --- UPDATED: Append Add Btn to CARD ---
        userCard.append(addNodeBtn);

        // --- UPDATED: Remove 'node-hover-target' from label ---
        const label = Utils.createElem("label", ["emptitle"]); 
        Utils.applyStyles(label, { position: "relative", overflow: "visible !important" });
        label.append(userCard);
        newNode.append(label);
        parent.append(newNode);

        this.counter++;
    }
    
    addRolePopup = async(e,p,parentId,nodeId) => {
        return new Promise((resolve, reject) => {
            let skills =[]; let softSkills = [];
            
            // Main Wrapper: Fills the fixed 650px popup body
            const wrapper = Utils.createElem('div');
            Utils.applyStyles(wrapper,{
                display:'flex', gap:'15px', flexFlow:'column', height: '100%', boxSizing: 'border-box'
            });
            
            // --- Title and Level Row ---
            const titleRow = Utils.createElem('div');
            Utils.applyStyles(titleRow, {
                display: 'flex',
                alignItems: 'center',
                borderBottom: `2px solid #e5e7eb`,
                paddingBottom: '5px',
                flexShrink: 0
            });

            // Designation Input
            const roleTitle = Utils.createElem('input',[],'','',{'placeholder':'Designation'});
            Utils.applyStyles(roleTitle,{
                border:'none', fontFamily:'inherit',
                padding:'10px 5px', fontSize: '16px', fontWeight: 'bold', outline: 'none',
                flexGrow: '1' // Title input takes available space
            });

            // --- FIX START: Use the robust getDynamicConfig helper ---
            const initialConfig = this.config().data?.kvdrOrgConfigData;
            const dynamicConfig = this.getDynamicConfig(initialConfig);
            const levelOptions = dynamicConfig?.level?.values || [];
            // --- FIX END ---

            // Create the level dropdown
            // const levelDropdown = this._createLevelDropdown(levelOptions, null);

            titleRow.append(roleTitle);
            
            // Skills Row (Fixed Height)
            const skillSection = Utils.createElem('div')
            Utils.applyStyles(skillSection,{
                display:'flex', gap:'20px', alignItems:'flex-start', width:'100%', height: '150px', flexShrink: 0
            });

            // Functional Skills
            const functionalSkillContainer = Utils.createElem('div');
            Utils.applyStyles(functionalSkillContainer,{flex:'1', minWidth: '0', display: 'flex', flexDirection: 'column'});

            const functionalSkillBox = Utils.createElem('div');
            Utils.applyStyles(functionalSkillBox, {
                marginTop: '5px', display: 'flex', flexWrap: 'wrap', gap: '6px', alignContent: 'flex-start',
                height: '80px', overflowY: 'auto', width: '100%', padding: '4px',
                border: '1px solid #f1f5f9', borderRadius: '6px', background: '#fafafa', boxSizing: 'border-box'
            });
            
            const functionalSkillInput = Utils.createSuggestiveDropDown(this.skills(),'functionalSkills','Functional Skills');
            functionalSkillInput.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    this.updateRoleSkills('',functionalSkillBox,skills,'','functionalSkills');
                }
            });
            
            const skillSeprator = Utils.createElem('span');
            Utils.applyStyles(skillSeprator,{width:'1px', background:'#E5E7EB', height: '100%'});
            
            // Soft Skills
            const behavioralSkillContainer = Utils.createElem('div');
            Utils.applyStyles(behavioralSkillContainer,{flex:'1', minWidth: '0', display: 'flex', flexDirection: 'column'});

            const behavioralSkillBox = Utils.createElem('div');
            Utils.applyStyles(behavioralSkillBox, {
                marginTop: '5px', display: 'flex', flexWrap: 'wrap', gap: '6px', alignContent: 'flex-start',
                height: '80px', overflowY: 'auto', width: '100%', padding: '4px',
                border: '1px solid #f1f5f9', borderRadius: '6px', background: '#fafafa', boxSizing: 'border-box'
            });

            const behavioralSkillInput = Utils.createSuggestiveDropDown(this.softSkills(),'behavioralSkills','Soft Skills');
            behavioralSkillInput.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    this.updateRoleSkills('',behavioralSkillBox,softSkills,'','behavioralSkills');
                }
            });
            
            // Description: Flex 1 (Fills remaining height)
            if (!document.getElementById('textarea-scroll-styles')) {
                const style = document.createElement('style');
                style.id = 'textarea-scroll-styles';
                style.innerHTML = `.invisible-scroll-y { overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none; } .invisible-scroll-y::-webkit-scrollbar { display: none; }`;
                document.head.appendChild(style);
            }

                const roleDescription = Utils.createElem("textarea", ["descBox", "invisible-scroll-y"], "", "", {'placeholder':"Insert Role Description", 'maxlength':2500});            
                roleDescription.style.cssText = `
                width: 100%; flex: 1; min-height: 100px; fontFamily: inherit; color: ${e.displaySettings.tc};
                resize: none; padding: 15px; padding-right: 65px; borderRadius: 8px; border: 1px solid #e5e7eb; box-sizing: border-box;
                overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;
            `;

            const descWrapper = Utils.createElem('div');
            Utils.applyStyles(descWrapper, { position: 'relative', width: '100%', flex: '1', display: 'flex', flexDirection: 'column' });

            const aiGenerateBtn = Utils.createElem('button');
            aiGenerateBtn.title = "Use AI to enhance description";
            Utils.applyStyles(aiGenerateBtn, {
                position: 'absolute', bottom: '15px', right: '15px', background: '#f0f0f0',
                border: 'none', borderRadius: '50%', width: '36px', height: '36px',
                display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                zIndex: '2', transition: 'all 0.2s ease'
            });
            const aiIcon = Utils.createElem('img');
            aiIcon.src = AIGenerateIcon;
            Utils.applyStyles(aiIcon, { width: '20px', height: '20px' });
            aiGenerateBtn.append(aiIcon);
            
            aiGenerateBtn.addEventListener('click', async (event) => {
                event.preventDefault();
                const title = roleTitle.value;
                if (!title) { alert("Please enter a Designation first."); return; }
                aiIcon.classList.add('ai-icon-loading'); aiGenerateBtn.disabled = true;
                try {
                    const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                    const response = await fetch(`${API_BASE_URL}/api/generate-role-description`, {
                        method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ role_id: "new_role", role_title: title, technical_skills: skills, soft_skills: softSkills })
                    });
                    const data = await response.json();
                    
                    roleDescription.value = data.description;
                    roleDescription.dispatchEvent(new Event('input'));
                    
                    // --- FIX STARTS HERE ---
                    if (data.recommended_technical_skills && data.recommended_technical_skills.length > 0) {
                        const funcInput = functionalSkillInput.querySelector('input'); // Get the actual input element
                        if (funcInput) {
                            const currentVal = funcInput.value.trim();
                            const newSkillsStr = data.recommended_technical_skills.join(', ');
                            funcInput.value = currentVal ? currentVal + ', ' + newSkillsStr : newSkillsStr;
                        }
                    }
                    if (data.recommended_soft_skills && data.recommended_soft_skills.length > 0) {
                        const softInput = behavioralSkillInput.querySelector('input'); // Get the actual input element
                        if (softInput) {
                            const currentVal = softInput.value.trim();
                            const newSkillsStr = data.recommended_soft_skills.join(', ');
                            softInput.value = currentVal ? currentVal + ', ' + newSkillsStr : newSkillsStr;
                        }
                    }
                    // --- FIX ENDS HERE ---

                } catch (error) { console.error("AI Generation Error:", error); alert("AI Generation Failed"); } 
                finally { aiIcon.classList.remove('ai-icon-loading'); aiGenerateBtn.disabled = false; }
            });
            descWrapper.append(roleDescription, aiGenerateBtn);

            const charCount = Utils.createElem("div", [], "", "0/2500");
            Utils.applyStyles(charCount, { textAlign: "right", fontSize: "11px", color: "#9ca3af", marginTop: "4px" });
            roleDescription.addEventListener("input", function() { charCount.innerText = `${this.value.length}/2500`; });

            const roleBtn = Utils.createElem('button','','',this.can('addRoleRequest')?'Request Role':'Create Role');
            Utils.applyStyles(roleBtn,{
                background:`${e.displaySettings.cc}`, border:'none', padding:'8px 16px',
                borderRadius:'6px', fontFamily:'inherit', cursor:'pointer', fontWeight: '600', color: '#fff'
            });

            let isKvdrActive = false;
            const kvdrBtnContainer = Utils.createElem("div");
            Utils.applyStyles(kvdrBtnContainer, { display: "flex", alignItems: "center", marginRight: "12px", cursor: "pointer" });
            const kvdrIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-award"]);
            Utils.applyStyles(kvdrIcon, { fontSize: "20px", color: "#6b7280", transition: "color 0.2s ease" });
            kvdrBtnContainer.append(kvdrIcon);
            this.attachTooltip(kvdrBtnContainer, "Make role Key Value Drive Role (KVDR)");

            // FIX: Use .onclick to prevent duplicate firing
            kvdrBtnContainer.onclick = (evt) => {
                evt.stopPropagation();
                isKvdrActive = !isKvdrActive;
                kvdrIcon.style.color = isKvdrActive ? e.displaySettings.cc : "#6b7280";
                if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'sine');
            };

            roleBtn.addEventListener('click', async () => {
                if(roleBtn.disabled) return;
                roleBtn.disabled = true; 
                
                const descValue = roleDescription.value;
                const BACKUP_TAG = "[ROLE_DESC_SAVE]"; 

                const apiData = {
                    title: roleTitle.value,
                    skills: skills,
                    softSkills: softSkills,
                    roleSummary: descValue,
                    description: descValue ? [{ msg: BACKUP_TAG + " " + descValue, userId: this.user()._id, createdAt: new Date() }] : [],
                    status: this.can('addRole') ? 'published' : 'pending',
                    requestedBy: this.user()._id,
                    analyzedBy: this.user()._id,
                    parentId: parentId,
                    selfId: nodeId,
                    kvdrId: this.config().id,
                    is_kvdr: isKvdrActive, // Safe
                    isKvdr: isKvdrActive   // Add camelCase backup
                };
                
                try {
                    // 1. Create the role in Node.js
                    const response = await e.onNodeClick(apiData);
                    
                    // --- KVDR PERSISTENCE FIX STARTS HERE ---
                    // If KVDR was selected during creation, we must explicitly save it to 
                    // our LocalStorage registry and sync it to the Python Backend.
                    if (isKvdrActive) {
                        const orgId = this.getActualOrgId();
                        
                        // A. Save to LocalStorage Registry (so Reports tab & Edit popup remember it)
                        const storageKey = `kvdr_roles_state_${orgId}`;
                        let kvdrRegistry = {};
                        try {
                            kvdrRegistry = JSON.parse(localStorage.getItem(storageKey)) || {};
                        } catch (err) {}
                        
                        kvdrRegistry[nodeId] = true;
                        localStorage.setItem(storageKey, JSON.stringify(kvdrRegistry));
                        
                        // B. Sync with Python Backend (FastAPI)
                        const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                        fetch(`${API_BASE_URL}/api/talent-pool/role/kvdr-flag`, {
                            method: 'PATCH',
                            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                            body: JSON.stringify({ role_id: nodeId, organization_id: orgId, is_kvdr: true })
                        }).catch(err => console.error("Python Sync Error on Create:", err));
                    }
                    // --- KVDR PERSISTENCE FIX ENDS HERE ---

                    // Ensure the response object passed back to the chart builder has the flags
                    // so the organigram card renders with the correct state instantly.
                    let finalResponse = response || apiData;
                    finalResponse.is_kvdr = isKvdrActive;
                    finalResponse.isKvdr = isKvdrActive;

                    resolve(finalResponse);
                    
                    p.style.display = "none"; p.innerHTML = "";
                    if (typeof isViewportActive !== 'undefined') {
                        isViewportActive.status = true;
                    }
                    
                    if (apiData.status === 'pending') {
                        this.showToast("Role request submitted successfully for Admin approval.", "success");
                    }
                } catch (err) { 
                    roleBtn.disabled = false; 
                    reject(err); 
                }
            });

            functionalSkillContainer.append(functionalSkillInput,functionalSkillBox);
            behavioralSkillContainer.append(behavioralSkillInput,behavioralSkillBox);
            skillSection.append(functionalSkillContainer,skillSeprator,behavioralSkillContainer);
            
            wrapper.append(titleRow, skillSection, descWrapper, charCount);

            const popupConfig = {
                headerText: `Create Role ${this.can('addRoleRequest')?'Request':''}`,
                headerRightControlls: kvdrBtnContainer,
                onCloseClick: () => { p.style.display = "none"; p.innerHTML = ""; isViewportActive.status = true; },
                data: wrapper,
                displaySettings: {
                    primaryColor: e.displaySettings.cc, 
                    secondaryColor: e.displaySettings.tc,
                    width: "700px",
                    height: "650px" 
                },
                footer: roleBtn,
            };
            const popup = this.createPopup(popupConfig);
            p.append(popup); p.style.display = "flex";
            wrapper.dataset.selectedNode = event.target.closest("div.member").dataset.empid;
        })
    }

    expandRole = async (data, type, id) => {
        const { kvdrRoleId, candidateList, displaySettings, kvdrOrgConfigData } = data;
        
        const node = document.querySelector(`[data-empid='${kvdrRoleId}']`);
        if (!node) return console.error(`Node with kvdrRoleId ${kvdrRoleId} not found`);
        
        const selectedProfiles = type === 'ROLE' 
            ? (node.dataset.selectedUsr ? node.dataset.selectedUsr.split(",").filter(Boolean) : [])
            : id;
        
        const popupBox = document.querySelector("#back-drop-overlay");

        const filteredProfiles = selectedProfiles
            .map(profileId => candidateList.find(cand => cand.id === profileId))
            .filter(profile => profile !== undefined);
    
        const updatedData = {
            ...data,
            profile: filteredProfiles,
            type
        };
    
        // Helper for legends
        const roleLegends = (data) => {
            const footer = Utils.createElem('div', ["roleLegends"]);
            Utils.applyStyles(footer, {
                display: "flex",
                alignItems: "center",
                gap: "16px", // Space between each legend item
                width: "100%",
                justifyContent: "flex-start"
            });

            // "Legends:" title
            const titleLabel = Utils.createElem("span");
            titleLabel.innerText = "Legends:";
            Utils.applyStyles(titleLabel, {
                fontWeight: '600',
                fontSize: '13px',
                color: '#4B5563'
            });
            footer.append(titleLabel);

            if (data && data.length) {
                Array.from(data).forEach(t => {
                    // Create the legend item showing only the value
                    const legend = Utils.createElem("label", ["legend"], "", `(${t.value})`);
                    Utils.applyStyles(legend, {
                        display: "flex",
                        gap: "5px", // Tighter gap between dot and value
                        alignItems: "center",
                        fontSize: "12px",
                        color: "#374151",
                        cursor: "help"
                    });

                    // The colored circle
                    const legendMarker = Utils.createElem("span");
                    Utils.applyStyles(legendMarker, {
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: `${t.color}`
                    });

                    legend.prepend(legendMarker);
                    footer.append(legend);

                    this.attachTooltip(legend, t.title);
                });
            }
            return footer;
        };

        // --- 1. PROPERLY DECLARE responseData ---
        const responseData = await this._roleProfileData(updatedData);
    
        const contentHtml = responseData.content ? responseData.content : responseData;
        const customHeader = responseData.customHeader || null;
        const freshRoleData = responseData.rawData || {}; // <--- ADD THIS LINE

        const dynamicOrgConfig = this.getDynamicConfig(kvdrOrgConfigData);

        const kvdrBtnContainer = Utils.createElem("div");
        if (type === 'ROLE') {
            const orgId = this.getActualOrgId();
            const storageKey = `kvdr_roles_state_${orgId}`;
            
            // 1. Check LocalStorage FIRST (Since Node doesn't save it, frontend must remember)
            let kvdrRegistry = {};
            try {
                kvdrRegistry = JSON.parse(localStorage.getItem(storageKey)) || {};
            } catch (e) {}
            
            const localNode = safeGraphData(this.config()).find(n => n.selfId === kvdrRoleId);
            
            // 2. Determine State: LocalStorage > localNode > false
            let isKvdrActive = false;
            if (kvdrRegistry.hasOwnProperty(kvdrRoleId)) {
                isKvdrActive = kvdrRegistry[kvdrRoleId];
            } else if (localNode) {
                isKvdrActive = (localNode.is_kvdr === true || localNode.is_kvdr === 'true' || localNode.isKvdr === true);
            }
            
            Utils.applyStyles(kvdrBtnContainer, { display: "flex", alignItems: "center", marginRight: "12px", cursor: "pointer" });
            const kvdrIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-award"]);
            
            const themeColor = (this.config().displaySettings && this.config().displaySettings.cardColor) ? this.config().displaySettings.cardColor : "#F2C244";
            Utils.applyStyles(kvdrIcon, { fontSize: "20px", color: isKvdrActive ? themeColor : "#6b7280", transition: "color 0.2s ease" });
            
            kvdrBtnContainer.append(kvdrIcon);
            this.attachTooltip(kvdrBtnContainer, "Make role Key Value Drive Role (KVDR)");

            kvdrBtnContainer.onclick = async (evt) => {
                evt.stopPropagation();
                const newState = !isKvdrActive;
                
                // 3. Optimistic UI Update (Turn Yellow instantly)
                kvdrIcon.style.color = newState ? themeColor : "#6b7280";
                isKvdrActive = newState;
                
                // 4. Save to LocalStorage immediately so it survives popup close/open
                kvdrRegistry[kvdrRoleId] = newState;
                localStorage.setItem(storageKey, JSON.stringify(kvdrRegistry));
                
                // Keep local memory cache updated
                if (localNode) {
                    localNode.is_kvdr = newState;
                    localNode.isKvdr = newState;
                }

                try {
                    const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                    
                    // 5. Send to Python Database
                    const res = await fetch(`${API_BASE_URL}/api/talent-pool/role/kvdr-flag`, {
                        method: 'PATCH',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ role_id: kvdrRoleId, organization_id: orgId, is_kvdr: newState })
                    });
                    
                    if (res.ok) {
                        if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'sine');
                    } else {
                        throw new Error("Python API failed");
                    }
                } catch (err) {
                    console.error("Python Sync Error:", err);
                    // Revert UI on fail
                    isKvdrActive = !newState;
                    kvdrIcon.style.color = isKvdrActive ? themeColor : "#6b7280";
                    kvdrRegistry[kvdrRoleId] = isKvdrActive;
                    localStorage.setItem(storageKey, JSON.stringify(kvdrRegistry));
                }
            };
        }
    
        // --- 3. APPLY DYNAMIC CONFIG TO THE FOOTER ---
        const popupData = {
            headerText: customHeader ? "" : `${type} Evaluation`,
            headerLeftControlls: customHeader, 
            headerRightControlls: type === 'ROLE' ? kvdrBtnContainer : '',
            onCloseClick: (event) => {
                event.stopPropagation();
                popupBox.style.display = "none";
                popupBox.innerHTML = "";
                if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
            },
            data: contentHtml,
            footer: roleLegends(dynamicOrgConfig.calculationTypes || []), // <--- Safely injected here
            displaySettings: { ...displaySettings, width: "900px" } 
        };

        const popupElement = this.createPopup(popupData);
        const footerElement = popupElement.querySelector('.OrganiGramPopupFooter');
        if (footerElement) footerElement.style.display = 'none';
        
        popupBox.innerHTML = ""; 
        popupBox.append(popupElement);
        popupBox.style.display = "flex";
        popupElement.dataset.selectedNode = kvdrRoleId;
        if (type === 'Talent' && footerElement) {
            footerElement.style.display = 'flex';
        }
    }

   async _roleProfileData(e){
        const t = Utils.createElem("ul");
        t.style.cssText = "display:flex; flex-direction:column; height:100%; width:100%; row-gap:15px; box-sizing:border-box;";
        
        const roleDataFull = (e.type === 'ROLE') ? await e.roleData(`selfId=${e.kvdrRoleId}`) : await e.profileData(`userId=${e.profile[0].id}&kvdrRoleId=${e.kvdrRoleId}`);
        
        if (!roleDataFull || !roleDataFull[0]) {
            const emptyMessage = Utils.createElem("div", [], "", "Access restricted or no data available.");
            Utils.applyStyles(emptyMessage, {display:"flex", alignItems:"center", justifyContent:"center", height:"200px", color:"#666", fontSize:"16px"});
            t.append(emptyMessage);
            return { content: t, customHeader: null };
        }
        
        let _currentRoleData = roleDataFull[0];

        const BACKUP_TAG = "[ROLE_DESC_SAVE]";
        let allLogs = (_currentRoleData.description && Array.isArray(_currentRoleData.description)) ? _currentRoleData.description : [];
        const latestBackup = allLogs.slice().reverse().find(log => log.msg && log.msg.startsWith(BACKUP_TAG));
        let staticDescription = "";

        if (latestBackup) {
            staticDescription = latestBackup.msg.replace(BACKUP_TAG + " ", "");
        } else if (_currentRoleData.roleSummary && _currentRoleData.roleSummary !== "undefined") {
            staticDescription = _currentRoleData.roleSummary;
        }

        let currentTitleValue = _currentRoleData.title || "";
        let customHeader = null;
        if (e.type === 'ROLE') {
            customHeader = Utils.createElem("div");
            Utils.applyStyles(customHeader, { display: "flex", alignItems: "center", gap: "10px", width: "100%", paddingRight: "10px" });
            const titleInput = Utils.createElem("input", ["roleTitleInputHeader"], "", "");
            titleInput.value = currentTitleValue;
            titleInput.placeholder = "Role Name";
            Utils.applyStyles(titleInput, { fontSize: "1.2rem", fontWeight: "700", color: "#111827", border: "1px solid transparent", background: "transparent", width: "auto", minWidth: "250px", padding: "4px 8px", borderRadius: "4px", fontFamily: "inherit" });
            titleInput.addEventListener('input', (evt) => { currentTitleValue = evt.target.value; });
            customHeader.append(titleInput);
        }

        const accessMap = { 'Appraisal (Self)': 'appraisalData', 'Fitment (Fit)': 'fitmentData', 'Performance (Drive)': 'performanceData', 'Succession (Secure)': 'successionData' };
        const roleAccess = { 0: ['Appraisal (Self)'], 1: ['Appraisal (Self)', 'Fitment \n(Fit)', 'Performance (Drive)'], 2: ['Appraisal (Self)', 'Fitment (Fit)', 'Performance (Drive)', 'Succession (Secure)'] };
        const allowedFields = roleAccess[this.role()] || [];

        const l = Utils.createElem("li");
        l.style.cssText = "border:2px solid #d0d5dd;border-radius:5px;display:flex;align-items:center;justify-content:space-between;";
        
        // --- FIX: Declare variables in the parent scope so they are accessible everywhere in this function ---
        let skills, softSkills, functionalSkillBox, softSkillBox;

        if(e.profile.length && e.profile.length > 0){
             let ids = e.profile.map(p => `&userId=${p.id}`).join('');
             const profileData = await e.profileData(`${ids}&kvdrRoleId=${e.kvdrRoleId}`);
             if(profileData.length){ this.assessmentData = []; profileData.forEach(pd => { let entry = {}; allowedFields.forEach(field => { entry[field] = pd[accessMap[field]] || ''; }); this.assessmentData.push(entry); }); }
        }
        if(e.type === 'Talent'){
            l.style.justifyContent = "flex-start";
             const profileData = await e.profileData(`userId=${e.profile[0].id}&kvdrRoleId=${e.kvdrRoleId}`);
             if(profileData.length){ let entry = {}; allowedFields.forEach(field => { entry[field] = profileData[0][accessMap[field]] || ''; }); this.assessmentData = [entry]; }
             const a = Utils.createElem("label", "", "", ""); a.style.cssText = "display:flex;align-items:center;padding:5px;";
             const r = Utils.createElem("img", ["roleProfileImg"], "", ""); r.setAttribute("src", e.profile[0].imageUrl); r.style.cssText = "width:45px;height:45px;oveflow:hidden;object-fit:cover;object-position:center;border-radius:50%;margin-right:10px";
             const s = Utils.createElem("span", "", "", ""); s.style.cssText = "text-align:left;";
             const o = Utils.createElem("h5", "", "", e.profile[0].name); const n = Utils.createElem("span", "", "", e.profile[0].emailId); n.style.cssText = "font-size:1rem;font-weight:normal"; s.append(o, n);
             const i = Utils.createElem("span", ["removeRoleProfile"], "remove-role-profile-" + e.profile[0].id + "-btn", "-");
            i.style.cssText = "background:#FF0000;border-radius:50%;width:30px;height:30px;line-height:30px;font-size:30px;cursor:pointer;color:#FFF;margin-right:15px;margin-left:auto;display:flex;justify-content:center;align-items:center;padding-bottom:4px;flex-shrink:0;";
            this.attachTooltip(i, "Remove Profile");
            i.addEventListener("click", () => e.removeProfile({ userId: e.profile[0].id, kvdrRoleId: e.kvdrRoleId }));
             a.append(r, s); l.append(a, i);
        } else {
             l.style.width = "100%"; l.style.boxSizing = "border-box";
             
             // --- FIX: Initialize the higher-scoped variables here without 'const' or 'let' ---
             skills = _currentRoleData['skills']||[]; 
             softSkills = _currentRoleData['softSkills']||[];

             const skillsContainer = Utils.createElem('div',["textCumItemBox"]); Utils.applyStyles(skillsContainer,{'display':'block', 'flex': '1', 'padding':'15px 10px', 'textAlign':'left', 'minWidth': '0'});
             const softSkillsContainer = Utils.createElem('div',["textCumItemBox"]); Utils.applyStyles(softSkillsContainer,{'display':'block', 'flex': '1', 'padding':'15px 10px', 'textAlign':'left', 'minWidth': '0'});
             const functionalSkillLabel = Utils.createElem('label', [], '', 'Functional Skills'); Utils.applyStyles(functionalSkillLabel, { fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '16px', color: '#000' }); 
             const softSkillLabel = Utils.createElem('label', [], '', 'Soft Skills'); Utils.applyStyles(softSkillLabel, { fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '16px', color: '#000' }); 

             functionalSkillBox = this.createSkillSpan(skills,e.kvdrRoleId,e.roleUpdate,'skills');
             softSkillBox = this.createSkillSpan(softSkills,e.kvdrRoleId,e.roleUpdate,'softSkills');
             
             const skillEntrBox = Utils.createSuggestiveDropDown(this.skills(),'functionalSkills','Add functional skill...'); skillEntrBox.classList.add('edit-func-skill-input');
             skillEntrBox.addEventListener('keydown',()=>this.updateRoleSkills(e.kvdrRoleId,functionalSkillBox,skills,e.roleUpdate,'skills'));
             const softSkillEntrBox = Utils.createSuggestiveDropDown(this.softSkills(),'softSkills','Add soft skill...'); softSkillEntrBox.classList.add('edit-soft-skill-input');
             softSkillEntrBox.addEventListener('keydown',()=>this.updateRoleSkills(e.kvdrRoleId,softSkillBox,softSkills,e.roleUpdate,'softSkills'));
             
             skillsContainer.append(functionalSkillLabel, skillEntrBox, functionalSkillBox); softSkillsContainer.append(softSkillLabel, softSkillEntrBox, softSkillBox);
             l.append(skillsContainer,softSkillsContainer);
        }

        const d = Utils.createElem("div");
        d.style.cssText = "display:flex; flex-direction:column; flex:1; width:100%; row-gap:10px; min-height:0;";
        const tabBtnsContainer = Utils.createElem("div");
        tabBtnsContainer.style.cssText = "gap:10px;display:flex;align-items:center;flex-wrap:wrap;";
        const contentContainer = Utils.createElem("div");
        Utils.applyStyles(contentContainer, { flex: '1', width: '100%', display: 'flex', flexDirection: 'column' });
        const btnStyle = `min-width:100px;height:40px;color:#646464;font-size:13px;text-align:center;border:none;border-radius:8px;cursor:pointer;font-weight:bold;padding:4px 10px;line-height:15px;transition:all 0.2s;background-color:#f0f0f0;`;

        const notesBtn = Utils.createElem("button", ["descBtn"]);
        notesBtn.style.cssText = `width: 40px; height: 40px; border: none; border-radius: 8px; cursor: pointer; padding: 4px 10px; background-color: #f0f0f0; background-image: url(${Comment}); background-position: center center; background-size: auto; background-repeat: no-repeat; margin-left: auto;`;
        notesBtn.title = "Notes & Logs";
        
        const roleDescWrapper = Utils.createElem('div'); 
        const notesWrapper = Utils.createElem("div");    
        const togglePopupFooter = (event, show) => {
            const popup = event.target.closest('.organiGramPopup');
            if (popup) {
                const footer = popup.querySelector('.OrganiGramPopupFooter');
                if (footer) footer.style.display = show ? 'flex' : 'none';
            }
        };

        const switchTab = (viewName, targetBtn) => {
            contentContainer.innerHTML = "";
            Array.from(tabBtnsContainer.children).forEach(btn => { btn.style.backgroundColor = "#f0f0f0"; btn.style.color = "#646464"; });
            if(targetBtn){ targetBtn.style.backgroundColor = e.displaySettings.cc; if(targetBtn !== notesBtn) targetBtn.style.color = e.displaySettings.tc; }
            if(viewName === 'DESC') contentContainer.append(roleDescWrapper);
            else if (viewName === 'NOTES') contentContainer.append(notesWrapper);
        };

        if (e.type === 'ROLE') {
            const roleDescBtn = Utils.createElem("button", ["roleDescBtn"], "", "Role Description");
            roleDescBtn.style.cssText = btnStyle;
            roleDescBtn.addEventListener("click", (evt) => { evt.preventDefault(); switchTab('DESC', evt.currentTarget); togglePopupFooter(evt, false); });
            tabBtnsContainer.append(roleDescBtn);

            const roleDescTextarea = Utils.createElem("textarea",["roleDescBox", "invisible-scroll-y"], "", "", {'placeholder':"Enter Role Description...", 'rows':5, 'maxlength':2000});
            roleDescTextarea.style.cssText = `width:100%;height:240px;font-family:inherit;color:${e.displaySettings.tc};resize:none;padding:15px;padding-right:75px;border-radius:10px;border:1px solid #ddd;box-sizing:border-box; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;`;
            
            let originalTitle = currentTitleValue;
            let originalDesc = staticDescription;
            roleDescTextarea.value = staticDescription;

            Utils.applyStyles(roleDescWrapper, { position: 'relative', width: '100%' });
            
            const aiGenerateBtn = Utils.createElem('button');
            aiGenerateBtn.title = "Use AI to enhance description";
            Utils.applyStyles(aiGenerateBtn, { position: 'absolute', top: '12px', right: '12px', background: '#f0f0f0', border: 'none', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: '2' });
            const aiIcon = Utils.createElem('img'); aiIcon.src = AIGenerateIcon; Utils.applyStyles(aiIcon, { width: '22px', height: '22px' }); aiGenerateBtn.append(aiIcon);
            
            aiGenerateBtn.addEventListener('click', async (event) => {
                event.preventDefault(); aiIcon.classList.add('ai-icon-loading');
                try {
                     const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                     const response = await fetch(`${API_BASE_URL}/api/generate-role-description`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ role_id: e.kvdrRoleId }) });
                     const data = await response.json();
                     
                     roleDescTextarea.value = data.description;
                     roleDescTextarea.dispatchEvent(new Event('input')); 

                     // --- FIX STARTS HERE ---
                     const funcInputWrapper = t.querySelector('.edit-func-skill-input');
                     const softInputWrapper = t.querySelector('.edit-soft-skill-input');

                     if (data.recommended_technical_skills && data.recommended_technical_skills.length > 0 && funcInputWrapper) {
                         const funcInput = funcInputWrapper.querySelector('input'); // Get the actual input element
                         if(funcInput) {
                            const currentVal = funcInput.value.trim();
                            const newSkillsStr = data.recommended_technical_skills.join(', ');
                            funcInput.value = currentVal ? currentVal + ', ' + newSkillsStr : newSkillsStr;
                         }
                     }
                     if (data.recommended_soft_skills && data.recommended_soft_skills.length > 0 && softInputWrapper) {
                        const softInput = softInputWrapper.querySelector('input'); // Get the actual input element
                        if (softInput) {
                            const currentVal = softInput.value.trim();
                            const newSkillsStr = data.recommended_soft_skills.join(', ');
                            softInput.value = currentVal ? currentVal + ', ' + newSkillsStr : newSkillsStr;
                        }
                     }
                     // --- FIX ENDS HERE ---
                     
                } catch(err){ 
                    console.error("AI Generation Error:", err); 
                } finally { 
                    aiIcon.classList.remove('ai-icon-loading'); 
                }
            });

            const saveBtn = Utils.createElem("button", ["saveRoleTickBtn"], "", "");
            const tickIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-check"]);
            Utils.applyStyles(tickIcon, { fontSize: "18px", color: "#fff", fontWeight: "bold" });
            saveBtn.append(tickIcon);
            Utils.applyStyles(saveBtn, { position: 'absolute', bottom: '12px', right: '12px', backgroundColor: "#28c76f", border: "none", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 5px rgba(0,0,0,0.2)", zIndex: "3", transition: "all 0.2s", opacity: "0", transform: "scale(0.8)", pointerEvents: "none" });

            const checkDirty = () => {
                if (currentTitleValue !== originalTitle || roleDescTextarea.value !== originalDesc) {
                    saveBtn.style.opacity = "1"; saveBtn.style.transform = "scale(1)"; saveBtn.style.pointerEvents = "all";
                } else {
                    saveBtn.style.opacity = "0"; saveBtn.style.transform = "scale(0.8)"; saveBtn.style.pointerEvents = "none";
                }
            };
            roleDescTextarea.addEventListener('input', checkDirty);
            const headerInput = customHeader ? customHeader.querySelector('input') : null;
            if(headerInput) headerInput.addEventListener('input', checkDirty);

            saveBtn.addEventListener('click', async (evt) => {
                evt.preventDefault(); evt.stopPropagation();
                const currentDescValue = roleDescTextarea.value;
                const cleanedLogs = allLogs.filter(log => !log.msg || !log.msg.startsWith(BACKUP_TAG));
                const backupLog = { msg: BACKUP_TAG + " " + currentDescValue, userId: this.user()._id, createdAt: new Date() };
                const newLogs = [...cleanedLogs, backupLog];
                tickIcon.className = "vs-icon notranslate icon-scale feather icon-loader ai-icon-loading"; 
                try {
                    const param = { query: e.kvdrRoleId, data: { title: currentTitleValue, roleSummary: currentDescValue, description: newLogs } };
                    await e.roleUpdate(param);
                    if (this.config().data && this.config().data.graphData) {
                        const localNode = safeGraphData(this.config()).find(n => n.selfId === e.kvdrRoleId);
                        if (localNode) { Object.assign(localNode, { title: currentTitleValue, roleSummary: currentDescValue, description: newLogs }); }
                    }
                    originalTitle = currentTitleValue; originalDesc = currentDescValue; allLogs = newLogs; 
                    const cardTitle = document.querySelector(`[data-empid='${e.kvdrRoleId}'] .role-card-title`);
                    if(cardTitle) cardTitle.innerText = currentTitleValue;
                    if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
                    setTimeout(() => { tickIcon.className = "vs-icon notranslate icon-scale feather icon-check"; checkDirty(); }, 500);
                } catch(err) { console.error(err); alert("Failed."); tickIcon.className = "vs-icon notranslate icon-scale feather icon-x"; }
            });

            roleDescWrapper.append(roleDescTextarea, aiGenerateBtn, saveBtn);
        }

        if (this.assessmentData) {
            allowedFields.forEach((item) => {
                if(!item) return;
                const btn = Utils.createElem("button", ["tabBtn"], "", item);
                btn.style.cssText = btnStyle; btn.value = accessMap[item.trim()]; 
                btn.addEventListener("click", (evt) => {
                    evt.preventDefault(); togglePopupFooter(evt, true);
                    this.createRelativeUsrData(this.assessmentData, e.kvdrOrgConfigData, evt.target, e.profile, contentContainer, e.profileUpdate, e.displaySettings, e.type);
                });
                tabBtnsContainer.append(btn);
            });
        }
        
        notesBtn.addEventListener("click", (evt) => { evt.preventDefault(); switchTab('NOTES', evt.currentTarget); togglePopupFooter(evt, false); });
        tabBtnsContainer.append(notesBtn);
        Utils.applyStyles(notesWrapper, { position: "relative", width: "100%" });

        const notesLogTextarea = Utils.createElem("textarea",["descBox", "invisible-scroll-y"], "", "", {'placeholder':"Add a new note...",'rows':5,'maxlength':2500});
        notesLogTextarea.style.cssText = `width:100%;height:240px;font-family:inherit;color:${e.displaySettings.tc};resize:none;padding:15px;padding-right:75px;border-radius:10px;border:1px solid #ddd;box-sizing:border-box; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;`;
        
        const notesSaveBtn = Utils.createElem("button", ["saveNoteBtn"], "", "");
        const noteTickIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-check"]);
        Utils.applyStyles(noteTickIcon, { fontSize: "18px", color: "#fff", fontWeight: "bold" });
        notesSaveBtn.append(noteTickIcon);
        Utils.applyStyles(notesSaveBtn, { position: 'absolute', top: '190px', right: '12px', backgroundColor: "#28c76f", border: "none", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 5px rgba(0,0,0,0.2)", zIndex: "3", transition: "all 0.2s", opacity: "0", transform: "scale(0.8)", pointerEvents: "none" });

        notesLogTextarea.addEventListener('input', () => {
            if(notesLogTextarea.value.trim().length > 0) {
                notesSaveBtn.style.opacity = "1"; notesSaveBtn.style.transform = "scale(1)"; notesSaveBtn.style.pointerEvents = "all";
            } else {
                notesSaveBtn.style.opacity = "0"; notesSaveBtn.style.transform = "scale(0.8)"; notesSaveBtn.style.pointerEvents = "none";
            }
        });

        notesSaveBtn.addEventListener('click', async (evt) => {
            evt.preventDefault(); evt.stopPropagation();
            const noteText = notesLogTextarea.value.trim();
            if(!noteText) return;
            noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-loader ai-icon-loading";
            const newLog = { msg: noteText, userId: this.user()._id, createdAt: new Date() };
            const updatedLogs = [...allLogs, newLog];
            const param = { query : e.type === 'ROLE' ? e.kvdrRoleId : `userId=${e.profile[0].id}&kvdrRoleId=${e.kvdrRoleId}`, data : { description: updatedLogs } };
            try {
                e.type === 'ROLE' ? await e.roleUpdate(param) : await e.profileUpdate(param);
                if (this.config().data && this.config().data.graphData) {
                    const localNode = safeGraphData(this.config()).find(n => n.selfId === e.kvdrRoleId);
                    if (localNode) localNode.description = updatedLogs;
                }
                allLogs = updatedLogs;
                let visibleNotes = updatedLogs.filter(log => !log.msg || !log.msg.startsWith(BACKUP_TAG));
                const oldHistory = notesWrapper.querySelector('.descLogsBox');
                if(oldHistory) oldHistory.remove();
                const newHistory = this.descriptionLogs(visibleNotes, notesLogTextarea);
                notesWrapper.append(newHistory);
                notesLogTextarea.value = "";
                notesSaveBtn.style.opacity = "0"; notesSaveBtn.style.transform = "scale(0.8)"; notesSaveBtn.style.pointerEvents = "none";
                if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
                setTimeout(() => { noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-check"; }, 500);
            } catch(err) { console.error(err); noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-x"; }
        });
        
        let visibleNotes = allLogs.filter(log => !log.msg || !log.msg.startsWith(BACKUP_TAG));
        let notesLogHistory = this.descriptionLogs(visibleNotes, notesLogTextarea);
        notesWrapper.append(notesLogTextarea, notesSaveBtn, notesLogHistory);
        
        if (e.type === 'ROLE') {
            const roleBtn = tabBtnsContainer.querySelector('.roleDescBtn');
            if(roleBtn) { roleBtn.click(); togglePopupFooter({ target: roleBtn }, false); }
        } else {
            const firstButton = tabBtnsContainer.querySelector('button');
            if (firstButton) firstButton.click(); 
            else contentContainer.innerHTML = "<p>No evaluation data available.</p>";
        }

        d.append(tabBtnsContainer, contentContainer);
        t.append(l, d);
        return { content: t, customHeader: customHeader, rawData: _currentRoleData };
    }

    // Helper to recreate the header if needed (keep logic clean)
    _createTitleHeader(ref, updateFn, roleId) {
        const customHeader = Utils.createElem("div");
        Utils.applyStyles(customHeader, { display: "flex", alignItems: "center", gap: "10px", width: "100%", paddingRight: "10px" });
        const titleInput = Utils.createElem("input", ["roleTitleInputHeader"], "", "");
        titleInput.value = ref.value;
        titleInput.placeholder = "Role Name";
        Utils.applyStyles(titleInput, { fontSize: "1.2rem", fontWeight: "700", color: "#111827", border: "1px solid transparent", background: "transparent", width: "auto", minWidth: "250px", padding: "4px 8px", borderRadius: "4px", fontFamily: "inherit" });
        titleInput.addEventListener('input', (evt) => { ref.value = evt.target.value; }); // Sync with ref for save button
        customHeader.append(titleInput);
        return customHeader;
    }

    createRoleConfig(body){
        const container = body.querySelector(`#organigram-popup-body`);
        const configPanel = Utils.createElem("div",["configPanel"]);
        Utils.applyStyles(configPanel,{
            position : "absolute",
            inset : "0px",
            background: "rgba(255, 255, 255, 0.5)",
            padding: "10px",
            display: "flex",
            flexFlow: "column"
        })
        const headerPanel = Utils.createElem("div",["headerPanel"]);
        Utils.applyStyles(headerPanel,{display:"flex",justifyContent:"space-between",padding:"0px 10px",position:"sticky",top:"0px"});
        const tips = Utils.createElem("span","","","&#128161;");
        const controlPanel = Utils.createElem("div",["controlPanel"]);
        Utils.applyStyles(controlPanel,{display:"flex",gap:"10px",alignItems:"center"});
        const saveBtn = Utils.createElem("button");
        const cancelBtn = Utils.createElem("button");
        const btnStyles = {};
        Utils.applyStyles(saveBtn,btnStyles),Utils.applyStyles(cancelBtn,btnStyles);
        //append buttons to control panel
        controlPanel.append(saveBtn,cancelBtn);
        //append controls and tips to header panel
        headerPanel.append(tips,controlPanel)
        //append header Panel to config panel
        configPanel.append(headerPanel)
        container.append(configPanel);
    }
    createSkillSpan = (skills, roleId, roleUpdateAPI, keyName) => {
        const skillsContainer = Utils.createElem('div');
        Utils.applyStyles(skillsContainer, {
            marginTop: '10px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px',
            alignContent: 'flex-start',
            height: '80px',         // Fixed Height
            overflowY: 'auto',      // Scroll if needed
            width: '100%',
            padding: '4px',
            border: '1px solid #f1f5f9',
            borderRadius: '6px',
            background: '#fafafa',
            boxSizing: 'border-box'
        });

        if (Array.isArray(skills)) {
            skills.forEach(skill => {
                const skillPill = Utils.createElem('span', [], '', '', { 'data-value': skill });
                Utils.applyStyles(skillPill, {
                    background: '#fff', color: '#334155', borderRadius: '16px', 
                    padding: '4px 8px 4px 12px', display: 'inline-flex', alignItems: 'center',
                    gap: '6px', fontSize: '12px', border: '1px solid #e2e8f0',
                    maxWidth: '100%', height: '24px', boxSizing: 'border-box', flexShrink: 0
                });

                const skillText = Utils.createElem('span', [], '', skill);
                skillText.setAttribute('title', skill);
                Utils.applyStyles(skillText, {
                    maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block'
                });

                const delSkillBtn = Utils.createElem('button', [], '', '×', { 'data-value': skill });
                Utils.applyStyles(delSkillBtn, {
                    background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer',
                    width: '16px', height: '16px', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontSize: '14px', fontWeight: 'bold', padding: '0', flexShrink: 0
                });
                
                delSkillBtn.addEventListener('click', () => this.delRoleSkill(skillPill, roleId, roleUpdateAPI, skills, keyName));
                skillPill.append(skillText, delSkillBtn);
                skillsContainer.append(skillPill);
            });
        }
        return skillsContainer;
    }
   
    descriptionLogs = (logs,box) =>{
        let currentIndex = logs.length;
        const container = Utils.createElem("div",["descLogsBox"]);
        Utils.applyStyles(container,{display:"flex",gap:'10px',alignItems:"center",justifyContent:"space-between"})
        const msgBox = Utils.createElem("div",["descLog"],"",`This description is being logged by you.`);
              msgBox.style.cssText = `flex: 0 1 calc(100% - 70px);`;
    
        const handleLog = (log) => {
            const logUser = this.config().candidateList.find(candidate => candidate.id === log.userId) || log.userId;
            msgBox.innerText = `This description was logged by ${logUser.name} at ${log.createdAt}`;
            box.value = log.msg;
        }
        const btnStyles = {
            background: "#d7d7d7",
            border: "none",
            padding: "5px",
            fontSize: "15px",
            borderRadius: "2px",
            cursor: "pointer"
        }
        const prevBtn = Utils.createElem("button",["prevLogBtn"],"",`&larr;`);
        Utils.applyStyles(prevBtn,btnStyles);
        prevBtn.addEventListener('click',(e)=>{
            e.preventDefault();
            if(currentIndex == 0) {Utils.playBellSound(800,840,'square'); return;}
            currentIndex--;
            handleLog(logs[currentIndex]);
        });
        const nextBtn = Utils.createElem("button",["nextLogBtn"],"",`&rarr;`);
        Utils.applyStyles(nextBtn,btnStyles);
        nextBtn.addEventListener('click',(e)=>{
            e.preventDefault();
            currentIndex++;
            if(currentIndex > logs.length){currentIndex = logs.length;Utils.playBellSound(800,840,'square'); return;}
            else if(currentIndex == logs.length){msgBox.innerText = `This description is being logged by you.`;box.value=""}
            else handleLog(logs[currentIndex]);
        })
        container.append(prevBtn,msgBox,nextBtn);
        return container;
    }
    // a small function to use change background color of selected tab button
    selectBtn(target,settings){
        let nextSibling = target.nextElementSibling;
        let prevSibling = target.previousElementSibling;
        while(nextSibling){
            nextSibling.style.backgroundColor = "#f0f0f0";
            nextSibling.style.color = "#646464";
            nextSibling = nextSibling.nextElementSibling;
        }
        while(prevSibling){
            prevSibling.style.backgroundColor = "#f0f0f0"
            prevSibling.style.color = "#646464";
            prevSibling = prevSibling.previousElementSibling;
        }
        target.style.backgroundColor = settings.cc;
        target.style.color = settings.tc;
    }
// Add this helper method inside the OrganiGram class
    getDynamicConfig(passedConfig) {
        let finalConfig = { ...passedConfig };

        // 1. Merge API data if we fetched it
        if (this.cachedOrgConfig) {
            finalConfig = { ...finalConfig, ...this.cachedOrgConfig };
        }

        // 2. Local Storage overrides ALWAYS take precedence if the API returned 
        // the default "000000000000000000000000" document, or if the user hasn't saved to DB yet.
        try {
            const pathParts = window.location.pathname.split('/');
            const slugIndex = pathParts.indexOf('organization') + 1;
            const slug = pathParts[slugIndex];
            
            if (slug) {
                const localDataStr = localStorage.getItem(`onboardingConfigs_${slug}`);
                if (localDataStr) {
                    const localData = JSON.parse(localDataStr);
                    
                    // If backend gave us the default org, OVERRIDE the metrics with what you typed in Step 3!
                    if (!this.cachedOrgConfig || this.cachedOrgConfig.orgId === "000000000000000000000000" || this.cachedOrgConfig.orgId === "0") {
                        if (localData.appraisal) finalConfig.appraisalData = localData.appraisal;
                        if (localData.fitment) finalConfig.fitmentData = localData.fitment;
                        if (localData.succession) finalConfig.successionData = localData.succession;
                        if (localData.performance) finalConfig.performanceData = localData.performance;
                    }
                }
            }
        } catch (e) {
            console.warn("Could not load local dynamic config", e);
        }

        // 3. Fallback Mapping (Catch-all for legacy variable names)
        if (!finalConfig.appraisalData && finalConfig.appraisal) finalConfig.appraisalData = finalConfig.appraisal;
        if (!finalConfig.fitmentData && finalConfig.fitment) finalConfig.fitmentData = finalConfig.fitment;

        return finalConfig;
    }

createRelativeUsrData(e, t, target, profiles, s, profileUpdate, settings, viewType) {
    const dynamicT = this.getDynamicConfig(t);
    this.selectBtn(target, settings);
    let _calProfileEval = [];

    const configKey = target.value;
    const dataKey = configKey.replace('Data', '');
    const n = target.innerText;

    s.innerHTML = "";
    _totalEvaluation.total = 0;
    _calculateEvaluation.total = 0;

    if (!document.getElementById('invisible-scroll-styles')) {
        const style = document.createElement('style');
        style.id = 'invisible-scroll-styles';
        style.innerHTML = `.invisible-scroll { overflow-x: auto; overflow-y: hidden; scrollbar-width: none; -ms-overflow-style: none; scroll-behavior: auto; } .invisible-scroll::-webkit-scrollbar { display: none; }`;
        document.head.appendChild(style);
    }

    const metricConfig = dynamicT[dataKey] || dynamicT[configKey] || {};
    const l = Utils.createElem("div", ["assessmentDataContainer"], "assessment-data-container", "");
    l.style.cssText = `overflow: visible; border:1px solid rgba(0,0,0,0.1); border-radius:16px; width: 100%; box-sizing: border-box; background: #fff;`;    
    const d = Utils.createElem("div", "", "", "");
    d.style.cssText = "display:flex; flex-direction:column; align-items:stretch; width: 100%; position: relative;";

    const colWidth = viewType === 'ROLE' ? "25%" : "35%";
    const weightColWidth = '60px';
    const sidewaysWidth = '40px';
    const baseLeftPad = '15px';
    const titleLeftPad = `calc(${sidewaysWidth} + ${baseLeftPad})`;

    const colWidthCSS = `flex: 0 0 ${colWidth}; width: ${colWidth}; min-width: 200px; box-sizing: border-box;`;
    const weightColCSS = `flex: 0 0 ${weightColWidth}; width: ${weightColWidth}; box-sizing: border-box; border-left: 1px solid rgba(0,0,0,0.1); border-right: 1px solid rgba(0,0,0,0.1);`;
    const profilesColCSS = `flex: 1 1 0%; min-width: 0; box-sizing: border-box;`; 
    
    const profColWidth = (viewType === 'ROLE') ? "70px" : "480px";

    const syncScrollers = [];

    let sortedProfiles = [];
    let sortedAssessments = [];
    if (profiles.length > 0) {
        const defaultType = dynamicT.calculationTypes.find(type => type.default === true);
        const defaultVal = defaultType ? Utils.parseNumber(defaultType.value) : 0;

        const mappedData = profiles.map((profile, index) => {
            const assessment = e[index]; 
            const scoresList = assessment ? (assessment[n] || assessment[configKey] || assessment[dataKey]) : [];
            let calculatedTotal = 0;

            Object.keys(metricConfig).forEach(group => {
                metricConfig[group].forEach(attr => {
                    const attrKey = attr.key;
                    // FIX: Create unique composite key for accurate calculation
                    const compKey = `${group}|${attrKey}`;
                    const weight = Utils.parseNumber(attr.value);
                    const userItem = scoresList ? (scoresList.find(x => x.key === compKey) || scoresList.find(x => x.key === attrKey)) : null;
                    let val = userItem ? Utils.parseNumber(userItem.score !== undefined ? userItem.score : userItem.value) : defaultVal;
                    calculatedTotal += (val * weight);
                });
            });
            return { profile: profile, assessment: assessment, total: calculatedTotal, isLocked: false };
        });

        mappedData.sort((a, b) => b.total - a.total);
        sortedProfiles = mappedData.map(x => x.profile);
        sortedAssessments = mappedData.map(x => x.assessment);
    }

    const _headerRow = Utils.createElem("div", ["assessment-header-row"]);
    _headerRow.style.cssText = "display:flex; align-items:stretch; width: 100%; border-bottom:1px solid rgba(0,0,0,0.1); box-sizing: border-box;";
    
    const isAppraisalTab = n.toLowerCase().includes('appraisal');
    const canEditAttr = (this.role() !== 0) || isAppraisalTab;
    
    const _headerAttr = Utils.createElem("div", "", "", `<span style="font-weight:bold;">Attribute</span>`);
    _headerAttr.style.cssText = `display:flex; align-items:center; justify-content:flex-start; padding:12px 10px 12px ${titleLeftPad}; text-align: left; ${colWidthCSS}`;

    const _headerWeight = Utils.createElem("div");

    if (canEditAttr) {
        // Create the '+' button for adding attributes
        const addButton = Utils.createElem("button", ["add-attribute-btn"]); // Using a unique class to avoid CSS conflicts
        addButton.innerHTML = '+';
        Utils.applyStyles(addButton, {
            width: '24px',
            height: '24px',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            background: '#ffffff',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px',
            color: '#4b5563',
            lineHeight: '1'
        });
        // Note: This button is currently visual to fix the layout. Functionality would be a new feature.
        _headerWeight.append(addButton);
        
        // Style the container cell to center the button
        _headerWeight.style.cssText = `display:flex; align-items:center; justify-content:center; ${weightColCSS}`;

    } else {
        // Original behavior for non-editable views
        _headerWeight.innerHTML = `<span style="border:1.5px solid;border-radius:5px;padding:1.5px 8px;font-weight:bold;margin:auto;">${dynamicT.calculationUnit || ''}</span>`;
        _headerWeight.style.cssText = `display:flex; align-items:center; justify-content:flex-start; padding:12px 10px 12px ${baseLeftPad}; ${weightColCSS}`;
    }
    
    const _headerProfiles = Utils.createElem("div");
    _headerProfiles.style.cssText = `display:flex; flex-direction:column; overflow-x: auto; ${profilesColCSS}`;
    
    const _roleProfilesContainer = Utils.createElem("div", ["roleProfilesContainer", "invisible-scroll"]);
    _roleProfilesContainer.style.cssText = "display:flex; width:100%; justify-content:flex-start; padding-bottom: 5px; box-sizing: border-box;";
    syncScrollers.push(_roleProfilesContainer);

    const _footerCalEvalSec = Utils.createElem("div"); 

    sortedProfiles.forEach((profile, ind) => {
        if (!profile.isLocked) {
            _calProfileEval.push(0);
            const profileImgWrapper = Utils.createElem("div", ["roleProfileImgWrapper"]);
            profileImgWrapper.style.cssText = `position: relative; display: flex; flex-direction:column; align-items:center; flex: 0 0 ${profColWidth}; min-width: ${profColWidth}; padding: 5px 10px; box-sizing: border-box;`;
            const img = Utils.createElem("img", ["roleProfileImg"]);
            img.setAttribute("src", profile.imageUrl);
            img.style.cssText = "width:35px;height:35px;object-fit:cover;object-position:center;border-radius:50%;border:0px solid; cursor: help; margin: 0;";
            this.attachTooltip(img, profile.name);
            profileImgWrapper.append(img);
            _roleProfilesContainer.append(profileImgWrapper);

            const _profileFooterEvalContainer = Utils.createElem("div");
            _profileFooterEvalContainer.style.cssText = `margin:0; flex: 0 0 ${profColWidth}; min-width: ${profColWidth}; text-align:center; box-sizing: border-box;`;
            _profileFooterEvalContainer.dataset.targetprofile = profile.id;
            _profileFooterEvalContainer.innerText = "0"; 
            _footerCalEvalSec.append(_profileFooterEvalContainer);
        }
    });

    _headerProfiles.append(_roleProfilesContainer);
    _headerRow.append(_headerAttr, _headerWeight, _headerProfiles);
    d.append(_headerRow);

    const _tableBody = Utils.createElem("div", ["assessment-table-body"]);
    _tableBody.style.cssText = "width: 100%; box-sizing: border-box; position: relative;";
    d.append(_tableBody);
    const h = ["#FFFBE5", "#E5FFEA", "#E5F3FF", "#F8E5FF", "#FFE5E5"];

    Object.keys(metricConfig).forEach((a, r) => {
        const _groupWrapper = Utils.createElem("div", ["attri-group-wrapper"]);
        _groupWrapper.style.cssText = "position: relative; display: flex; flex-direction: column; width: 100%; box-sizing: border-box; border-bottom: 1px solid #fff;";

        const _sidewaysLabelWrapper = Utils.createElem("div");
        _sidewaysLabelWrapper.style.cssText = `position: absolute; left: 0; top: 0; bottom: 0; width: ${sidewaysWidth}; background: ${h[r % h.length]}; display:flex; align-items:center; justify-content: center; box-sizing: border-box; z-index: 1; border-right: 1px solid rgba(0,0,0,0.05);`;
        const _sidewaysLabel = Utils.createElem("h6", ["attriGrpTitle"], "", `<span style="transform-origin:50% 50%;">${a}</span>`);
        _sidewaysLabel.style.cssText = `white-space:normal; writing-mode:sideways-lr; margin:0;`;
        _sidewaysLabelWrapper.append(_sidewaysLabel);
        _groupWrapper.append(_sidewaysLabelWrapper);

        for (let l = 0; l < metricConfig[a].length; l++) {
            const _row = Utils.createElem("div", ["assessment-row"]);
            _row.style.cssText = "display:flex; align-items:stretch; min-height: 45px; width: 100%; box-sizing: border-box; position: relative;";

            const _titleCell = Utils.createElem("div", ["attriTitle"], "", metricConfig[a][l].title);
            _titleCell.style.cssText = `background:${h[r % h.length]}; padding:10px 10px 10px ${titleLeftPad}; font-size: 13px; font-weight: 500; display: flex; align-items: center; justify-content: flex-start; text-align: left; border-bottom: 1px solid rgba(0,0,0,0.05); line-height: 1.3; z-index: 0; ${colWidthCSS}`;
            if (metricConfig[a][l].desc) this.attachTooltip(_titleCell, metricConfig[a][l].desc);
            _totalEvaluation.total += Utils.parseNumber(metricConfig[a][l].value);

            const _weightCell = Utils.createElem("div", ["attriVal"], "", metricConfig[a][l].value);
            _weightCell.style.cssText = `padding:10px 10px 10px ${baseLeftPad}; display: flex; align-items: center; justify-content: flex-start; text-align: left; border-bottom: 1px solid #eee; font-size: 13px; background: #fff; ${weightColCSS}`;

            const _scoresCell = Utils.createElem("div", ["profileEvalBtnContainer", "invisible-scroll"]);
            _scoresCell.style.cssText = `display:flex; padding:0px; justify-content:flex-start; border-bottom: 1px solid #eee; position: relative; overflow-x: auto; ${profilesColCSS}`;
            syncScrollers.push(_scoresCell);

            const currentAttrKey = metricConfig[a][l].key;
            const compositeKey = `${a}|${currentAttrKey}`;

            sortedProfiles.forEach((p, ind) => {
                if (!p.isLocked) {
                    const u = Utils.createElem("div");
                    const justifyStyle = (viewType === 'ROLE') ? 'center' : 'flex-start';
                    u.style.cssText = `padding:5px 10px; display: flex; align-items: center; justify-content: ${justifyStyle}; gap: 10px; flex: 0 0 ${profColWidth}; min-width: ${profColWidth}; position: relative; box-sizing: border-box;`;

                    const _profileEvalContainer = _footerCalEvalSec.childNodes[ind];
                    const userScoreList = sortedAssessments[ind] ? (sortedAssessments[ind][n] || sortedAssessments[ind][configKey] || sortedAssessments[ind][dataKey]) : [];
                    
                    let _currentItem = userScoreList ? (userScoreList.find(e => e.key === compositeKey) || userScoreList.find(e => e.key === currentAttrKey)) : null;
                    
                    let rawVal = 0, remarksText = "", dotColor = "#e0e0e0";

                    if (_currentItem) {
                        rawVal = Utils.parseNumber(_currentItem.score !== undefined ? _currentItem.score : _currentItem.value);
                        remarksText = _currentItem.remarks || _currentItem.reasoning || "";
                        // --- FIXED: Safely compare float to float ---
                        const configColor = dynamicT.calculationTypes.find(type => parseFloat(type.value) === parseFloat(rawVal));
                        dotColor = configColor ? configColor.color : "#e0e0e0";
                        _calProfileEval[ind] += rawVal * Utils.parseNumber(metricConfig[a][l].value);
                    } else {
                        const defaultType = dynamicT.calculationTypes.find(type => type.default === true);
                        if (defaultType) {
                            rawVal = Utils.parseNumber(defaultType.value); dotColor = defaultType.color;
                            _calProfileEval[ind] += rawVal * Utils.parseNumber(metricConfig[a][l].value);
                        }
                    }
                    if (_profileEvalContainer) _profileEvalContainer.innerText = Math.round(_calProfileEval[ind]);

                    // Single flag to explicitly determine if editing is allowed in this specific view & cell
                    const isEditable = !p.isLocked && canEditAttr && viewType !== 'ROLE';

                    const _userCalValueBtn = Utils.createElem("div");
                    _userCalValueBtn.dataset.group = configKey;
                    _userCalValueBtn.dataset.value = rawVal;
                    _userCalValueBtn.dataset.key = compositeKey; 
                    _userCalValueBtn.dataset.keyValue = metricConfig[a][l].value;
                    _userCalValueBtn.dataset.targetProfile = p.id;
                    _userCalValueBtn.style.cssText = `width: 22px; height: 22px; border-radius: 50%; background: ${dotColor}; position: relative; border: 1px solid rgba(0,0,0,0.1); flex-shrink: 0;`;

                    // ======= CLEANED UP LOGIC TO FIX THE "CLICK" BUG ========
                    if (viewType === 'ROLE') {
                        // Strict Read-Only Mode
                        if (remarksText) {
                            _userCalValueBtn.style.pointerEvents = "auto";
                            _userCalValueBtn.style.cursor = "help";
                            
                            // Keep remarks tooltip for role view
                            _userCalValueBtn.addEventListener("mouseenter", () => {
                                const tooltip = document.createElement("div");
                                tooltip.className = "role-remarks-hover-tip";
                                tooltip.innerText = remarksText;
                                Object.assign(tooltip.style, {
                                    position: "fixed", background: "rgba(33, 33, 33, 0.95)", color: "#fff",
                                    padding: "8px 12px", borderRadius: "6px", fontSize: "12px", lineHeight: "1.4",
                                    maxWidth: "280px", zIndex: "1000000", pointerEvents: "none",
                                    boxShadow: "0 4px 15px rgba(0,0,0,0.3)", fontFamily: "inherit",
                                    whiteSpace: "normal", wordWrap: "break-word", textAlign: "left"
                                });
                                document.body.appendChild(tooltip);
                                const rect = _userCalValueBtn.getBoundingClientRect();
                                const tipRect = tooltip.getBoundingClientRect();
                                tooltip.style.top = (rect.top - tipRect.height - 10) + "px";
                                tooltip.style.left = (rect.left - (tipRect.width / 2) + (rect.width / 2)) + "px";
                            });
                            _userCalValueBtn.addEventListener("mouseleave", () => {
                                document.querySelectorAll(".role-remarks-hover-tip").forEach(el => el.remove());
                            });
                        } else {
                            _userCalValueBtn.style.pointerEvents = "none";
                            _userCalValueBtn.style.cursor = "default";
                        }
                        u.append(_userCalValueBtn);
                    } else {
                        // Specific Profile View (Editing Allowed if 'isEditable' is true)
                        if (isEditable) {
                            _userCalValueBtn.style.pointerEvents = "auto";
                            _userCalValueBtn.style.cursor = "pointer";
                            _userCalValueBtn.addEventListener("click", (e) => {
                                const query = `userId=${p.id}&kvdrRoleId=${target.closest("div#candidate-list-popup").dataset.selectedNode}`;
                                this.updateUserEvaluation(e.target, dynamicT.calculationTypes, _tableBody, query, profileUpdate, false);
                            });
                        } else {
                            _userCalValueBtn.style.pointerEvents = "none";
                            _userCalValueBtn.style.cursor = "default";
                        }

                        const _remarksInput = Utils.createElem("textarea", ["remarks-input"]);
                        _remarksInput.value = remarksText;
                        _remarksInput.placeholder = !isEditable ? "" : "Add remarks...";
                        _remarksInput.disabled = !isEditable;
                        _remarksInput.dataset.key = compositeKey;
                        const collapsedStyle = `flex: 1; border: 1px solid transparent; background: transparent; font-size: 12px; padding: 6px; color: #666; text-align: left; transition: all 0.2s ease; min-width: 0; font-family: inherit; resize: none; height: 28px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: ${!isEditable ? 'default' : 'text'}; box-sizing: border-box;`;
                        _remarksInput.style.cssText = collapsedStyle;

                        if (isEditable) {
                            _remarksInput.addEventListener('focus', () => { 
                                _groupWrapper.style.zIndex = '100'; _row.style.zIndex = '101'; u.style.zIndex = '102';
                                _scoresCell.style.overflow = 'visible';
                                Object.assign(_remarksInput.style, { position: 'absolute', left: '45px', top: '2px', width: '400px', zIndex: '5000', background: '#ffffff', border: '1px solid #28c76f', borderRadius: '8px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)', whiteSpace: 'normal', padding: '10px', outline: 'none', color: '#111', height: 'auto' }); 
                                _remarksInput.style.height = (_remarksInput.scrollHeight) + 'px';
                            });
                            _remarksInput.addEventListener('blur', () => { 
                                _groupWrapper.style.zIndex = ''; _row.style.zIndex = ''; u.style.zIndex = '';
                                _scoresCell.style.overflow = ''; _scoresCell.style.overflowX = 'auto';
                                _remarksInput.style.cssText = collapsedStyle; 
                                const query = `userId=${p.id}&kvdrRoleId=${target.closest("div#candidate-list-popup").dataset.selectedNode}`; 
                                this.updateUserEvaluation(_userCalValueBtn, dynamicT.calculationTypes, _tableBody, query, profileUpdate, true); 
                            });
                        }
                        u.append(_userCalValueBtn, _remarksInput);
                    }
                    // =========================================================

                    _scoresCell.append(u);
                }
            });
            _row.append(_titleCell, _weightCell, _scoresCell);
            _groupWrapper.append(_row);
        }
        _tableBody.append(_groupWrapper);
    });

    const _footerRow = Utils.createElem("div", ["assessment-footer-row"]);
    _footerRow.style.cssText = "display:flex; align-items:stretch; width: 100%; border-top:1px solid rgba(0,0,0,0.1); box-sizing: border-box; background: #fff;";
    
    const _footerLabel = Utils.createElem("div", "", "", "Total");
    _footerLabel.style.cssText = `padding:10px 10px 10px ${titleLeftPad}; font-size:14px; font-weight:bold; display:flex; align-items:center; justify-content:flex-start; text-align: left; ${colWidthCSS}`;
    
    const _footerTotalWeight = Utils.createElem("div", "", "", _totalEvaluation.total);
    _footerTotalWeight.style.cssText = `padding:10px 10px 10px ${baseLeftPad}; font-size:14px; font-weight:bold; display:flex; align-items:center; justify-content: center; text-align: center; ${weightColCSS}`;
    
    const _footerScores = _footerCalEvalSec; 
    _footerScores.classList.add("invisible-scroll");
    _footerScores.style.cssText = `font-size:14px; font-weight:bold; padding:10px 0px; display:flex; justify-content:flex-start; align-items:center; overflow-x: auto; ${profilesColCSS}`;
    syncScrollers.push(_footerScores);

    _footerRow.append(_footerLabel, _footerTotalWeight, _footerScores);
    d.append(_footerRow);
    l.append(d);
    s.append(l);

    let isSyncingLeftScroll = false;
    syncScrollers.forEach(el => {
        el.addEventListener('scroll', (e) => {
            if (!isSyncingLeftScroll) {
                isSyncingLeftScroll = true;
                const scrollValue = e.target.scrollLeft;
                syncScrollers.forEach(target => { if (target !== e.target) target.scrollLeft = scrollValue; });
                window.requestAnimationFrame(() => { isSyncingLeftScroll = false; });
            }
        }, { passive: true });
    });
}

updateUserEvaluation(target, calType, container, query, profileUpdate, isTextOnlyUpdate = false) {
    if (!isTextOnlyUpdate) {
        // --- FIXED: Safely compare float to float ---
        let calTypeIndex = calType.findIndex(x => parseFloat(x.value) === parseFloat(target.dataset.value));
        (calTypeIndex === 0) ? calTypeIndex = calType.length - 1 : calTypeIndex--;
        target.dataset.value = calType[calTypeIndex].value;
        target.style.background = calType[calTypeIndex].color;
    }

    let data = [],
        total = 0,
        group = target.dataset.group;

    const keyAttris = container.querySelectorAll('[data-target-profile="' + target.dataset.targetProfile + '"]');
    
    keyAttris.forEach(item => {
        const parent = item.parentElement; 
        const remarksInput = parent.querySelector('textarea.remarks-input');
        const remarksVal = remarksInput ? remarksInput.value : "";

        data.push({
            key: item.dataset.key, // FIX: This is now the composite unique key
            value: item.dataset.value, 
            score: item.dataset.value, 
            remarks: remarksVal        
        });
        
        total += Utils.parseNumber(item.dataset.keyValue) * Utils.parseNumber(item.dataset.value);
    });

    const footerTotal = container.parentElement.querySelector('[data-targetprofile="' + target.dataset.targetProfile + '"]');
    if (footerTotal) footerTotal.innerText = Math.round(total);

    const dataObj = {};
    dataObj[group] = data;
    this.param = { query: query, data: dataObj };
    
    if (typeof profileUpdate === 'function') {
        profileUpdate(this.param).then(() => {
            if (!isTextOnlyUpdate && typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
        }).catch(err => console.error("Sync Error:", err));
    }
}
    
    updateUserEvaluation(target, calType, container, query, profileUpdate, isTextOnlyUpdate = false) {
    
    // 1. Cycle color and value immediately for UI feedback
    if (!isTextOnlyUpdate) {
        let calTypeIndex = calType.findIndex(x => x.value == target.dataset.value);
        (calTypeIndex === 0) ? calTypeIndex = calType.length - 1 : calTypeIndex--;
        target.dataset.value = calType[calTypeIndex].value;
        target.style.background = calType[calTypeIndex].color;
    }

    let data = [],
        total = 0,
        group = target.dataset.group;

    // 2. Find all attribute rows for this specific candidate
    const keyAttris = container.querySelectorAll('[data-target-profile="' + target.dataset.targetProfile + '"]');
    
    keyAttris.forEach(item => {
        const parent = item.parentElement; 
        const remarksInput = parent.querySelector('textarea.remarks-input');
        const remarksVal = remarksInput ? remarksInput.value : "";

        data.push({
            key: item.dataset.key,
            value: item.dataset.value, 
            score: item.dataset.value, 
            remarks: remarksVal        
        });
        
        // Recalculate total locally: Weight * Score
        total += Utils.parseNumber(item.dataset.keyValue) * Utils.parseNumber(item.dataset.value);
    });

    // --- FIX: Search in parentElement because the footer is a sibling of the table body (container) ---
    const footerTotal = container.parentElement.querySelector('[data-targetprofile="' + target.dataset.targetProfile + '"]');
    if (footerTotal) {
        footerTotal.innerText = Math.round(total); // Update total on screen instantly
    }

    // 3. Update database in the background
    const dataObj = {};
    dataObj[group] = data;
    this.param = { query: query, data: dataObj };
    
    if (typeof profileUpdate === 'function') {
        profileUpdate(this.param).then(() => {
            if (!isTextOnlyUpdate && typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
        }).catch(err => console.error("Sync Error:", err));
    }
}
    updateRoleSkills = (roleId, container, skills, api, keyName) => {
        // Trigger ONLY on 'Enter'
        if (event.key === 'Enter') {
            event.preventDefault();
            let rawValue = event.target.value || '';
            
            // Split the input by commas, trim extra spaces, and remove empty strings
            let items = rawValue.split(',').map(item => item.trim()).filter(item => item !== '');
            
            if (items.length === 0) {
                event.target.value = '';
                return; 
            }

            let addedNew = false;
            
            items.forEach(item => {
                // Prevent duplicate skill tags from being added
                if (skills.some(s => s.toLowerCase() === item.toLowerCase())) {
                    return; 
                }

                const query = `${roleId}`;
                skills.push(item);
                addedNew = true;

                const skillPill = Utils.createElem('span', [], '', '', { 'data-value': item });
                Utils.applyStyles(skillPill, {
                    background: '#fff', color: '#334155', borderRadius: '16px', 
                    padding: '4px 8px 4px 12px', display: 'inline-flex', alignItems: 'center',
                    gap: '6px', fontSize: '12px', border: '1px solid #e2e8f0',
                    maxWidth: '100%', height: '24px', boxSizing: 'border-box', flexShrink: 0,
                    marginTop: '0'
                });

                const skillText = Utils.createElem('span', [], '', item);
                skillText.setAttribute('title', item);
                Utils.applyStyles(skillText, {
                    maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block'
                });

                const delSkillBtn = Utils.createElem('button', [], '', '×', { 'data-value': item });
                Utils.applyStyles(delSkillBtn, {
                    background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer',
                    width: '16px', height: '16px', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontSize: '14px', fontWeight: 'bold', padding: '0', flexShrink: 0
                });

                delSkillBtn.addEventListener('click', () => this.delRoleSkill(skillPill, roleId, api, skills, keyName));
                skillPill.append(skillText, delSkillBtn);
                
                container.append(skillPill);
            });
            
            // Only update backend and scroll if valid new skills were actually added
            if (addedNew) {
                const param = { query: `${roleId}`, data: { [keyName]: skills } };
                if (api) { api(param) }
                container.scrollTop = container.scrollHeight;
            }

            event.target.value = '';
            event.target.focus();
        }
    }
    delRoleSkill = (container,roleId,api,skills,keyName) => {
        const query = `${roleId}`;
        const item = event.target.dataset.value;
        const index = skills.indexOf(item);
        if (index !== -1){
            skills.splice(index, 1);
        } 
        const param = {query : query,data:{[keyName] : skills}};
        if(api) api(param);
        container.remove();
    }

    /**
     * Handles a "destructive" user move. It removes the user from all other roles
     * before adding them to the new one. This is used for the manual '+' add action.
     * @param {string} userId - The ID of the user to move.
     * @param {string} newRoleId - The ID of the destination role.
     * @param {object} context - The 'e' context object from the caller.
     * @param {HTMLElement} userImage - The image element of the user being added.
     */
    async _handleDestructiveUserMove(userId, newRoleId, context, userImage) {
        const allRoles = this.config().data.graphData;
        const removalPromises = [];

        // 1. Find and remove user from all other roles
        allRoles.forEach(role => {
            if (role.selfId !== newRoleId && role.profiles && role.profiles.some(p => p.userId === userId)) {
                console.log(`Removing user ${userId} from old role ${role.selfId}`);
                
                // Call API to remove from backend
                const promise = context.onNodeRemoveProfileClick({ roleId: role.selfId, userId: userId });
                removalPromises.push(promise);

                // Update local data and DOM for the old role
                const oldRoleNode = document.querySelector(`[data-empid='${role.selfId}']`);
                if (oldRoleNode) {
                    const oldSelectedUsers = oldRoleNode.dataset.selectedUsr.split(',').filter(Boolean);
                    const updatedUsers = oldSelectedUsers.filter(id => id !== userId);
                    oldRoleNode.dataset.selectedUsr = updatedUsers.join(',');
                    
                    const imgToRemove = oldRoleNode.querySelector(`#img-${userId}`);
                    if (imgToRemove) imgToRemove.remove();
                }
                role.profiles = role.profiles.filter(p => p.userId !== userId);
            }
        });

        await Promise.all(removalPromises);

        // 2. Add user to the new role
        console.log(`Adding user ${userId} to new role ${newRoleId}`);
        await context.onNodeAddProfileClick({ roleId: newRoleId, userId: userId });

        const newRoleNode = document.querySelector(`[data-empid='${newRoleId}']`);
        if (newRoleNode) {
            const currentSelectedUsers = newRoleNode.dataset.selectedUsr.split(',').filter(Boolean);
            if (!currentSelectedUsers.includes(userId)) {
                currentSelectedUsers.push(userId);
                newRoleNode.dataset.selectedUsr = currentSelectedUsers.join(',');
            }
            
            const r = newRoleNode.querySelector("label>fieldset>div>span");
            const _selectedUser = Utils.createElem("img", ["selectedUsrImg"], "img-" + userId, "",{ src : userImage.src});
            Utils.applyStyles(_selectedUser,{ position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
            
            // --- FIX: Create the correctly structured data object for expandRole ---
            const expandData = {
                kvdrRoleId: newRoleId,
                candidateList: context.candidateList,
                kvdrOrgConfigData: context.data.kvdrOrgConfigData || context.kvdrOrgConfigData,
                removeProfile: (t) => context.onNodeRemoveProfileClick(t),
                profileData: async (t) => context.onNodeProfileFetch(t),
                profileUpdate: async (t) => context.onNodeProfileUpdate(t),
                roleData: async (t) => context.onNodeFetch(t),
                roleUpdate: async (t) => context.onNodeUpdate(t),
                displaySettings: context.displaySettings
            };

            _selectedUser.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [userId]); });
            r.prepend(_selectedUser);
        }
    }

    _popupUsrListCollection = (event, e, t) => {
    const roleNode = event.target.closest('div.member');
    const roleId = e.selfId;
    const orgId = this.getActualOrgId();
    const roleTitle = e.title;
    const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";

    // FIX: Create a deep copy to ensure this popup's data is isolated and deduplicate to avoid UI clones.
    const rawCandidates = JSON.parse(JSON.stringify(e.candidateList || []));
    const localCandidateList = [];
    const seenIds = new Set();
    const seenEmails = new Set();

    rawCandidates.forEach(cand => {
        const cId = String(cand.id || cand.user_id);
        const cEmail = (cand.email || cand.emailId || "").toLowerCase().trim();
        const hasId = cId && cId !== "undefined";
        const hasEmail = cEmail && cEmail.length > 0;
        
        let isDuplicate = false;
        if (hasId && seenIds.has(cId)) isDuplicate = true;
        if (hasEmail && seenEmails.has(cEmail)) isDuplicate = true;
        
        if (!isDuplicate) {
            if (hasId) seenIds.add(cId);
            if (hasEmail) seenEmails.add(cEmail);
            localCandidateList.push(cand);
        }
    });

    const rawSelected = roleNode.dataset.selectedUsr;
    const selectedUsr = rawSelected ? rawSelected.split(',').filter(Boolean) : [];
    const activeTask = this.activeAiTasks.get(roleId);

    const createSkeletonRow = () => {
        const listItem = Utils.createElem("li");
        listItem.className = 'skeleton-user-row';
        listItem.innerHTML = `
            <div style="display: flex; align-items: center; padding: 12px 20px; border-bottom: 1px solid #F3F4F6; animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;">
                <div style="width: 16px; height: 16px; margin-right: 16px; background-color: #e5e7eb; border-radius: 4px;"></div>
                <div style="width: 38px; height: 38px; border-radius: 50%; margin-right: 16px; background-color: #e5e7eb;"></div>
                <div style="flex: 1; display: flex; flex-direction: column; gap: 6px;">
                    <div style="height: 14px; width: 40%; background-color: #e5e7eb; border-radius: 4px;"></div>
                    <div style="height: 12px; width: 60%; background-color: #e5e7eb; border-radius: 4px;"></div>
                </div>
            </div>
        `;
        if (!document.getElementById('organigram-skeleton-style')) {
            const style = document.createElement('style');
            style.id = 'organigram-skeleton-style';
            style.innerHTML = `@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }`;
            document.head.appendChild(style);
        }
        return listItem;
    };

    // --- FIX: MORE ROBUST ROLE TITLE LOOKUP ---
    const getUserCurrentRoleTitles = (userId) => {
        if (!userId) return "Unassigned";
        const uidStr = String(userId);
        const allRoles = (this.config().data && this.config().data.graphData) ? this.config().data.graphData : [];
        let foundRoles = new Set(); // Use a Set to avoid duplicate role titles

        for (const r of allRoles) {
            if (r.profiles?.some(p => String(p.userId) === uidStr)) {
                foundRoles.add(r.title);
            }
            if (r.kvdrRoleProfiles?.some(p => String(p.userId) === uidStr)) {
                foundRoles.add(r.title);
            }
            // Fallback check on the DOM node's data attribute, which is often more up-to-date
            const domNode = document.querySelector(`[data-empid='${r.selfId}']`);
            if (domNode && domNode.dataset.selectedUsr?.split(',').includes(uidStr)) {
                foundRoles.add(r.title);
            }
        }
        
        const rolesArray = Array.from(foundRoles);
        return rolesArray.length > 0 ? rolesArray.join(', ') : "Unassigned";
    };

    const getUserCurrentRoleNodeIds = (userId) => {
        if (!userId) return [];
        const uidStr = String(userId);
        const allRoles = (this.config().data && this.config().data.graphData) ? this.config().data.graphData : [];
        let foundIds = new Set();
        for (const r of allRoles) {
             if (r.profiles?.some(p => String(p.userId) === uidStr)) {
                foundIds.add(r.selfId);
            }
             if (r.kvdrRoleProfiles?.some(p => String(p.userId) === uidStr)) {
                foundIds.add(r.selfId);
            }
            const domNode = document.querySelector(`[data-empid='${r.selfId}']`);
            if (domNode && domNode.dataset.selectedUsr?.split(',').includes(uidStr)) {
                foundIds.add(r.selfId);
            }
        }
        return Array.from(foundIds);
    };

    const mainContainer = Utils.createElem("div", ["popup-main-container"], "", "");
    Utils.applyStyles(mainContainer, { display: "flex", flexDirection: "column", width: "100%", height: "100%", maxHeight: "70vh", position: "relative" });

    const searchRow = Utils.createElem("div", ["search-row"], "", "");
    Utils.applyStyles(searchRow, { display: "flex", alignItems: "center", padding: "16px 20px", gap: "12px", flexShrink: "0", borderBottom: "1px solid #f0f0f0", position: "relative", zIndex: "50" });
    const searchInputWrapper = Utils.createElem("div");
    Utils.applyStyles(searchInputWrapper, { flex: "1", position: "relative", display: "flex", alignItems: "center" });
    const searchInput = Utils.createElem("input", ["search-mem-box"], "search-mem-box", "");
    searchInput.type = "text"; searchInput.placeholder = "Search candidates...";
    Utils.applyStyles(searchInput, { width: "100%", padding: "10px 14px", border: "1px solid #E5E7EB", background: "#F9FAFB", borderRadius: "8px", fontFamily: "inherit", fontSize: "14px", outline: "none", transition: "border 0.2s ease" });
    searchInput.addEventListener("focus", () => searchInput.style.borderColor = e.displaySettings.cc || "#F2C244");
    searchInput.addEventListener("blur", () => searchInput.style.borderColor = "#E5E7EB");
    searchInputWrapper.append(searchInput);
    const filterWrapper = Utils.createElem("div");
    Utils.applyStyles(filterWrapper, { position: "relative" });
    const filterBtn = Utils.createElem("button");
    filterBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>`;
    Utils.applyStyles(filterBtn, { display: "flex", alignItems: "center", justifyContent: "center", width: "40px", height: "40px", background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", cursor: "pointer", color: "#6B7280", transition: "background 0.2s" });
    filterBtn.onmouseenter = () => filterBtn.style.background = "#F9FAFB";
    filterBtn.onmouseleave = () => filterBtn.style.background = "#fff";
    this.attachTooltip(filterBtn, "Filter by Role");
    const filterDropdown = Utils.createElem("div");
    Utils.applyStyles(filterDropdown, {
        position: "fixed", background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", boxShadow: "0 10px 25px rgba(0,0,0,0.15)", zIndex: "999999",
        minWidth: "220px", display: "none", flexDirection: "column", maxHeight: "250px", overflowY: "auto", padding: "8px 0"
    });
    let currentFilter = "all";
    const renderFilterDropdown = () => {
        filterDropdown.innerHTML = "";
        const graphDataSafe = (this.config().data && this.config().data.graphData) ? this.config().data.graphData : [];
        const roleOptions = [{ selfId: "all", title: "All Roles" }, { selfId: "unassigned", title: "Unassigned" }, ...graphDataSafe];
        roleOptions.forEach(r => {
            const opt = Utils.createElem("div");
            Utils.applyStyles(opt, { padding: "10px 16px", fontSize: "13px", color: "#374151", cursor: "pointer", transition: "background 0.2s", fontWeight: r.selfId === "all" ? "600" : "400", display: "flex", alignItems: "center", justifyContent: "space-between" });
            const titleSpan = Utils.createElem("span", [], "", r.title);
            opt.append(titleSpan);
            if (currentFilter === r.selfId) {
                const tick = Utils.createElem("span");
                tick.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="${e.displaySettings.cc || '#F2C244'}" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
                opt.append(tick);
                opt.style.background = "#F9FAFB";
            }
            opt.onmouseenter = () => { if (currentFilter !== r.selfId) opt.style.background = "#F3F4F6"; };
            opt.onmouseleave = () => { if (currentFilter !== r.selfId) opt.style.background = "transparent"; };
            opt.onclick = () => {
                currentFilter = r.selfId;
                renderFilterDropdown();
                applySearchAndFilter();
                filterDropdown.style.display = "none";
                filterBtn.style.color = currentFilter !== "all" ? (e.displaySettings.cc || "#F2C244") : "#6B7280";
                filterBtn.style.borderColor = currentFilter !== "all" ? (e.displaySettings.cc || "#F2C244") : "#E5E7EB";
            };
            filterDropdown.append(opt);
        });
    };
    renderFilterDropdown();
    filterBtn.onclick = (ev) => {
        ev.stopPropagation();
        if (filterDropdown.style.display === "flex") {
            filterDropdown.style.display = "none";
        } else {
            const rect = filterBtn.getBoundingClientRect();
            filterDropdown.style.top = (rect.bottom + 8) + "px";
            filterDropdown.style.left = (rect.right - 220) + "px";
            filterDropdown.style.display = "flex";
        }
    };
    document.addEventListener("click", (ev) => {
        if (!filterWrapper.contains(ev.target)) filterDropdown.style.display = "none";
    });
    filterWrapper.append(filterBtn);
    document.body.appendChild(filterDropdown);
    searchRow.append(searchInputWrapper, filterWrapper);

    const listHeader = Utils.createElem("div");
    Utils.applyStyles(listHeader, { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 20px", borderBottom: "1px solid #f0f0f0", background: "#fafafa", flexShrink: "0", minHeight: "56px", boxSizing: "border-box" });
    const listHeaderLeft = Utils.createElem("div");
    Utils.applyStyles(listHeaderLeft, { display: "flex", alignItems: "center" });
    const selectAllCb = Utils.createElem("input");
    selectAllCb.type = "checkbox";
    Utils.applyStyles(selectAllCb, { width: "16px", height: "16px", cursor: "pointer", accentColor: e.displaySettings.cc || "#F2C244", marginRight: "16px" });
    const listTotalLabel = Utils.createElem("span");
    Utils.applyStyles(listTotalLabel, { fontSize: "13px", color: "#6B7280", fontWeight: "500", transition: "color 0.2s" });
    const clearSelectionBtn = Utils.createElem("button", [], "", "Clear");
    Utils.applyStyles(clearSelectionBtn, { background: "transparent", border: "none", color: "#6B7280", fontSize: "12px", cursor: "pointer", padding: "0", textDecoration: "underline", marginLeft: "10px", display: "none" });
    clearSelectionBtn.onclick = () => {
        userList.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => { cb.checked = false; });
        selectAllCb.checked = false;
        updateHeaderState();
    };
    listHeaderLeft.append(selectAllCb, listTotalLabel, clearSelectionBtn);
    const listHeaderRight = Utils.createElem("div");
    Utils.applyStyles(listHeaderRight, { display: "none", alignItems: "center", gap: "10px" });
    const bulkAddBtn = Utils.createElem("button", ["bulk-add-btn"]);
    bulkAddBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>`;
    Utils.applyStyles(bulkAddBtn, {
        height: "32px", width: "32px", background: "#fff", color: "#374151", border: "1px solid #E5E7EB", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s"
    });
    bulkAddBtn.onmouseenter = () => bulkAddBtn.style.background = "#F9FAFB";
    bulkAddBtn.onmouseleave = () => bulkAddBtn.style.background = "#fff";
    bulkAddBtn.title = "Add to Role";
    const aiEvalButton = Utils.createElem("button", ["ai-eval-btn"], "", "");
    const btnYellowColor = e.displaySettings.cc || "#F2C244";
    aiEvalButton.innerHTML = `<img src="${AIGenerateIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" />`;
    Utils.applyStyles(aiEvalButton, {
        height: "32px", width: "32px", background: btnYellowColor, border: "none", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease"
    });
    listHeaderRight.append(bulkAddBtn, aiEvalButton);
    listHeader.append(listHeaderLeft, listHeaderRight);

    const userList = Utils.createElem("ul", ["user-list-container"], "", "");
    Utils.applyStyles(userList, { flex: "1", overflowY: "auto", overflowX: "hidden", display: "flex", flexDirection: "column", padding: "0", margin: "0" });

    searchInput.disabled = true;
    filterBtn.disabled = true;
    selectAllCb.disabled = true;
    mainContainer.style.pointerEvents = 'none';
    mainContainer.style.opacity = '0.8';
    for (let i = 0; i < 7; i++) {
        userList.append(createSkeletonRow());
    }
    
    // --- NEW: UNIFIED SORTING FUNCTION ---
    const sortUserList = () => {
        const listItems = Array.from(userList.querySelectorAll('li'));
        listItems.sort((a, b) => {
            const dataA = a.candidateData || {};
            const dataB = b.candidateData || {};

            // An AI suggestion is a candidate with a 'score' from the suggestions API.
            const isAiA = dataA.score !== undefined && dataA.score !== null;
            const isAiB = dataB.score !== undefined && dataB.score !== null;

            // Priority 1: AI-matched candidates go to the top.
            if (isAiA && !isAiB) return -1; // A comes first
            if (!isAiA && isAiB) return 1;  // B comes first

            // Priority 2: If both are AI-matched, sort by their score (descending).
            if (isAiA && isAiB) {
                return (parseFloat(dataB.score) || 0) - (parseFloat(dataA.score) || 0);
            }

            // Priority 3: If neither are AI-matched, sort by keyword match percentage (descending).
            const matchA = dataA.keywordMatch?.match_percentage || 0;
            const matchB = dataB.keywordMatch?.match_percentage || 0;
            return matchB - matchA;
        });

        // Re-append the sorted items to the DOM.
        listItems.forEach(li => userList.append(li));
    };

    // --- DYNAMIC LOGIC ---
    const updateListTotal = () => {
        const visibleRows = userList.querySelectorAll("li:not([style*='display: none'])");
        const checkedCount = userList.querySelectorAll("li:not([style*='display: none']) input[type='checkbox']:checked").length;
        
        if (checkedCount === 0) {
            listTotalLabel.innerText = `${visibleRows.length} candidates`;
        }
        
        const visibleCheckboxes = userList.querySelectorAll("li:not([style*='display: none']) input[type='checkbox']:not([disabled])");
        if (visibleCheckboxes.length > 0) {
            selectAllCb.checked = (checkedCount > 0 && checkedCount === visibleCheckboxes.length);
            selectAllCb.disabled = false;
        } else {
            selectAllCb.checked = false;
            selectAllCb.disabled = true;
        }
    };

    const applySearchAndFilter = () => {
        const searchTerm = searchInput.value.toLowerCase();
        userList.querySelectorAll("li").forEach(li => {
            const cand = li.candidateData;
            if(!cand) return;
            const text = li.innerText.toLowerCase();
            const matchesSearch = text.includes(searchTerm);
            
            let matchesFilter = true;
            if (currentFilter !== "all") {
                const candRoleIds = getUserCurrentRoleNodeIds(cand.id || cand.user_id);
                if (currentFilter === "unassigned") {
                    matchesFilter = candRoleIds.length === 0;
                } else {
                    matchesFilter = candRoleIds.includes(currentFilter);
                }
            }
            li.style.display = (matchesSearch && matchesFilter) ? "" : "none";
        });
        updateListTotal();
    };

    searchInput.addEventListener("keyup", applySearchAndFilter);

    const updateHeaderState = () => {
        const checkedBoxes = userList.querySelectorAll('input[type="checkbox"]:checked');
        const count = checkedBoxes.length;

        if (count > 0) {
            listTotalLabel.innerText = `${count} selected`;
            listTotalLabel.style.fontWeight = "600";
            listTotalLabel.style.color = "#111827";
            clearSelectionBtn.style.display = "inline-block";
            listHeaderRight.style.display = "flex";
            
            // Limit AI Evaluation to 5
            if (count > 5) {
                aiEvalButton.disabled = true;
                aiEvalButton.style.opacity = "0.5";
                aiEvalButton.style.cursor = "not-allowed";
                aiEvalButton.title = "Select max 5 profiles for re-evaluation at a time";
            } else {
                aiEvalButton.disabled = false;
                aiEvalButton.style.opacity = "1";
                aiEvalButton.style.cursor = "pointer";
                aiEvalButton.title = `Re-evaluate (${count})`;
            }
        } else {
            listTotalLabel.style.fontWeight = "500";
            listTotalLabel.style.color = "#6B7280";
            clearSelectionBtn.style.display = "none";
            listHeaderRight.style.display = "none";
        }
        updateListTotal();
    };

    selectAllCb.addEventListener("change", (ev) => {
        const isChecked = ev.target.checked;
        userList.querySelectorAll("li:not([style*='display: none']) input[type='checkbox']").forEach(cb => {
            if (cb.dataset.processing !== "true") {
                cb.checked = isChecked;
            }
        });
        updateHeaderState();
    });

    // --- CREATE ROW FUNCTION ---
    const createRow = (candidateData) => {
        const listItem = Utils.createElem("li", [], "", "");
        listItem.candidateData = candidateData;
        
        const cId = candidateData.id || candidateData.user_id;
        const cEmail = (candidateData.email || candidateData.emailId || "").toLowerCase().trim();
        if(cEmail) listItem.dataset.emailKey = cEmail;
        if(cId) listItem.dataset.uid = cId;

        listItem.rebuildRow = (candidate) => {
            listItem.innerHTML = "";
            const isAlreadySelected = selectedUsr.includes(String(candidate.id || candidate.user_id));
            
            let rawScore = candidate.score;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.matchScore;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.ai_score;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.fitment_score;

            const hasScore = rawScore !== undefined && rawScore !== null;
            const scoreVal = hasScore ? Math.round(parseFloat(rawScore)) : 0;

            const row = Utils.createElem("div", ["multi-select-box"], "", "");
            Utils.applyStyles(row, { display: "flex", alignItems: "center", padding: "12px 20px", cursor: "pointer", borderBottom: "1px solid #F3F4F6", background: "#fff", transition: "background 0.2s" });
            row.addEventListener("mouseenter", () => row.style.background = "#F9FAFB");
            row.addEventListener("mouseleave", () => row.style.background = "#fff");

            // Checkbox container
            const cbContainer = Utils.createElem("div", ["cb-container-box"], "", "");
            Utils.applyStyles(cbContainer, { width: "16px", height: "16px", marginRight: "16px", flexShrink: "0", display: "flex", alignItems: "center", justifyContent: "center" });

            if (!isAlreadySelected && !hasScore) {
                const userCheckbox = Utils.createElem("input", "", candidate.id || candidate.user_id, "");
                userCheckbox.type = "checkbox"; 
                userCheckbox.value = candidate.id || candidate.user_id;
                Utils.applyStyles(userCheckbox, { width: "16px", height: "16px", cursor: "pointer", accentColor: e.displaySettings.cc || "#F2C244", margin: "0" });
                userCheckbox.addEventListener("change", updateHeaderState);
                userCheckbox.addEventListener("click", (ev) => ev.stopPropagation()); 
                cbContainer.append(userCheckbox);
            }
            row.append(cbContainer);

            // Avatar
            const userImage = Utils.createElem("img", ["usrListImg"]);
            let avatarSrc = candidate.imageUrl || candidate.image_url;
            if (!avatarSrc) avatarSrc = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
            userImage.src = avatarSrc;
            Utils.applyStyles(userImage, { width: "38px", height: "38px", borderRadius: "50%", margin: "0 16px 0 0", flexShrink: "0", objectFit: "cover", border: "1px solid #E5E7EB" });
            
            // Info Box & Skill Tags (UPDATED LOGIC HERE)
            const infoBox = Utils.createElem("div");
            Utils.applyStyles(infoBox, { flex: "1", textAlign: "left", overflow: "hidden" });
            const dName = candidate.name || (candidate.email ? candidate.email.split('@')[0] : "Candidate");
            const currRoleTitle = getUserCurrentRoleTitles(candidate.id || candidate.user_id);
            
            let htmlContent = `<h5 style="margin:0;font-size:14px;color:#111827;font-weight:600;line-height:1.2;">${dName}</h5><span style="font-size:12px;color:#6B7280;margin-top:2px;display:block;">${currRoleTitle}</span>`;
            
            // Render Simple Keyword Matches
            if (candidate.keywordMatch) {
                let skillsHtml = '<div style="margin-top: 6px; display: flex; flex-wrap: wrap; gap: 4px;">';
                
                // if (candidate.keywordMatch.match_percentage !== undefined) {
                //      const pct = candidate.keywordMatch.match_percentage;
                //      const color = pct > 70 ? '#10B981' : pct > 30 ? '#F59E0B' : '#6B7280';
                //      skillsHtml += `<span style="font-size:10px; font-weight:bold; color:${color}; border: 1px solid ${color}; padding:2px 6px; border-radius:10px;">${pct}% Match</span>`;
                // }
                (candidate.keywordMatch.matched_skills || []).forEach(skill => {
                    skillsHtml += `<span style="background:#e6fffa; color:#00b894; border:1px solid #00b894; padding:2px 6px; border-radius:4px; font-size:10px; font-weight:500;">✓ ${skill}</span>`;
                });
                (candidate.keywordMatch.missing_skills || []).forEach(skill => {
                    skillsHtml += `<span style="background:#f3f4f6; color:#6b7280; border:1px solid #e5e7eb; padding:2px 6px; border-radius:4px; font-size:10px;">${skill}</span>`;
                });
                skillsHtml += '</div>';
                htmlContent += skillsHtml;
            }
            infoBox.innerHTML = htmlContent;
            row.append(userImage, infoBox);

            // Action Box (RESTORED ORIGINAL LOGIC)
            const actionBox = Utils.createElem("div", ["ai-status-box"]);
            Utils.applyStyles(actionBox, { display: "flex", alignItems: "center", gap: "8px", flexShrink: "0", marginLeft: "auto" });

            if (hasScore) {
                const scoreColor = scoreVal > 70 ? "#4caf50" : scoreVal >= 65 ? "#ff9800" : "#f44336";
                const scoreBadge = Utils.createElem("span", [], "", `${scoreVal}%`);
                Utils.applyStyles(scoreBadge, { fontSize: "12px", fontWeight: "bold", color: "#fff", background: scoreColor, padding: "4px 10px", borderRadius: "12px", cursor:"pointer" });
                
                scoreBadge.addEventListener("click", (evt) => {
                     evt.stopPropagation();
                     const orgConfig = e.data && e.data.kvdrOrgConfigData ? e.data.kvdrOrgConfigData : {};
                     this.previewCandidateFitment(candidate, e, roleNode, orgConfig);
                });
                actionBox.append(scoreBadge);

                if (isAlreadySelected) {
                    const addedText = Utils.createElem("span", [], "", "Added");
                    Utils.applyStyles(addedText, { color: "#10B981", fontSize: "12px", fontWeight: "bold", marginLeft: "4px" });
                    actionBox.append(addedText);
                } else {
                    if (scoreVal < 65) {
                        const autoRejectLabel = Utils.createElem("span", [], "", "Auto-Rejected");
                        Utils.applyStyles(autoRejectLabel, { color: "#f44336", fontWeight: "bold", fontSize: "11px", border: "1px solid #f44336", padding: "2px 6px", borderRadius: "12px", background: "#fff5f5" });
                        
                        const moreOptionsBtn = Utils.createElem("button", [], "", "•••");
                        Utils.applyStyles(moreOptionsBtn, { background: "#f0f0f0", color: "#666", border: "none", fontSize: "14px", fontWeight: "bold", cursor: "pointer", padding: "4px 8px", position: "relative", borderRadius: "4px" });
                        this.attachTooltip(moreOptionsBtn, "More Options");

                        const dropdown = Utils.createElem("div");
                        Utils.applyStyles(dropdown, { position: "absolute", top: "100%", right: "0", marginTop: "4px", background: "#fff", border: "1px solid #eee", borderRadius: "6px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: "100", display: "none", flexDirection: "column", minWidth: "130px", overflow: "hidden" });

                        const addItem = Utils.createElem("div", [], "", "Add to Role");
                        Utils.applyStyles(addItem, { padding: "8px 12px", fontSize: "12px", color: "#333", cursor: "pointer", borderBottom: "1px solid #f5f5f5", textAlign: "left" });
                        addItem.addEventListener("mouseenter", () => addItem.style.background = "#f9f9f9");
                        addItem.addEventListener("mouseleave", () => addItem.style.background = "#fff");
                        
                        addItem.addEventListener("click", async (evt) => {
                            evt.stopPropagation();
                            addItem.innerText = "Adding...";
                            
                            const targetId = candidate.id || candidate.user_id;
                            const sourceFitment = candidate.fitment_data || candidate.fitmentData || [];
                            const finalFitmentData = JSON.parse(JSON.stringify(sourceFitment));

                            const payload = { 
                                user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, 
                                score: candidate.score, reasoning: candidate.reasoning || "Manual Override", fitment_data: finalFitmentData, role_name: e.title 
                            };

                            try {
                                const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                                
                                if(apiRes.ok) { 
                                    const forcePatch = async () => {
                                        try {
                                            const fitmentPayload = { query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitmentData } };
                                            await e.onNodeProfileUpdate(fitmentPayload);
                                        } catch (e) {}
                                    };
                                    await forcePatch();
                                    setTimeout(forcePatch, 500);

                                    const existingLocal = e.candidateList.find(c => String(c.id) === String(targetId));
                                    if (!existingLocal) {
                                        e.candidateList.push(Object.assign({}, candidate, { id: targetId, fitmentData: finalFitmentData }));
                                    } else {
                                        existingLocal.fitmentData = finalFitmentData;
                                    }
                                    
                                    const current = roleNode.dataset.selectedUsr ? roleNode.dataset.selectedUsr.split(',') : [];
                                    if(!current.includes(String(targetId))) {
                                        current.push(targetId); 
                                        roleNode.dataset.selectedUsr = current.join(',');
                                    }

                                    const r = roleNode.querySelector("label>fieldset>div>span");
                                    if (r && !r.querySelector(`#img-${targetId}`)) {
                                        const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`);
                                        newImg.src = avatarSrc;
                                        Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
                                        
                                        const expandData = { kvdrRoleId: roleId, candidateList: e.candidateList, kvdrOrgConfigData: e.data.kvdrOrgConfigData, removeProfile: (pl) => e.onNodeRemoveProfileClick(pl), profileData: (p) => e.onNodeProfileFetch(p), profileUpdate: (p) => e.onNodeProfileUpdate(p), roleData: (p) => e.onNodeFetch(p), roleUpdate: (p) => e.onNodeUpdate(p), displaySettings: e.displaySettings };
                                        newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                                        r.prepend(newImg);
                                    }
                                    
                                    if(!selectedUsr.includes(String(targetId))) {
                                        selectedUsr.push(String(targetId));
                                        listItem.remove();
                                    }
                                    if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
                                }
                            } catch (err) { console.error(err); addItem.innerText = "Error"; }
                        });

                        const dismissItem = Utils.createElem("div", [], "", "Dismiss Profile");
                        Utils.applyStyles(dismissItem, { padding: "8px 12px", fontSize: "12px", color: "#f44336", cursor: "pointer", textAlign: "left" });
                        dismissItem.addEventListener("mouseenter", () => dismissItem.style.background = "#fff5f5");
                        dismissItem.addEventListener("mouseleave", () => dismissItem.style.background = "#fff");

                        dismissItem.addEventListener("click", async (evt) => {
                            evt.stopPropagation(); dismissItem.innerText = "Dismissing...";
                            const payload = { user_id: candidate.id || candidate.user_id, role_id: roleId, email: candidate.email || "", organization_id: orgId, role_name: roleTitle, send_email: true };
                            try {
                                const res = await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, { method: "POST", headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload) });
                                if(res.ok) listItem.remove();
                            } catch (err) { console.error(err); }
                        });

                        dropdown.append(addItem, dismissItem);
                        moreOptionsBtn.addEventListener("click", (evt) => {
                            evt.stopPropagation();
                            const isVisible = dropdown.style.display === "flex";
                            document.querySelectorAll('.auto-reject-dropdown').forEach(el => el.style.display = 'none');
                            dropdown.classList.add('auto-reject-dropdown');
                            if (!isVisible) {
                                dropdown.style.display = "flex";
                                const closeFn = () => { dropdown.style.display = "none"; document.removeEventListener("click", closeFn); };
                                setTimeout(() => document.addEventListener("click", closeFn), 0);
                            } else {
                                dropdown.style.display = "none";
                            }
                        });

                        const btnWrapper = Utils.createElem("div");
                        Utils.applyStyles(btnWrapper, { position: "relative" });
                        btnWrapper.append(moreOptionsBtn, dropdown);
                        actionBox.append(autoRejectLabel, btnWrapper);
                    } else {
                        const rejectBtn = Utils.createElem("button", [], "", "-");
                        Utils.applyStyles(rejectBtn, { background: "#ff4444", color: "#fff", border: "none", width: "28px", height: "28px", borderRadius: "50%", cursor: "pointer", fontSize: "18px", fontWeight: "bold", display:"flex", alignItems:"center", justifyContent:"center", paddingBottom:"2px" });
                        rejectBtn.addEventListener("click", async (evt) => {
                            evt.stopPropagation(); rejectBtn.innerText = ".."; rejectBtn.disabled = true;
                            const payload = { user_id: candidate.id || candidate.user_id, role_id: roleId, email: candidate.email || "", organization_id: orgId, role_name: roleTitle, send_email: true };
                            try {
                                const res = await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, { method: "POST", headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload) });
                                if(res.ok) listItem.remove();
                                else { rejectBtn.innerText = "-"; rejectBtn.disabled = false; }
                            } catch (err) { console.error(err); rejectBtn.innerText = "-"; rejectBtn.disabled = false; }
                        });

                        const addBtn = Utils.createElem("button", [], "", "+");
                        Utils.applyStyles(addBtn, { background:"#F2C244", color: "#fff", border: "none", width: "28px", height: "28px", borderRadius: "50%", cursor: "pointer", fontSize: "18px", fontWeight: "bold", display:"flex", alignItems:"center", justifyContent:"center" });
                        this.attachTooltip(addBtn, "Add to Role");

                        addBtn.addEventListener("click", async (evt) => {
                            evt.stopPropagation(); 
                            if(addBtn.disabled) return;
                            addBtn.innerText = "..";
                            addBtn.disabled = true;
                            const targetId = candidate.user_id || candidate.id;
                            
                            const rawFit = candidate.fitment_data || candidate.fitmentData || [];
                            const finalFitment = rawFit.map(item => ({ key: item.key, score: item.score || item.value || 0, remarks: item.remarks || item.reasoning || "" }));

                            const payload = { 
                                user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, 
                                score: candidate.score, reasoning: candidate.reasoning || "Manual", fitment_data: finalFitment, 
                                role_name: e.title, overwrite_existing: true 
                            };
                            
                            const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });

                            if(apiRes.ok) { 
                                const forcePatch = async () => {
                                    await e.onNodeProfileUpdate({ query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitment } });
                                };
                                await forcePatch();
                                setTimeout(forcePatch, 800);

                                const existingLocal = e.candidateList.find(c => String(c.id) === String(targetId));
                                if (existingLocal) { existingLocal.fitmentData = finalFitment; } 
                                else { e.candidateList.push(Object.assign({}, candidate, { id: targetId, fitmentData: finalFitment })); }
                                
                                const current = roleNode.dataset.selectedUsr ? roleNode.dataset.selectedUsr.split(',') : [];
                                if(!current.includes(String(targetId))) {
                                    current.push(targetId); 
                                    roleNode.dataset.selectedUsr = current.join(',');
                                }

                                const r = roleNode.querySelector("label>fieldset>div>span");
                                if (r && !r.querySelector(`#img-${targetId}`)) {
                                    const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`);
                                    newImg.src = avatarSrc;
                                    Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
                                    
                                    const expandData = { kvdrRoleId: roleId, candidateList: e.candidateList, kvdrOrgConfigData: e.data.kvdrOrgConfigData, removeProfile: (pl) => e.onNodeRemoveProfileClick(pl), profileData: (p) => e.onNodeProfileFetch(p), profileUpdate: (p) => e.onNodeProfileUpdate(p), roleData: (p) => e.onNodeFetch(p), roleUpdate: (p) => e.onNodeUpdate(p), displaySettings: e.displaySettings };
                                    newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                                    r.prepend(newImg);
                                }
                                
                                if(!selectedUsr.includes(String(targetId))) {
                                    selectedUsr.push(String(targetId));
                                    listItem.remove(); 
                                }
                                if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
                            } else {
                                addBtn.innerText = "+";
                                addBtn.disabled = false;
                            }
                        });
                        actionBox.append(rejectBtn, addBtn);
                    }
                }
            }

            // Restore Hover Tooltip for Evaluated Candidates
            let tooltipEl = null;
            if (hasScore && candidate.reasoning) {
                row.addEventListener("mouseenter", () => {
                    document.querySelectorAll('.custom-suggestion-tooltip').forEach(el => el.remove());
                    tooltipEl = Utils.createElem("div", ["custom-suggestion-tooltip"], "", `💡 ${candidate.reasoning}`);
                    Utils.applyStyles(tooltipEl, {
                        position: "fixed", backgroundColor: "#1f1f1f", color: "#fff", padding: "12px 16px", borderRadius: "8px", fontSize: "12px", maxWidth: "420px", zIndex: "200000", pointerEvents: "none", boxShadow: "0 6px 20px rgba(0,0,0,0.3)", lineHeight: "1.6", textAlign: "left", whiteSpace: "normal", wordWrap: "break-word", opacity: '0', transition: 'opacity 0.2s ease'
                    });
                    document.body.appendChild(tooltipEl);
                    requestAnimationFrame(() => { if(tooltipEl) tooltipEl.style.opacity = '1'; });
                    const rect = row.getBoundingClientRect();
                    let leftPos = rect.right + 12; let topPos = rect.top;
                    if (leftPos + tooltipEl.offsetWidth > window.innerWidth) leftPos = rect.left - tooltipEl.offsetWidth - 12;
                    tooltipEl.style.top = topPos + "px"; tooltipEl.style.left = leftPos + "px";
                });
                row.addEventListener("mouseleave", () => { 
                    if(tooltipEl) { tooltipEl.style.opacity = '0'; setTimeout(() => { if(tooltipEl) tooltipEl.remove() }, 200); tooltipEl = null; } 
                });
            }

            row.addEventListener("click", (evt) => {
                if (tooltipEl) { tooltipEl.remove(); tooltipEl = null; }
                if (evt.target.tagName === "BUTTON" || evt.target.tagName === "INPUT" || evt.target.closest('.ai-status-box')) return;
                
                if (hasScore) {
                    const orgConfig = (e.data && e.data.kvdrOrgConfigData) ? e.data.kvdrOrgConfigData : {};
                    this.previewCandidateFitment(candidate, e, roleNode, orgConfig);
                } else {
                    const checkbox = row.querySelector('input[type="checkbox"]');
                    if (checkbox && !checkbox.disabled) { 
                        checkbox.checked = !checkbox.checked;
                        checkbox.dispatchEvent(new Event('change'));
                    }
                }
            });

            row.append(actionBox);
            listItem.append(row);
        };

        listItem.rebuildRow(candidateData);
        return listItem;
    };

    // --- 5. BULK ADD LOGIC ---
    // --- 5. BULK ADD LOGIC ---
    bulkAddBtn.addEventListener("click", async (ev) => {
        ev.stopPropagation();
        const checkedBoxes = userList.querySelectorAll('input[type="checkbox"]:checked');
        if(checkedBoxes.length === 0) return;
        
        bulkAddBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai-icon-loading"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg>`;
        bulkAddBtn.disabled = true;

        const candidatesToAdd = [];
        Array.from(checkedBoxes).forEach(cb => {
            const li = cb.closest('li');
            if(li && li.candidateData) candidatesToAdd.push(li.candidateData);
        });

        // FIX: Replaced block-scoped "let i" with "for...of" to bypass the Babel "_loop$" reference bug
        for (const candidate of candidatesToAdd) {
            const targetId = candidate.user_id || candidate.id;
            
            let rawScore = candidate.score;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.matchScore;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.ai_score;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.fitment_score;
            
            const hasScore = rawScore !== undefined && rawScore !== null;

            if (hasScore) {
                const rawFit = candidate.fitment_data || candidate.fitmentData || [];
                const finalFitment = rawFit.map(item => ({ key: item.key, score: item.score || item.value || 0, remarks: item.remarks || item.reasoning || "" }));
                const payload = { 
                    user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, 
                    score: candidate.score, reasoning: candidate.reasoning || "Manual Bulk Assign", fitment_data: finalFitment, 
                    role_name: e.title, overwrite_existing: true 
                };
                
                try {
                    const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                    if(apiRes.ok) { 
                        await e.onNodeProfileUpdate({ query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitment } });
                        const existingLocal = e.candidateList.find(c => String(c.id) === String(targetId));
                        if (existingLocal) { existingLocal.fitmentData = finalFitment; } 
                        else { e.candidateList.push(Object.assign({}, candidate, { id: targetId, fitmentData: finalFitment })); }
                    }
                } catch (err) { console.error("Bulk add error:", err); continue; }
            } else {
                let avatarSrc = candidate.imageUrl || candidate.image_url;
                if (!avatarSrc) avatarSrc = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                const imgPlaceholder = { src: avatarSrc };
                await this._handleDestructiveUserMove(targetId, roleId, e, imgPlaceholder);
            }

            const current = roleNode.dataset.selectedUsr ? roleNode.dataset.selectedUsr.split(',') : [];
            if(!current.includes(String(targetId))) {
                current.push(targetId); 
                roleNode.dataset.selectedUsr = current.join(',');
            }

            const r = roleNode.querySelector("label>fieldset>div>span");
            if (r && !r.querySelector(`#img-${targetId}`)) {
                const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`);
                let avatarSrc = candidate.imageUrl || candidate.image_url;
                if (!avatarSrc) avatarSrc = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                newImg.src = avatarSrc;
                Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
                
                const kvdrDataConfig = (e.data && e.data.kvdrOrgConfigData) ? e.data.kvdrOrgConfigData : {};
                const expandData = { kvdrRoleId: roleId, candidateList: e.candidateList, kvdrOrgConfigData: kvdrDataConfig, removeProfile: (pl) => e.onNodeRemoveProfileClick(pl), profileData: (p) => e.onNodeProfileFetch(p), profileUpdate: (p) => e.onNodeProfileUpdate(p), roleData: (p) => e.onNodeFetch(p), roleUpdate: (p) => e.onNodeUpdate(p), displaySettings: e.displaySettings };
                
                newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                r.prepend(newImg);
            }
            
            const li = userList.querySelector(`li[data-uid="${targetId}"]`);
            if(li && !selectedUsr.includes(String(targetId))) {
                selectedUsr.push(String(targetId));
                li.remove(); 
            }
        }

        if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
        bulkAddBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>`;
        bulkAddBtn.disabled = false;
        
        userList.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => { cb.checked = false; });
        selectAllCb.checked = false;
        updateHeaderState();
    });

    // --- 6. ASSEMBLE INITIAL VIEW ---
    mainContainer.append(searchRow, listHeader, userList);
    let pollInterval; // Declare interval ID in a scope accessible by cleanup

    // This function will be called by the interval
    const pollForUpdates = async () => {
        if (!mainContainer.isConnected) {
            clearInterval(pollInterval);
            return;
        }
        try {
            const res = await fetch(`${API_BASE_URL}/api/talent-pool/suggestions/${orgId}/${roleId}?include_rejected=true&status=all&t=${Date.now()}`);
            const response = await res.json();
            const suggestionsArray = Array.isArray(response.data || response) ? (response.data || response) : [];
            let listWasChanged = false;

            suggestionsArray.forEach(c => {
                const cId = String(c.user_id || c.id);
                const cEmail = (c.email || c.emailId || "").toLowerCase().trim();
                if ((!cId || cId === "undefined") && !cEmail) return;

                // --- FIX: Stronger ID and Email check to prevent duplicates ---
                let existingCand = localCandidateList.find(cand => {
                    const candId = String(cand.id || cand.user_id);
                    const candEmail = (cand.email || cand.emailId || "").toLowerCase().trim();
                    if (cId && cId !== "undefined" && candId === cId) return true;
                    if (cEmail && candEmail === cEmail) return true;
                    return false;
                });

                if (existingCand) {
                    const oldImg1 = existingCand.imageUrl;
                    const oldImg2 = existingCand.image_url;
                    
                    // If candidate exists, merge new data. Check if score changed to avoid needless re-renders.
                    if (existingCand.score !== c.score) {
                        Object.assign(existingCand, c);
                        
                        // Preserve the valid profile picture if the API returned null/missing image.
                        if (!existingCand.imageUrl && oldImg1) existingCand.imageUrl = oldImg1;
                        if (!existingCand.image_url && oldImg2) existingCand.image_url = oldImg2;
                        
                        listWasChanged = true;
                    }
                } else {
                    // If it's a truly new candidate, add it to our local data array.
                    const newCandData = Object.assign({}, c, { id: cId !== "undefined" ? cId : undefined });
                    localCandidateList.push(newCandData);
                    listWasChanged = true;
                }
            });

            if (listWasChanged) {
                // If any data changed, rebuild the entire list from the single source of truth (localCandidateList).
                const currentScroll = userList.scrollTop; // Preserve scroll position
                userList.innerHTML = '';
                localCandidateList.forEach(cand => userList.append(createRow(cand)));
                sortUserList();
                applySearchAndFilter();
                updateListTotal();
                userList.scrollTop = currentScroll; // Restore scroll position
            }
        } catch (err) {
            console.error("Polling error:", err);
        }
    };

    const initializeAndLoadList = async () => {
        try {
            const keywordPromise = new Promise(async (resolve) => {
                const userIds = localCandidateList.map(c => c.id || c.user_id).filter(Boolean);
                if (userIds.length === 0) return resolve();
                try {
                    const res = await fetch(`${API_BASE_URL}/api/talent-pool/keyword-match`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ role_id: roleId, user_ids: userIds })
                    });
                    const result = await res.json();
                    if (result.status === 'success' && result.data) {
                        result.data.forEach(matchData => {
                            const matchId = String(matchData.user_id);
                            const cand = localCandidateList.find(c => String(c.id || c.user_id) === matchId);
                            if (cand) cand.keywordMatch = matchData;
                        });
                    }
                } catch (err) { console.error("Keyword match fetch failed", err); }
                resolve();
            });

            const initialSuggestionsPromise = new Promise(async (resolve) => {
                try {
                    const res = await fetch(`${API_BASE_URL}/api/talent-pool/suggestions/${orgId}/${roleId}?include_rejected=true&status=all&t=${Date.now()}`);
                    const response = await res.json();
                    const suggestionsArray = Array.isArray(response.data || response) ? (response.data || response) : [];
                    
                    suggestionsArray.forEach(c => {
                        const cId = String(c.user_id || c.id);
                        const cEmail = (c.email || c.emailId || "").toLowerCase().trim();
                        if ((!cId || cId === "undefined") && !cEmail) return;

                        let existingCand = localCandidateList.find(cand => {
                            const candId = String(cand.id || cand.user_id);
                            const candEmail = (cand.email || cand.emailId || "").toLowerCase().trim();
                            if (cId && cId !== "undefined" && candId === cId) return true;
                            if (cEmail && candEmail === cEmail) return true;
                            return false;
                        });

                        if (existingCand) {
                            const oldImg1 = existingCand.imageUrl;
                            const oldImg2 = existingCand.image_url;
                            Object.assign(existingCand, c);
                            if (!existingCand.imageUrl && oldImg1) existingCand.imageUrl = oldImg1;
                            if (!existingCand.image_url && oldImg2) existingCand.image_url = oldImg2;
                        } else {
                            localCandidateList.push(Object.assign({}, c, { id: cId !== "undefined" ? cId : undefined }));
                        }
                    });
                } catch (err) { console.error("Initial suggestions fetch failed", err); }
                finally { resolve(); }
            });

            await Promise.allSettled([keywordPromise, initialSuggestionsPromise]);

            userList.innerHTML = '';
            localCandidateList.forEach(c => userList.append(createRow(c)));
            sortUserList();
            applySearchAndFilter();
            updateListTotal();
        } catch (err) {
            console.error("Error during popup initialization:", err);
            userList.innerHTML = '<li style="text-align: center; padding: 20px; color: #dc3545;">Could not load candidates.</li>';
        } finally {
            mainContainer.style.pointerEvents = 'auto';
            mainContainer.style.opacity = '1';
            searchInput.disabled = false;
            filterBtn.disabled = false;
        }
    };

    initializeAndLoadList();
    pollInterval = setInterval(pollForUpdates, 5000);

    aiEvalButton.addEventListener('click', (ev) => {
        ev.stopPropagation();
        if (aiEvalButton.disabled) return;

        const checkedBoxes = userList.querySelectorAll('input[type="checkbox"]:checked');
        let usersToEval = [];
        if(checkedBoxes.length > 0) {
            Array.from(checkedBoxes).forEach(cb => {
                const rowLi = cb.closest('li');
                if (rowLi && rowLi.candidateData) {
                    const candEmail = rowLi.candidateData.email || rowLi.candidateData.emailId || "";
                    usersToEval.push({ email: candEmail, row: rowLi, candidate: rowLi.candidateData });
                }
            });
        }
        if(usersToEval.length === 0) return;

        usersToEval.reverse().forEach(u => {
            if (u.row && userList.contains(u.row)) {
                userList.prepend(u.row);
            }
        });

        aiEvalButton.disabled = true; 
        aiEvalButton.style.opacity = '0.7'; 
        aiEvalButton.style.cursor = 'wait';
        aiEvalButton.innerHTML = `<img src="${OrangeSpinnerIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" class="ai-icon-loading" />`;

        const allCheckboxes = userList ? userList.querySelectorAll('input[type="checkbox"]') : [];
        if (allCheckboxes) {
            allCheckboxes.forEach(cb => {
                if (cb) { 
                    cb.disabled = true;
                    cb.dataset.processing = "true"; 
                    const row = cb.closest('.multi-select-box');
                    if (row) { row.style.opacity = "0.6"; row.style.pointerEvents = "none"; }
                }
            });
        }

        const emailsToApi = [];
            usersToEval.forEach(u => {
                let email = u.email;
                if (!email && u.candidate) { email = u.candidate.email || u.candidate.emailId; }
                if(!email) return;

                emailsToApi.push(email);
                
                if (u.row) {
                    u.row.dataset.evalStatus = 'processing';
                    u.row.dataset.processing = 'true';
                }

                const statusBox = u.row ? u.row.querySelector('.ai-status-box') : null;
                if(statusBox) {
                    statusBox.innerHTML = ''; 
                    const loader = Utils.createElem("img", ["ai-icon-loading"]);
                    loader.src = OrangeSpinnerIcon; 
                    Utils.applyStyles(loader, { width: "20px", height: "20px", animation: "spin 1s linear infinite" });
                    statusBox.append(loader);
                }
            });

        if(emailsToApi.length > 0){ 
            this.triggerAiEvaluation(orgId, roleId, emailsToApi, userList, aiEvalButton); 
        }
    });

    const cleanupOnClose = () => {
        if (document.body.contains(filterDropdown)) filterDropdown.remove();
        clearInterval(pollInterval);
    };
    
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.removedNodes.forEach((node) => {
                if (node === mainContainer || node.contains(mainContainer)) {
                    cleanupOnClose();
                    observer.disconnect();
                }
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    if (activeTask) {
        if (aiEvalButton) {
            aiEvalButton.disabled = true;
            aiEvalButton.style.opacity = '0.7';
            aiEvalButton.innerHTML = `<img src="${OrangeSpinnerIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" class="ai-icon-loading" />`;
        }
        setTimeout(() => {
            if (!userList || !mainContainer.isConnected) return; 
            mainContainer.classList.add('evaluating-lock');
            userList.classList.add('evaluating-lock');
            if (bulkAddBtn) bulkAddBtn.disabled = true;
            if (searchInput) searchInput.disabled = true;

            userList.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                if (cb) { 
                    cb.disabled = true;
                    cb.dataset.processing = "true";
                    const row = cb.closest('.multi-select-box');
                    if (row) { row.style.opacity = '0.6'; row.style.pointerEvents = 'none'; }
                }
            });
            activeTask.emails.forEach(email => {
                const row = userList.querySelector(`li[data-email-key="${email.toLowerCase().trim()}"]`);
                
                if (row) {
                    userList.prepend(row);
                    row.dataset.evalStatus = 'processing';
                }
                
                const statusBox = row ? row.querySelector('.ai-status-box') : null;
                if (statusBox) {
                    statusBox.innerHTML = '';
                    const loader = Utils.createElem("img", ["ai-icon-loading"]);
                    loader.src = OrangeSpinnerIcon;
                    Utils.applyStyles(loader, { width: "20px", height: "20px", animation: "spin 1s linear infinite" });
                    statusBox.append(loader);
                }
            });
        }, 0);
        this._startAiEvaluationPolling(orgId, activeTask.taskId, userList, aiEvalButton, roleId);
    }

    updateHeaderState();
    return mainContainer;
}


    previewCandidateFitment(candidate, roleData, roleDomNode, passedConfig) {
        const roleTitle = roleData.title;
        const roleId = roleData.selfId;
        const orgId = this.getActualOrgId();
        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";

        const currentSelected = roleDomNode.dataset.selectedUsr ? roleDomNode.dataset.selectedUsr.split(',') : [];
        const isAlreadyAdded = currentSelected.includes(candidate.user_id || candidate.id);

        const container = Utils.createElem("div");
        Utils.applyStyles(container, {
            display: "flex", flexDirection: "column", height: "100%", width: "100%", overflow: "hidden", fontFamily: "inherit"
        });

        const headerSec = Utils.createElem("div");
        Utils.applyStyles(headerSec, {
            display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #eee", padding: "0 5px 10px 5px", marginBottom: "5px", flexShrink: "0"
        });

        const userInfo = Utils.createElem("div");
        Utils.applyStyles(userInfo, { display: "flex", alignItems: "center", gap: "12px" });
        const img = Utils.createElem("img");
        img.src = candidate.image_url || candidate.imageUrl || "https://cdn-icons-png.flaticon.com/512/149/149071.png";
        Utils.applyStyles(img, { width: "45px", height: "45px", borderRadius: "50%", objectFit: "cover", border: "1px solid #eee" });
        const textInfo = Utils.createElem("div");
        const name = Utils.createElem("h3", [], "", (candidate.name || (candidate.email ? candidate.email.split('@')[0] : "Candidate")));
        Utils.applyStyles(name, { margin: "0", fontSize: "15px", fontWeight: "600" });
        const email = Utils.createElem("span", [], "", candidate.email || candidate.emailId);
        Utils.applyStyles(email, { color: "#888", fontSize: "12px", display: "block" });
        textInfo.append(name, email);
        userInfo.append(img, textInfo);

        const actionContainer = Utils.createElem("div");
        Utils.applyStyles(actionContainer, { display: "flex", alignItems: "center", gap: "8px" });

        const scoreBox = Utils.createElem("div");
        let rawScore = candidate.score;
        if (rawScore === undefined || rawScore === null) rawScore = candidate.matchScore;
        if (rawScore === undefined || rawScore === null) rawScore = candidate.ai_score;
        const scoreVal = rawScore ? Math.round(parseFloat(rawScore)) : 0;
        const scoreColor = scoreVal > 75 ? "#4caf50" : scoreVal >= 65 ? "#ff9800" : "#f44336";
        Utils.applyStyles(scoreBox, {
            width: "40px", height: "40px", borderRadius: "50%", background: scoreColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "bold"
        });
        scoreBox.innerText = `${scoreVal}%`;

        if (!isAlreadyAdded) {
            if (scoreVal < 65) {
                const rejectedMsg = Utils.createElem("span", [], "", "Auto-Rejected");
                Utils.applyStyles(rejectedMsg, { color: "#f44336", fontWeight: "bold", fontSize: "13px", border: "1px solid #f44336", padding: "4px 8px", borderRadius: "5px", background: "#fff5f5" });
                const moreBtn = Utils.createElem("button", [], "", "•••");
                Utils.applyStyles(moreBtn, { background: "#f0f0f0", color: "#444", border: "none", width: "32px", height: "32px", borderRadius: "4px", cursor: "pointer", fontSize: "14px", fontWeight: "bold", marginLeft: "8px", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" });
                this.attachTooltip(moreBtn, "More Options");
                const dropdown = Utils.createElem("div");
                Utils.applyStyles(dropdown, { position: "absolute", top: "100%", right: "0", marginTop: "5px", background: "#fff", border: "1px solid #ddd", borderRadius: "6px", boxShadow: "0 5px 15px rgba(0,0,0,0.2)", zIndex: "10", display: "none", flexDirection: "column", minWidth: "140px", overflow: "hidden" });
                const addOpt = Utils.createElem("div", [], "", "Add to Role");
                Utils.applyStyles(addOpt, { padding: "10px", fontSize: "12px", color: "#333", cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontWeight: "500", textAlign: "left" });
                addOpt.onmouseenter = () => addOpt.style.background = "#f9f9f9";
                addOpt.onmouseleave = () => addOpt.style.background = "#fff";
                addOpt.onclick = async (e) => {
                    e.stopPropagation(); addOpt.innerText = "Adding...";
                    const targetId = candidate.user_id || candidate.id;
                    const rawFit = candidate.fitment_data || candidate.fitmentData || [];
                    const finalFitmentData = rawFit.map(i => ({ key: i.key, score: parseFloat(i.score || i.value || 0), remarks: i.remarks || i.reasoning || "" }));
                    const payload = { user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, score: scoreVal, reasoning: "Manual Override (Auto-Rejected)", fitment_data: finalFitmentData, role_name: roleTitle, overwrite_existing: true };
                    try {
                        const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                        if (apiRes.ok) {
                            const fitmentPayload = { query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitmentData } };
                            await roleData.onNodeProfileUpdate(fitmentPayload);
                            Utils.playBellSound(800, 840, 'square');
                            document.querySelector(".organiGramPopup.fitment-view")?.remove();
                            document.getElementById("back-drop-overlay").style.display = "none";
                            if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                            const currentUsers = roleDomNode.dataset.selectedUsr ? roleDomNode.dataset.selectedUsr.split(',') : [];
                            if (!currentUsers.includes(targetId)) { currentUsers.push(targetId); roleDomNode.dataset.selectedUsr = currentUsers.join(','); }
                            let localCand = roleData.candidateList.find(c => c.id === targetId);
                            if (localCand) { localCand.fitmentData = finalFitmentData; } else { roleData.candidateList.push({ ...candidate, id: targetId, fitmentData: finalFitmentData }); }
                            const r = roleDomNode.querySelector("label>fieldset>div>span");
                            const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`, "", { src: img.src });
                            Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit: "cover", objectPosition: "center", border: "2px solid", borderRadius: "50%", cursor: "pointer" });
                            const expandData = { kvdrRoleId: roleId, candidateList: roleData.candidateList, kvdrOrgConfigData: roleData.data.kvdrOrgConfigData, removeProfile: (pl) => roleData.onNodeRemoveProfileClick(pl), profileData: (p) => roleData.onNodeProfileFetch(p), profileUpdate: (p) => roleData.onNodeProfileUpdate(p), roleData: (p) => roleData.onNodeFetch(p), roleUpdate: (p) => roleData.onNodeUpdate(p), displaySettings: roleData.displaySettings };
                            newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                            r.prepend(newImg);
                            document.querySelector(`li[data-email-key="${(candidate.email || "").toLowerCase().trim()}"]`)?.remove();
                        }
                    } catch (err) { console.error(err); addOpt.innerText = "Error"; }
                };
                const dismissOpt = Utils.createElem("div", [], "", "Dismiss Profile");
                Utils.applyStyles(dismissOpt, { padding: "10px", fontSize: "12px", color: "#f44336", cursor: "pointer", fontWeight: "500", textAlign: "left" });
                dismissOpt.onmouseenter = () => dismissOpt.style.background = "#fff5f5";
                dismissOpt.onmouseleave = () => dismissOpt.style.background = "#fff";
                dismissOpt.onclick = async (e) => {
                    e.stopPropagation(); dismissOpt.innerText = "Dismissing...";
                    const payload = { user_id: candidate.id || candidate.user_id, role_id: roleId, email: candidate.email || "", organization_id: orgId, role_name: roleTitle, send_email: true };
                    try {
                        const res = await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, { method: "POST", headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload) });
                        if (res.ok) {
                            document.querySelector(".organiGramPopup.fitment-view")?.remove();
                            document.getElementById("back-drop-overlay").style.display = "none";
                            if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                            document.querySelector(`li[data-email-key="${(candidate.email || "").toLowerCase().trim()}"]`)?.remove();
                        }
                    } catch (err) { console.error(err); }
                };
                dropdown.append(addOpt, dismissOpt);
                const btnWrapper = Utils.createElem("div");
                Utils.applyStyles(btnWrapper, { position: "relative" });
                btnWrapper.append(moreBtn, dropdown);
                moreBtn.onclick = (e) => {
                    e.stopPropagation();
                    const isVisible = dropdown.style.display === "flex";
                    if (!isVisible) {
                        dropdown.style.display = "flex";
                        const closeFn = () => { dropdown.style.display = "none"; document.removeEventListener("click", closeFn); };
                        setTimeout(() => document.addEventListener("click", closeFn), 0);
                    } else { dropdown.style.display = "none"; }
                };
                actionContainer.append(scoreBox, rejectedMsg, btnWrapper);
            } else {
                const rejectBtn = Utils.createElem("button", [], "", "-");
                Utils.applyStyles(rejectBtn, { background: "#ff4444", color: "#fff", border: "none", width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer", fontSize: "20px", fontWeight: "bold" });
                const addBtn = Utils.createElem("button", [], "", "+");
                Utils.applyStyles(addBtn, { background: "#F2C244", color: "#fff", border: "none", width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer", fontSize: "20px", fontWeight: "bold" });
                addBtn.onclick = async () => {
                    addBtn.innerHTML = ".."; addBtn.disabled = true;
                    try {
                        const targetId = candidate.user_id || candidate.id;
                        const rawFit = candidate.fitment_data || candidate.fitmentData || [];
                        const finalFitmentData = rawFit.map(i => ({ key: i.key, score: parseFloat(i.score || i.value || 0), remarks: i.remarks || i.reasoning || "" }));
                        const payload = { user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, score: scoreVal, reasoning: candidate.reasoning || "Manual", fitment_data: finalFitmentData, role_name: roleTitle, overwrite_existing: true };
                        const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                        if (apiRes.ok) {
                            const fitmentPayload = { query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitmentData } };
                            await roleData.onNodeProfileUpdate(fitmentPayload);
                            Utils.playBellSound(800, 840, 'square');
                            document.querySelector(".organiGramPopup.fitment-view")?.remove();
                            document.getElementById("back-drop-overlay").style.display = "none";
                            if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                            const currentUsers = roleDomNode.dataset.selectedUsr ? roleDomNode.dataset.selectedUsr.split(',') : [];
                            if (!currentUsers.includes(targetId)) { currentUsers.push(targetId); roleDomNode.dataset.selectedUsr = currentUsers.join(','); }
                            let localCand = roleData.candidateList.find(c => c.id === targetId);
                            if (localCand) { localCand.fitmentData = finalFitmentData; } else { roleData.candidateList.push({ ...candidate, id: targetId, fitmentData: finalFitmentData }); }
                            const r = roleDomNode.querySelector("label>fieldset>div>span");
                            const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`, "", { src: img.src });
                            Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit: "cover", objectPosition: "center", border: "2px solid", borderRadius: "50%", cursor: "pointer" });
                            const expandData = { kvdrRoleId: roleId, candidateList: roleData.candidateList, kvdrOrgConfigData: roleData.data ? roleData.data.kvdrOrgConfigData : roleData.kvdrOrgConfigData, removeProfile: (pl) => roleData.onNodeRemoveProfileClick(pl), profileData: (p) => roleData.onNodeProfileFetch(p), profileUpdate: (p) => roleData.onNodeProfileUpdate(p), roleData: (p) => roleData.onNodeFetch(p), roleUpdate: (p) => roleData.onNodeUpdate(p), displaySettings: roleData.displaySettings };
                            newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                            r.prepend(newImg);
                        } else { alert("Failed to add."); addBtn.innerHTML = "+"; addBtn.disabled = false; }
                    } catch (err) { console.error(err); addBtn.innerHTML = "!"; addBtn.disabled = false; }
                };
                rejectBtn.onclick = async () => {
                    rejectBtn.innerHTML = ".."; rejectBtn.disabled = true;
                    const payload = { user_id: candidate.id || candidate.user_id, role_id: roleId, email: candidate.email || "", organization_id: orgId, role_name: roleTitle, send_email: true };
                    try {
                        await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, { method: "POST", headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload) });
                        document.querySelector(".organiGramPopup.fitment-view")?.remove();
                        document.getElementById("back-drop-overlay").style.display = "none";
                        if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                        document.querySelector(`li[data-email-key="${(candidate.email || "").toLowerCase().trim()}"]`)?.remove();
                    } catch (err) { console.error(err); rejectBtn.innerHTML = "-"; rejectBtn.disabled = false; }
                };
                actionContainer.append(scoreBox, rejectBtn, addBtn);
            }
        } else {
            const addedLabel = Utils.createElem("span", [], "", "Added");
            Utils.applyStyles(addedLabel, { color: "#4caf50", fontWeight: "bold", fontSize: "13px" });
            actionContainer.append(scoreBox, addedLabel);
        }
        headerSec.append(userInfo, actionContainer);

        const contentArea = Utils.createElem("div");
        Utils.applyStyles(contentArea, { flex: "1", overflowY: "auto", overflowX: "hidden", display: "flex", flexDirection: "column", border: "1px solid #eee", borderRadius: "4px" });

        const tableHeader = Utils.createElem("div");
        Utils.applyStyles(tableHeader, { display: "flex", padding: "6px 0", borderBottom: "1px solid #ddd", fontWeight: "700", color: "#444", fontSize: "12px", background: "#f8f9fa" });
        tableHeader.innerHTML = `<div style="width: 260px; padding-left: 55px; text-align: left;">Attribute</div><div style="width: 60px; text-align: center;">Weight</div><div style="flex: 1; text-align: center;">Score</div>`;
        contentArea.append(tableHeader);

        const rawFitmentData = candidate.fitment_data || candidate.fitmentData || [];
        const orgConfig = passedConfig || (this.config().data ? this.config().data.kvdrOrgConfigData : {});
        const dynamicOrgConfig = this.getDynamicConfig(orgConfig);
        let fitmentStructure = dynamicOrgConfig['fitment'] || dynamicOrgConfig['fitmentData'] || dynamicOrgConfig['fitment_data'];
        
        const catColors = ["#FFFBE5", "#E5FFEA", "#E5F3FF", "#F8E5FF", "#FFE5E5"];
        let colorIdx = 0;
        
        // --- THIS IS THE FIX: Load dynamic calc types instead of a hardcoded VAL_MAP ---
        const calcTypes = dynamicOrgConfig.calculationTypes || [
            { value: 0, color: "#e0e0e0", title: "Absent" },
            { value: -1, color: "#f44336", title: "Poor" },
            { value: 1, color: "#FFC107", title: "Good" },
            { value: 1.5, color: "#4caf50", title: "Exceptional" }
        ];

        if (fitmentStructure) {
            Object.keys(fitmentStructure).forEach(groupName => {
                const attributes = fitmentStructure[groupName];
                const groupRow = Utils.createElem("div");
                Utils.applyStyles(groupRow, { display: "flex", borderBottom: "1px solid #eee", alignItems: "stretch" });
                const sidebar = Utils.createElem("div", [], "", groupName);
                Utils.applyStyles(sidebar, { backgroundColor: catColors[colorIdx % catColors.length], width: "40px", display: "flex", alignItems: "center", justifyContent: "center", writingMode: "vertical-rl", transform: "rotate(180deg)", fontWeight: "bold", fontSize: "10px", color: "#555", padding: "5px 0", borderRight: "1px solid #ddd", flexShrink: "0" });
                colorIdx++;
                const rowsContainer = Utils.createElem("div");
                Utils.applyStyles(rowsContainer, { flex: "1", display: "flex", flexDirection: "column" });
                attributes.forEach(attr => {
                    const row = Utils.createElem("div");
                    Utils.applyStyles(row, { display: "flex", alignItems: "center", padding: "4px 0", minHeight: "34px" });
                    const label = Utils.createElem("div", [], "", attr.title);
                    Utils.applyStyles(label, { width: "220px", fontSize: "12px", fontWeight: "500", color: "#333", paddingLeft: "15px", textAlign: "left" });
                    const weight = Utils.createElem("div", [], "", attr.value || "10");
                    Utils.applyStyles(weight, { width: "60px", textAlign: "center", fontSize: "12px", color: "#666" });
                    const scoreData = rawFitmentData.find(i => i.key === attr.key);
                    const aiReasoning = scoreData ? (scoreData.remarks || scoreData.reasoning) : "No AI analysis available for this attribute.";
                    let val = scoreData ? parseFloat(scoreData.score || scoreData.value) : 0;
                    if(isNaN(val)) val = 0;
                    const dotContainer = Utils.createElem("div");
                    Utils.applyStyles(dotContainer, { flex: "1", display: "flex", justifyContent: "center" });
                    const dot = Utils.createElem("div");

                    // --- THIS IS THE FIX: Use the dynamic calcTypes array to find the color ---
                    const configColorObj = calcTypes.find(type => parseFloat(type.value) === parseFloat(val));
                    const dotColor = configColorObj ? configColorObj.color : "#cbd5e1";

                    Utils.applyStyles(dot, { width: "20px", height: "20px", borderRadius: "50%", backgroundColor: dotColor, border: "1px solid rgba(0,0,0,0.1)", cursor: "help" });
                    dot.addEventListener("mouseenter", () => {
                        const tooltip = document.createElement("div");
                        tooltip.className = "fitment-ai-reasoning-tip";
                        tooltip.innerText = aiReasoning;
                        Object.assign(tooltip.style, { position: "fixed", background: "rgba(33, 33, 33, 0.95)", color: "#fff", padding: "8px 12px", borderRadius: "6px", fontSize: "12px", lineHeight: "1.4", maxWidth: "280px", zIndex: "1000000", pointerEvents: "none", boxShadow: "0 4px 15px rgba(0,0,0,0.3)", fontFamily: "inherit", whiteSpace: "normal", wordWrap: "break-word" });
                        document.body.appendChild(tooltip);
                        const rect = dot.getBoundingClientRect();
                        const tipRect = tooltip.getBoundingClientRect();
                        tooltip.style.top = (rect.top - tipRect.height - 10) + "px";
                        tooltip.style.left = (rect.left - (tipRect.width / 2) + (rect.width / 2)) + "px";
                    });
                    dot.addEventListener("mouseleave", () => { document.querySelectorAll(".fitment-ai-reasoning-tip").forEach(el => el.remove()); });
                    dotContainer.append(dot); row.append(label, weight, dotContainer); rowsContainer.append(row);
                });
                groupRow.append(sidebar, rowsContainer); contentArea.append(groupRow);
            });
        }

        container.append(headerSec, contentArea);
        const footer = Utils.createElem("div");
        Utils.applyStyles(footer, { display: "flex", justifyContent: "center", gap: "15px", padding: "10px 0", borderTop: "1px solid #eee", fontSize: "11px", fontWeight: "bold" });
        const createLegendItem = (color, text) => {
            const item = Utils.createElem("div");
            Utils.applyStyles(item, { display: "flex", alignItems: "center", gap: "5px" });
            const d = Utils.createElem("div");
            Utils.applyStyles(d, { width: "10px", height: "10px", borderRadius: "50%", background: color });
            item.append(d, document.createTextNode(text));
            return item;
        };

        // --- THIS IS THE FIX: Dynamically build the legend ---
        calcTypes.forEach(ct => {
            footer.append(createLegendItem(ct.color, `${ct.title} (${ct.value})`));
        });

        container.append(footer);

        const popupConfig = {
            headerText: `Fitment Details: ${roleTitle}`,
            onCloseClick: () => { document.querySelector(".organiGramPopup.fitment-view")?.remove(); document.getElementById("back-drop-overlay").style.display = "none"; if (typeof isViewportActive !== 'undefined') isViewportActive.status = true; },
            data: container, displaySettings: { width: "900px", height: "600px" }, footer: "" 
        };
        const popup = this.createPopup(popupConfig);
        popup.classList.add("fitment-view");
        const bodyPart = popup.querySelector('.OrganiGramPopupBody');
        if(bodyPart) { bodyPart.style.height = "100%"; bodyPart.style.display = "flex"; bodyPart.style.padding = "10px 15px"; }
        const backdrop = document.getElementById("back-drop-overlay");
        backdrop.innerHTML = ""; backdrop.style.display = "flex"; backdrop.append(popup);
    }
    
    _popupUsrListSelectFunction = async (e, t) => {
        const a = event.target.closest("div#candidate-list-popup").dataset.selectedNode,
            r = document.querySelector("[data-empid='" + a + "']>label>fieldset>div>span"),
            s = document.querySelector("[data-empid='" + a + "']").dataset.selectedUsr.split(","),
            v = event.target.value,
            o = {
            kvdrRoleId: a,
            candidateList: e.candidateList,
            kvdrOrgConfigData: e.data.kvdrOrgConfigData || e.kvdrOrgConfigData,
            removeProfile: (a) => {
                e.onNodeRemoveProfileClick(a), (t.innerHTML = ""), (t.style.display = "none");
            },
            profileData: async (a) => { return e.onNodeProfileFetch(a) },
            profileUpdate:async  (t) => {return e.onNodeProfileUpdate(t)},
            roleData: async (t) => {return e.onNodeFetch(t)},
            roleUpdate: async (t) => {return e.onNodeUpdate(t)},
            displaySettings : e.displaySettings,
        },
        _selectedUser = Utils.createElem("img", ["selectedUsrImg"], "img-" + v, "",{ src : event.target.parentNode.childNodes[1].src});
        Utils.applyStyles(_selectedUser,{ 
            position: "relative", marginLeft: "-5px",
            width: "32px",
            height: "32px",
            objectFit:"cover",objectPosition:"center",
            border:"2px solid",borderRadius:"50%"
        })
        if (s.includes(v)){
            if ("vibrate" in navigator) {
                navigator.vibrate(200);
            } else {
                console.log("Vibration API not supported on this device.");
            }
            Utils.playBellSound(800,840,'square');
            return;
        }  
        else {
            _selectedUser.addEventListener("click", (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                this.expandRole(o,'Talent',[v]);
            });

            r.prepend(_selectedUser);
            document.querySelector("[data-empid='" + a + "']").dataset.selectedUsr += `,${v}`;
            const l = { roleId: a, userId: v };
            
            // 1. Wait for the API to confirm the add
            await e.onNodeAddProfileClick(l);
            
            // 2. SOFT REFRESH LOGIC (FIXED)
            // We fetch latest data to keep internal state synced, but we REMOVED createKVDR()
            // to prevent wiping the DOM while the popup is still open.
            if (typeof e.onNodeFetch === 'function') {
                const query = `kvdrId=${this.config().id}`;
                const latestData = await e.onNodeFetch(query);
                
                // Silent Update: Keep data synced for future actions
                this.config().data.graphData = latestData;
            }
        }
    }
    uploadDesignations = (e, t) => {
        const a = Utils.createElem("div", ["chartCanvasLeftPanel"], "", "");
        a.style.cssText = "position:relative;height:" + t + "px;flex:0 0 200px;overflow:auto;border-right:1px solid #f1f5f9";
        const r = Utils.createElem("ul", ["desigList"], "", "<li>Upload designations</li>"),
            s = Utils.createElem("input", ["uploadDesingnation","hidden"], "upload-designation", "");
        (s.type = "file"), (s.accept = ".csv");
        const o = Utils.createElem("i", ["uploadDesingnationImg"], "upload-designation-img", "");
        o.style.cssText = "font-size:1.2em;";
        const n = Utils.createElem("label", ["uploadDesingnationLbl"], "upload-designation-lbl", "");
        (n.htmlFor = s.id),
            (n.style.cssText = "display:flex;padding:5px;font-size:2em;place-content:center;position:sticky;top:0;background:#fff;"),
            n.append(o, s),
            a.append(n, r),
            e.prepend(a),
            s.addEventListener("change", function (e) {
                e.stopPropagation();
                const t = e.target.files[0],
                    a = new FileReader();
                a.readAsText(t),
                    (a.onload = function (e) {
                        let t = JSON.parse(Utils.CSVToJSON(e.target.result));
                        if (t.length) {
                            r.innerHTML = "";
                            for (let e = 0; e < t.length - 1; e++) {
                                let a,
                                    s = t[e].Label;
                                if (((a = t[e].id ? t[e].id : "lbl_desig_" + e), "" !== s || null !== s)) {
                                    const e = Utils.createElem("li", "", a, s);
                                    (e.style.cssText = "padding:5px;cursor:pointer;border-bottom: 1px solid #f1f5f9;"), r.append(e);
                                }
                            }
                        }
                    }),
                    (a.onerror = function (e) {
                        console.log("error reading file", e);
                    });
            });
    };
    createKVDRSwitchDisplayButtons(e, t, a) {
        let r = a.type;
        const s = Utils.createElem("div", ["switchBtnBox"], "", "");
        Array.from(["F", "A", "S"]).forEach((e, t) => {
            const o = Utils.createElem("label", ["switchBtnLbl"], "", e);
            (o.htmlFor = t + "_" + e), (o.style.cssText = "display:flex;flex-flow:column;margin:auto;place-item:center;padding:5px;border-radius:3px"), r === e && (o.style.background = a.displaySettings.cardColor);
            const n = Utils.createElem("input", ["switchBtn"], t + "_" + e, e);
            (n.type = "radio"), n.setAttribute("name", "switchBtnGrp"), n.setAttribute("value", e), (n.style.display = "none"), a.type == e && n.setAttribute("checked", !0), o.append(n), s.append(o);
        });
        let o = document.querySelector("#" + e);
        o.prepend(s);
        let n = o.querySelectorAll(".switchBtn");
        Array.from(n).forEach((e) => {
            e.addEventListener("click", function () {
                (a.type = this.value), r !== a.type && (alert(a.type), (this.createKVDR = a));
            });
        });
    }
    notificationsPanel = (container) => {
        const notifyContainer = Utils.createElem('div');
        Utils.applyStyles(notifyContainer, { 
            width: '45px', 
            height: '45px', 
            position: 'relative', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            marginRight: '0px' // Remove extra gap so they sit close
        });
    
        this.notifyBtn = Utils.createElem('button', [], '', '');
        
        const bellImg = Utils.createElem('i', [
            "vs-icon",
            "notranslate",
            "icon-scale",
            "feather",
            "icon-bell"
        ]);

        Utils.applyStyles(bellImg, {
            fontSize: '20px',        // cleaner toolbar size
            color: '#FFC107',
            display: 'block',
            pointerEvents: 'none'
        });
        Utils.applyStyles(this.notifyBtn, { 
            background: 'transparent',
            padding: '0',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            outline: 'none',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            transition: 'background 0.2s ease, color 0.2s ease'
        });
        this.attachTooltip(this.notifyBtn, "Notifications");

        this.notifyBtn.title = "Notifications";
        this.notifyBtn.addEventListener('mouseenter', () => {
        this.notifyBtn.style.background = '#FFC107';
            bellImg.style.color = '#fff';
        });

        this.notifyBtn.addEventListener('mouseleave', () => {
        this.notifyBtn.style.background = 'transparent';
            bellImg.style.color = '#FFC107';
        });
        this.notifyBtn.append(bellImg);

        this.notifyBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleNotifications(this.notifyPanel);
        });

    
        this.badge = Utils.createElem('span', [], '', '');
        Utils.applyStyles(this.badge, {
            position: 'absolute',
            top: '8px',   // Adjusted for new size
            right: '8px', // Adjusted for new size
            background: '#FFD700',
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
            borderRadius: '50%',
            minWidth: '14px',
            height: '14px',
            lineHeight: '14px',
            textAlign: 'center',
            display: 'none',
            border: '1px solid #fff',
            zIndex: '10',
            boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
        });
        this.notifyBtn.append(this.badge);
    
        this.notifyPanel = Utils.createElem('div', ['notifyPanel'], 'notification-panel');
        Utils.applyStyles(this.notifyPanel, { 
            position: 'absolute', border: 'none', right: '-5px', top: '45px', 
            boxShadow: '0 4px 15px rgba(0,0,0,0.15)', padding: '0', display: 'none', 
            zIndex: '9999', background: '#fff', width: '300px', maxHeight: '400px', 
            overflowY: 'auto', borderRadius: '8px'
        });
    
        notifyContainer.append(this.notifyBtn, this.notifyPanel);
        container.prepend(notifyContainer);
        if (!this.notifyPanel || !document.body.contains(this.notifyPanel)) {
            this.notifyPanel = Utils.createElem('div', ['notifyPanel'], 'notification-panel');
            Utils.applyStyles(this.notifyPanel, {
                position: 'fixed', // Use 'fixed' to break out of parent stacking contexts
                display: 'none',
                zIndex: '100000', // Very high z-index to appear above all other elements
                width: '300px',
                maxHeight: '400px',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                overflowY: 'auto',
                padding: '0'
            });
            document.body.appendChild(this.notifyPanel);
        }
        
        document.addEventListener('click', (e) => {
            if (this.notifyPanel && this.notifyPanel.style.display === 'block') {
                // Hide if the click is outside both the button and the panel itself
                if (!notifyBtnContainer.contains(e.target) && !this.notifyPanel.contains(e.target)) {
                    this.notifyPanel.style.display = 'none';
                }
            }
        });

        this.startAutoNotificationRefresh();
    }
    createImportResumesBtn = (container) => {
        const importBtnContainer = Utils.createElem('div');
        
        Utils.applyStyles(importBtnContainer, { 
            position: 'relative', display: 'flex', alignItems: 'center', 
            justifyContent: 'center', marginLeft: 'auto', gap: '8px' // Added gap for spacing
        });

        // --- NEW: Plain text span ---
        const importText = Utils.createElem('span', [], '', 'Import Resumes');
        Utils.applyStyles(importText, {
            fontSize: '15px',
            fontWeight: '600',
            color: '#111827', // Matches standard dark text
            fontFamily: 'inherit'
        });

        const importBtn = Utils.createElem('button', [], '', '');

        const uploadImg = Utils.createElem('i', [
            "vs-icon", "notranslate", "icon-scale", "feather", "icon-file-text"
        ]);

        Utils.applyStyles(uploadImg, { 
            fontSize: '20px',
            color: '#28C76F', 
            display: 'block',
            pointerEvents: 'none',
            lineHeight: '1'
        });

        Utils.applyStyles(importBtn, { 
            background: 'transparent',
            padding: '0',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            outline: 'none',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            transition: 'background 0.2s ease, color 0.2s ease'
        });

        importBtn.appendChild(uploadImg);

        this.attachTooltip(importBtn, "Import Resumes");

        importBtn.addEventListener('mouseenter', () => {
            importBtn.style.background = '#28C76F';
            uploadImg.style.color = '#fff';
        });

        importBtn.addEventListener('mouseleave', () => {
            importBtn.style.background = 'transparent';
            uploadImg.style.color = '#28C76F';
        });

        importBtn.addEventListener('click', () => {
            const orgSlug = this.config().slug;
            if (orgSlug) localStorage.setItem(`onboardingStep_${orgSlug}`, '2');
            this.openResumeUploadModal();
        });

        // Append the text first, then the circular button
        importBtnContainer.append(importText, importBtn);
        container.append(importBtnContainer);
    }
    openResumeUploadModal() {
        // --- 1. STATE & CONSTANTS ---
        const orgId = this.config().id;
        const stateKey = `resume_upload_state_${orgId}`;
        const API_TOKEN = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";
        
        // Internal State (Reactive-ish)
        const state = {
            localBatchIds: [],
            batchesData: {},
            uploadQueue: [],
            isUploading: false,
            pollingInterval: null
        };

        // --- 2. CSS STYLES INJECTION ---
        if (!document.getElementById('resume-modal-styles')) {
            const css = `
                .resume-drop-zone { border: 2px dashed #e2e8f0; border-radius: 12px; background: #f8fafc; display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 250px; cursor: pointer; transition: all 0.3s; }
                .resume-drop-zone:hover, .resume-drop-zone.dragover { background: #f1f5f9; border-color: #94a3b8; }
                .resume-file-list { max-height: 300px; overflow-y: auto; padding-right: 5px; margin-top: 15px; }
                .resume-file-item { padding: 10px 0; border-bottom: 1px solid #f1f1f1; }
                .resume-progress-track { width: 100%; height: 6px; background: #f0f2f5; border-radius: 3px; margin-top: 6px; overflow: hidden; }
                .resume-progress-fill { height: 100%; transition: width 0.3s ease; }
                .bg-success { background-color: #28c76f !important; }
                .bg-danger { background-color: #ea5455 !important; }
                .bg-warning { background-color: #ff9f43 !important; }
                .text-success { color: #28c76f; } .text-danger { color: #ea5455; }
            `;
            const style = document.createElement('style');
            style.id = 'resume-modal-styles';
            style.innerHTML = css;
            document.head.appendChild(style);
        }

        // --- 3. DOM ELEMENTS ---
        const contentWrapper = Utils.createElem('div');
        Utils.applyStyles(contentWrapper, { width: '100%', height: '100%', display: 'flex', flexDirection: 'column' });
        
        // Hidden Input
        const fileInput = Utils.createElem('input');
        fileInput.type = 'file'; fileInput.multiple = true; fileInput.accept = '.pdf,.doc,.docx,.txt'; fileInput.style.display = 'none';

        // --- 4. LOGIC FUNCTIONS ---

        const persistState = () => {
            if(state.localBatchIds.length === 0 && state.uploadQueue.length === 0) return;
            const storagePayload = {
                localBatchIds: state.localBatchIds,
                batchesData: state.batchesData,
                uploadQueue: state.uploadQueue,
                timestamp: Date.now()
            };
            localStorage.setItem(stateKey, JSON.stringify(storagePayload));
        };

        const loadState = () => {
            try {
                const saved = localStorage.getItem(stateKey);
                if (!saved) return;
                const parsed = JSON.parse(saved);
                // Expire after 1 hour
                if (Date.now() - (parsed.timestamp || 0) > 3600000) { localStorage.removeItem(stateKey); return; }
                
                // If previously complete, reset
                const statuses = Object.values(parsed.batchesData || {}).map(b => b.status);
                const allDone = statuses.length > 0 && statuses.every(s => ['completed', 'failed', 'completed_with_errors'].includes(s));
                
                if (allDone) { localStorage.removeItem(stateKey); return; }

                state.localBatchIds = parsed.localBatchIds || [];
                state.batchesData = parsed.batchesData || {};
                state.uploadQueue = parsed.uploadQueue || [];
            } catch (e) { console.error("State Load Error", e); }
        };

        const getAggregatedStatus = () => {
            let totalFiles = 0;
            let processed = 0;
            let files = {};
            let batchStatuses = [];

            // Backend Batches
            state.localBatchIds.forEach(bid => {
                const data = state.batchesData[bid];
                if (data) {
                    totalFiles += (data.total_files || 0);
                    processed += (data.processed_count || 0);
                    if (data.files) Object.assign(files, data.files);
                    batchStatuses.push(data.status);
                }
            });

            // Queue
            state.uploadQueue.forEach(q => {
                q.files.forEach(f => {
                    files[`(Queue) ${f.name}`] = { status: 'queued', progress: 0 };
                    totalFiles++;
                });
                batchStatuses.push('pending');
            });

            const isComplete = state.localBatchIds.length > 0 && state.uploadQueue.length === 0 && batchStatuses.every(s => ['completed', 'failed', 'completed_with_errors'].includes(s));
            
            return { totalFiles, processed, files, isComplete };
        };

        const handleFiles = (fileList) => {
            const valid = Array.from(fileList).filter(f => ['.pdf', '.doc', '.docx', '.txt'].some(ext => f.name.toLowerCase().endsWith(ext)));
            
            // --- FIX 1: Validation Toast ---
            if (valid.length === 0 || valid.length > 10) {
                this.showToast("Invalid files. Check formats (PDF/DOC) and limit (max 10).", "error");
                return;
            }

            state.uploadQueue.push({ files: valid, tempId: Date.now() });
            renderUI(); // Update UI to show queued items
            processQueue();
        };

        const processQueue = async () => {
            if (state.uploadQueue.length === 0 || state.isUploading) return;
            
            state.isUploading = true;
            const currentBatch = state.uploadQueue[0];
            
            const formData = new FormData();
            formData.append('api_token', API_TOKEN);
            formData.append('organization_id', orgId);
            currentBatch.files.forEach(f => formData.append('files', f));

            try {
                renderUI(); // Update buttons state
                
                const res = await fetch(`${API_BASE_URL}/upload-resumes-batch/`, { method: 'POST', body: formData });
                const data = await res.json();
                if (!res.ok) throw new Error(data.detail);

                const newId = data.batch_id;

                // Init Batch Data
                const fileObj = {};
                currentBatch.files.forEach(f => fileObj[f.name] = { status: 'processing', progress: 5 });

                state.batchesData[newId] = {
                    status: 'processing',
                    total_files: currentBatch.files.length,
                    processed_count: 0,
                    files: fileObj
                };

                if (!state.localBatchIds.includes(newId)) state.localBatchIds.push(newId);
                
                // Remove from queue
                state.uploadQueue.shift();
                persistState();
                startPolling();

            } catch (e) {
                console.error(e);
                
                // --- FIX 2: Error Toast instead of Alert ---
                this.showToast(`Upload failed: ${e.message || "Unknown error"}`, "error");
                
                state.uploadQueue.shift(); // Remove failed batch
            } finally {
                state.isUploading = false;
                processQueue(); // Check next
                renderUI();
            }
        };

        const startPolling = () => {
            if (state.pollingInterval) return;
            state.pollingInterval = setInterval(async () => {
                if (state.localBatchIds.length === 0) return;
                try {
                    const ids = state.localBatchIds.join(',');
                    const res = await fetch(`${API_BASE_URL}/status/multi-batch?batch_ids=${ids}&organization_id=${orgId}`);
                    if (res.ok) {
                        const data = await res.json();
                        if (data.batches) {
                            Object.keys(data.batches).forEach(bid => {
                                state.batchesData[bid] = data.batches[bid];
                            });
                            persistState();
                            renderUI();
                            
                            const agg = getAggregatedStatus();
                            if (agg.isComplete) stopPolling();
                        }
                    }
                } catch (e) { console.error("Poll Error", e); }
            }, 2000);
        };

        const stopPolling = () => {
            if (state.pollingInterval) { clearInterval(state.pollingInterval); state.pollingInterval = null; }
        };

        // --- 5. RENDERER ---
        const renderUI = () => {
            contentWrapper.innerHTML = ""; // Clear
            const agg = getAggregatedStatus();
            const hasActiveUploads = state.localBatchIds.length > 0 || state.uploadQueue.length > 0;

            if (!hasActiveUploads) {
                // --- STATE 1: DROP ZONE ---
                const dropZone = Utils.createElem('div', ['resume-drop-zone']);
                dropZone.innerHTML = `
                    <div style="pointer-events:none; text-align:center;">
                        <p style="font-weight:600; font-size:18px; color:#333;">Drag & Drop Resumes Here</p>
                        <p style="font-size:14px; color:#888; margin-top:5px;">or click to select files</p>
                    </div>
                `;
                const meta = Utils.createElem('div', [], '', '');
                meta.innerHTML = `<p>Supported: PDF, DOC, DOCX, TXT</p><p>Max 10 files per upload.</p>`;
                Utils.applyStyles(meta, { textAlign: 'center', marginTop: '15px', fontSize: '12px', color: '#999' });

                dropZone.addEventListener('click', () => fileInput.click());
                dropZone.addEventListener('dragover', (e) => { e.preventDefault(); dropZone.classList.add('dragover'); });
                dropZone.addEventListener('dragleave', (e) => { e.preventDefault(); dropZone.classList.remove('dragover'); });
                dropZone.addEventListener('drop', (e) => { 
                    e.preventDefault(); dropZone.classList.remove('dragover');
                    if (e.dataTransfer.files) handleFiles(e.dataTransfer.files);
                });

                contentWrapper.append(dropZone, meta);
            } else {
                // --- STATE 2: PROCESSING LIST ---
                const header = Utils.createElem('div');
                Utils.applyStyles(header, { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderBottom: '1px solid #eee', paddingBottom: '10px' });
                
                let totalProgressSum = 0;
                Object.values(agg.files).forEach(f => {
                    // If completed or failed, count it as 100% done for the overall progress bar
                    if (f.status === 'completed' || f.status === 'processed_and_emailed' || f.status === 'failed') {
                        totalProgressSum += 100;
                    } else {
                        totalProgressSum += (f.progress || 0);
                    }
                });
                const percent = agg.totalFiles > 0 ? Math.floor(totalProgressSum / agg.totalFiles) : 0;
                
                header.innerHTML = `
                    <div>
                        <h4 style="font-weight:bold; margin:0; color:#333;">${agg.isComplete ? 'Processing Complete' : 'Processing...'}</h4>
                        <p style="font-size:13px; color:#666; margin:5px 0 0;">${agg.processed} / ${agg.totalFiles} processed</p>
                        ${state.uploadQueue.length > 0 ? `<p style="font-size:11px; color:#ff9f43; margin-top:4px;"><b>${state.uploadQueue.length}</b> batch(es) queued...</p>` : ''}
                    </div>
                    <div style="text-align:right;">
                        <span style="font-size:11px; color:#888; display:block;">TOTAL PROGRESS</span>
                        <span style="font-size:32px; font-weight:bold; color:#28c76f;">${agg.isComplete ? 100 : percent}%</span>
                    </div>
                `;

                const fileListContainer = Utils.createElem('div', ['resume-file-list']);
                
                Object.entries(agg.files).forEach(([filename, fileData]) => {
                    const item = Utils.createElem('div', ['resume-file-item']);
                    
                    let statusColor = 'bg-warning';
                    let statusText = `${Math.floor(fileData.progress || 0)}%`;
                    let barWidth = fileData.progress || 0;

                    if (fileData.status === 'completed' || fileData.status === 'processed_and_emailed') {
                        statusColor = 'bg-success'; statusText = 'DONE'; barWidth = 100;
                    } else if (fileData.status === 'failed') {
                        statusColor = 'bg-danger'; statusText = 'FAILED'; barWidth = 100;
                    } else if (fileData.status === 'queued') {
                        statusColor = 'bg-gray-300'; statusText = 'WAITING'; barWidth = 0;
                    }

                    item.innerHTML = `
                        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:5px;">
                            <div style="display:flex; align-items:center; overflow:hidden;">
                                <span style="font-size:13px; font-weight:500; color:#444; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:280px;" title="${filename}">${filename}</span>
                            </div>
                            <span class="${statusColor === 'bg-success' ? 'text-success' : statusColor === 'bg-danger' ? 'text-danger' : 'text-warning'}" style="font-size:11px; font-weight:bold;">${statusText}</span>
                        </div>
                        <div class="resume-progress-track">
                            <div class="resume-progress-fill ${statusColor}" style="width: ${barWidth}%;"></div>
                        </div>
                    `;
                    fileListContainer.append(item);
                });

                // Footer Actions
                const footer = Utils.createElem('div');
                Utils.applyStyles(footer, { marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '10px' });

                if (!agg.isComplete) {
                    const uploadMoreBtn = Utils.createElem('button', [], '', state.isUploading ? 'Uploading Batch...' : 'Upload More Resumes');
                    Utils.applyStyles(uploadMoreBtn, { 
                        width: '100%', padding: '10px', borderRadius: '20px', border: '2px solid #FFC107', 
                        background: 'transparent', color: '#FFC107', fontWeight: 'bold', cursor: state.isUploading ? 'not-allowed' : 'pointer',
                        opacity: state.isUploading ? '0.6' : '1'
                    });
                    if (!state.isUploading) uploadMoreBtn.onclick = () => fileInput.click();

                    const hideBtn = Utils.createElem('div', [], '', 'Hide & Process in Background');
                    Utils.applyStyles(hideBtn, { textAlign: 'center', fontSize: '12px', color: '#999', cursor: 'pointer', textDecoration: 'underline' });
                    hideBtn.onclick = () => {
                        const p = document.querySelector(".organiGramPopup.resume-upload-view");
                        if(p) p.remove();
                        document.getElementById("back-drop-overlay").style.display = "none";
                        if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                    };

                    footer.append(uploadMoreBtn, hideBtn);
                } else {
                    const finishBtn = Utils.createElem('button', [], '', 'Finish');
                    Utils.applyStyles(finishBtn, { 
                        width: '100%', padding: '12px', borderRadius: '6px', background: '#FF9F43', 
                        color: '#fff', fontWeight: 'bold', border: 'none', cursor: 'pointer' 
                    });
                    finishBtn.onclick = () => {
                        // Clear local storage and state
                        stopPolling();
                        localStorage.removeItem(stateKey);
                        // Close Modal
                        const p = document.querySelector(".organiGramPopup.resume-upload-view");
                        if(p) p.remove();
                        document.getElementById("back-drop-overlay").style.display = "none";
                        if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                        
                        // Show global Toast
                        this.showToast("Import Complete", "success");
                    };
                    footer.append(finishBtn);
                }

                contentWrapper.append(header, fileListContainer, footer);
            }
        };

        // --- 6. INIT ---
        loadState();
        if (state.localBatchIds.length > 0) startPolling();
        renderUI();

        // Bind File Input Change
        fileInput.onchange = (e) => { if(e.target.files) handleFiles(e.target.files); fileInput.value = ''; };

        // Create Popup Container
        const popupConfig = {
            headerText: "Import Resumes",
            onCloseClick: () => {
                const popup = document.querySelector(".organiGramPopup.resume-upload-view"); 
                if (popup) popup.remove();
                document.getElementById("back-drop-overlay").style.display = "none";
                if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                // If processing, polling continues in background variables, but will stop when class instance is destroyed or page refreshed unless we rely purely on LS.
                // For this implementation, closing UI hides it.
            },
            data: contentWrapper,
            displaySettings: { width: "500px", height: "auto" }, // Compact width
            footer: ""
        };

        const popup = this.createPopup(popupConfig);
        popup.classList.add("resume-upload-view");
        
        // Adjust body padding for this specific view
        const bodyPart = popup.querySelector('.OrganiGramPopupBody');
        if(bodyPart) { bodyPart.style.padding = "20px"; }

        const backdrop = document.getElementById("back-drop-overlay");
        backdrop.innerHTML = "";
        backdrop.style.display = "flex";
        backdrop.append(popup);
    }

    // New styled Toast function matching your screenshot perfectly
    showResumeSuccessToast = (count) => {
        const existing = document.getElementById('resume-success-toast');
        if (existing) existing.remove();

        const countText = count ? `${count} ` : "";

        const toast = document.createElement('div');
        toast.id = 'resume-success-toast';
        
        // Updated inner HTML
        toast.innerHTML = `
            <div style="font-weight: 700; font-size: 15px; margin-bottom: 6px;">Import Started</div>
            <div style="font-size: 13px; line-height: 1.5; font-weight: 500;">
                ${countText}Resume(s) uploaded successfully. Processing has started in the background.
            </div>
        `;

        Object.assign(toast.style, {
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            backgroundColor: '#5cb82a', // Green
            color: '#ffffff',
            padding: '16px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
            zIndex: '999999',
            fontFamily: 'inherit',
            maxWidth: '350px',
            opacity: '0',
            transform: 'translateY(20px)',
            transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
        });

        document.body.appendChild(toast);

        // Slide up
        requestAnimationFrame(() => {
            toast.style.opacity = '1';
            toast.style.transform = 'translateY(0)';
        });

        // Auto remove after 6 seconds
        setTimeout(() => {
            toast.style.opacity = '0';
            toast.style.transform = 'translateY(20px)';
            setTimeout(() => toast.remove(), 400);
        }, 6000);
    }

    toggleNotifications = async () => {
        const panel = this.notifyPanel;
        if (!panel) return;

        if (panel.style.display === 'block') {
            panel.style.display = 'none';
            return;
        }
        await this.fetchLatestNotifications();
        this.loadNotifications(panel);

    const btnRect = this.notifyBtn.getBoundingClientRect();
    const panelWidth = 300;
    const sidebarWidth = 80; // adjust to your sidebar width

    let top = btnRect.bottom + 6;
    let left = btnRect.right - panelWidth;

    // Prevent popup from going under sidebar
    if (left < sidebarWidth + 10) {
        left = sidebarWidth + 10;
    }

    panel.style.position = 'fixed';
    panel.style.top = `${top}px`;
    panel.style.left = `${left}px`;
    panel.style.right = 'auto';
    panel.style.margin = '0';
    panel.style.transform = 'none';

    panel.style.display = 'block';
};

    loadNotifications = (panel) => {
        panel.innerHTML = '';
    
        const userId = this.config().user._id; 
        const allRequests = this.config().data.graphData || [];
    
        let requests = [];
    
        if (this.can('addRole')) {
            // Admin: ONLY show requests that are waiting for approval ('pending')
            requests = allRequests.filter(r => r.status === 'pending');
        } else {
            // User: Show their own requests that are pending or rejected
            requests = allRequests.filter(r => r.requestedBy === userId && (r.status === 'pending' || r.status === 'rejected'));
        }
    
        if (requests.length) {
            requests.forEach(req => {
                const noticeBody = Utils.createElem('div');
                Utils.applyStyles(noticeBody, { 
                    padding: '12px 15px', 
                    borderBottom: '1px solid #f0f0f0',
                    cursor: 'pointer',
                    textAlign: 'left'
                });
                noticeBody.addEventListener('mouseenter', () => noticeBody.style.background = "#f9f9f9");
                noticeBody.addEventListener('mouseleave', () => noticeBody.style.background = "#fff");

                const title = Utils.createElem('div', ['notice'], '', req.title);
                Utils.applyStyles(title, { fontWeight: 'bold', fontSize: '14px', marginBottom: '4px', color: '#333' });

                const statusColor = req.status === 'rejected' ? '#dc3545' : '#ffc107';
                const status = Utils.createElem('span', [], '', `${req.status}`);
                Utils.applyStyles(status, { fontSize: '11px', padding: '2px 6px', borderRadius: '4px', background: statusColor, color: '#fff', marginLeft: 'auto' });
                
                const headerRow = Utils.createElem('div');
                Utils.applyStyles(headerRow, { display: 'flex', justifyContent: 'space-between', alignItems: 'center' });
                headerRow.append(title, status);

                const requestedUser = this.config().candidateList.find(candidate => candidate.id === req.requestedBy) || '';
                const message = Utils.createElem('div', [], '', `Requested by: ${requestedUser.name || req.requestedBy}`);
                Utils.applyStyles(message, { fontSize: '12px', color: '#666', marginTop: '5px' });
    
                noticeBody.append(headerRow, message);
    
                if (this.can('addRole') && req.status !== 'published') {
                    const actionContainer = Utils.createElem('div');
                    Utils.applyStyles(actionContainer, { display: 'flex', gap: '10px', marginTop: '10px' });

                    const approveBtn = Utils.createElem('button', [], '', '&#10003; Publish');
                    const rejectBtn = Utils.createElem('button', [], '', '&#10060; Reject');
                    
                    const btnStyle = { flex: '1', padding: '5px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' };
                    
                    Utils.applyStyles(approveBtn, { ...btnStyle, background: '#e6fffa', color: '#008000' });
                    Utils.applyStyles(rejectBtn, { ...btnStyle, background: '#fff5f5', color: '#cc0000' });
    
                    approveBtn.addEventListener('click', (e) => { e.stopPropagation(); this.handleAction(req, 'published'); });
                    rejectBtn.addEventListener('click', (e) => { e.stopPropagation(); this.handleAction(req, 'rejected'); });
    
                    actionContainer.append(approveBtn, rejectBtn);
                    noticeBody.append(actionContainer);
                }
                
                noticeBody.addEventListener('click', () => {
                   const el = document.getElementById(req._id);
                   if(el) el.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" }, !0);
                });
    
                panel.append(noticeBody);
            });
        } else {
            const emptyContainer = Utils.createElem('div');
            Utils.applyStyles(emptyContainer, { padding: '20px', textAlign: 'center' });
            
            const emptyMessage = Utils.createElem('p', [], '', 'No requests available.');
            Utils.applyStyles(emptyMessage, { color: '#888', fontSize: '14px', margin: 0 });
            
            emptyContainer.append(emptyMessage);
            panel.append(emptyContainer);
        }
    }
    
    handleAction = async (request, newStatus) => {
        try {
            // 🔥 First, send the status update to your server
            const param = {
                query: request.selfId,
                data: {analyzedBy:this.config().user._id,status:newStatus}
            }
            const response = await this.config().onNodeUpdate(param);
    
            if (!response.ok) {
                console.error('Failed to update request status');
                return;
            }
    
            const updatedData = await response.json();
            console.log('Server updated:', updatedData);
    
            const target = safeGraphData(this.config()).find(r => r._id === request._id);
        if (target) {
            target.status = newStatus;
        }

        // ---> ADD THIS: Instantly remove the box from the screen if rejected <---
        if (newStatus === 'rejected') {
            const domNode = document.querySelector(`[data-empid='${request.selfId}']`);
            if (domNode) domNode.remove();
        } 
        // ---> ADD THIS: Instantly remove the dimming effect if published <---
        else if (newStatus === 'published') {
            const domNode = document.querySelector(`[data-empid='${request.selfId}']`);
            if (domNode) {
                const label = domNode.querySelector('.emptitle');
                if (label) label.style.opacity = '1';
                
                // Note: For all action buttons to appear, a quick page refresh is naturally required, 
                // but this removes the lock visual instantly!
                const card = domNode.querySelector('.userCard');
                if (card) {
                    card.style.cursor = 'default';
                    card.classList.add('node-hover-target');
                }
            }
        }

        // 🔁 Refresh the panel and badge
        this.refreshNotifications();

        } catch (error) {
            console.error('Error updating status:', error);
        }
    }
    
    refreshNotifications = () => {
        this.updateNotificationBadge();
        if (this.notifyPanel.style.display === 'block') {
            this.loadNotifications(this.notifyPanel);
        }
    }
    
    updateNotificationBadge = () => {
        const userId = this.config().user._id;
        const allRequests = safeGraphData(this.config());
    
        let count = 0;
        if (this.can('addRole')) {
            count = allRequests.filter(r => r && r.status === 'pending').length;
        } else {
            count = allRequests.filter(r => r && r.requestedBy === userId && r.status === 'rejected').length;
        }
    
        if (count > 0) {
            this.badge.innerText = count;
            this.badge.style.display = 'block';
        } else {
            this.badge.innerText = '';
            this.badge.style.display = 'none';
        }
    }
    
    startAutoNotificationRefresh = async () => {
        try {
            await this.fetchLatestNotifications();
            this.updateNotificationBadge(); // Immediately reflect the new count on the UI
        } catch (err) {
            console.warn("Manual refresh failed:", err);
        }
    }
    
    fetchLatestNotifications = async () => {
        if (typeof this.config().onNodeFetch === 'function') {
            const query = `kvdrId=${this.config().id}`;
            const latestData = await this.config().onNodeFetch(query);
            // Replace the old graphData
            this.config().data.graphData = latestData;
    
            // Only update the panel if it's open
            if (this.notifyPanel && this.notifyPanel.style.display === 'block') {
                this.loadNotifications(this.notifyPanel);
            }
        }
    }
    createPopup(e) {
        event.preventDefault();
        event.stopPropagation();
        isViewportActive.status = false;
        
        const popupContainer = Utils.createElem("div", ["candidateListPopUp", "organiGramPopup"], "candidate-list-popup", "");
        popupContainer.addEventListener("click",()=>{event.stopPropagation()})
        
        const settings = e.displaySettings || {};

        Utils.applyStyles(popupContainer, {
            display: "flex", flexFlow: "column", margin: "auto", borderRadius: "12px", 
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)", overflow: "hidden", 
            border: "1px solid #E5E7EB", backgroundColor: "#fff",
            width: settings.width || "700px", 
            height: settings.height || 'auto',
            maxHeight: "95vh", maxWidth: "95vw"
        });
    
        const header = Utils.createElem("div", ["OrganiGramPopupHeader"], "OrganiGramPopupHeader");
        Utils.applyStyles(header, {
            padding: "12px 20px", background: "#FFF", borderBottom: "1px solid #E5E7EB",
            position: "relative", textAlign: "left", width: "100%", display: "flex",
            alignItems: "center", justifyContent: "space-between", flexShrink: "0",
            height: "60px", boxSizing: "border-box"
        });
        const headerTitle = Utils.createElem("span", ["headerTitle"], "", e.headerText);
        Utils.applyStyles(headerTitle, { fontSize: "1.15rem", fontWeight: "600", color: "#111827" });
        const headerLeft = Utils.createElem("div",["headerLeft"]);
        Utils.applyStyles(headerLeft, { display: "flex", alignItems: "center", gap: "10px" });
        headerLeft.append(headerTitle,e.headerLeftControlls?e.headerLeftControlls:'');
        const closeButton = Utils.createElem("i", ["popupShutDownBtn", "vs-icon", "notranslate", "icon-scale", "feather", "icon-x"], "popup-shut-down-btn", "");
        Utils.applyStyles(closeButton, { fontSize: "24px", color: "#6b7287", cursor: "pointer", opacity: '0.7' });
        closeButton.addEventListener("click", e.onCloseClick);
        const headerRight = Utils.createElem("div",["headerRight"]);
        Utils.applyStyles(headerRight, { display: "flex", alignItems: "center" });
        headerRight.append(e.headerRightControlls?e.headerRightControlls:'');
        headerRight.append(closeButton);
        header.append(headerLeft,headerRight);
        
        const body = Utils.createElem("div", ["OrganiGramPopupBody"], "organigram-popup-body", "");
        const bodyStyles = {
            position: "relative", padding: "10px 20px", background: "#fff", width : "100%",
            overflowX: "hidden", boxSizing: "border-box"
        };

        if (settings.height && settings.height !== 'auto') {
            bodyStyles.flex = '1';
            bodyStyles.overflowY = 'auto';
        } else {
            bodyStyles.display = 'flex';
            bodyStyles.flex = '1';
        }
        Utils.applyStyles(body, bodyStyles);
        body.append(e.data);
    
        if (e.footer && (typeof e.footer === 'object' || e.footer.trim() !== '')) {
            const footer = Utils.createElem("div", ["OrganiGramPopupFooter"], "organigram-popup-footer", "");
            Utils.applyStyles(footer, {
                padding: "12px 20px", background: "#F9FAFB", borderTop: "1px solid #E5E7EB",
                display: "flex", justifyContent: "flex-end", width: "100%",
                flexShrink: "0", boxSizing: "border-box"
            });
            footer.append(e.footer);
            popupContainer.append(header, body, footer);
        } else {
            popupContainer.append(header, body);
        }
    
        return popupContainer;
    }
    
    render() {
        const e = this.config(),
        t = this.chart;            
        return e.data && 0 != e.data.length
            ? (e.container && ("KVDR" === t ? this.createKVDR(e) : "TEAM" === t && this.createChartGroupBy(e)), this)
            : (e.container && ("KVDR" === t ? this.createKVDR(e) : "TEAM" === t && (document.querySelector("#" + e.container).innerHTML = "There is nothing to show. TO create chart provide data.")), this);
    }
}